export default {
  translation: {
    CHECK_EMAIL_TITLE: "E-Mail prüfen",
    WELCOME_BACK: "Willkommen zurück",
    ENTER_YOUR_CREDENTIALS: "Gib deine Anmeldedaten ein, um fortzufahren",
    EMAIL_FIELD: "E-Mail",
    CHECK_BUTTON: "Prüfen",
    EMAIL_IS_REQUIRED: "E-Mail ist erforderlich",
    CREATE_PASSWORD_TITLE: "Passwort erstellen",
    SUBMIT_BUTTON: "Absenden",
    LOGIN_TITLE: "Anmelden",
    PASSWORD_FIELD: "Passwort",
    PLEASE_INPUT_YOUR_PASSWORD: "Bitte gib dein Passwort ein!",
    FORGOT_PASSWORD: "Passwort vergessen?",
    REMEMBER_ME: "Angemeldet bleiben",
    LOGIN_TO_ACCOUNT_BUTTON: "In Konto anmelden",
    SIDEBAR_ORDER_HISTORY: "Bestellhistorie",
    SIDEBAR_SIGNOUT: "Abmelden",
    FOOTER_MENU_HOME: "Startseite",
    FOOTER_MENU_SHARE: "Teilen",
    FOOTER_MENU_KWIKCASH: "KwikCash",
    FOOTER_MENU_HISTORY: "Verlauf",
    SHARE_THE_PRODUCTS_TITLE: "Die Produkte teilen",
    PLEASE_SELECT_A_CAMPAIGN_TO_SHARE:
      "Wähle die Produkte aus, für die du einen Link erstellen möchtest.",
    CREATE_A_KWIKLINK_BUTTON: "Einen KwikLink erstellen",
    MANAGE_MY_KWIKLINKS: "Meine KwikLinks verwalten",
    KWIK_CASH_TITLE: "1Cash",
    KWIK_LINK_TITLE: "Die Produkte teilen",
    FIELD_PRODUCT: "Produkt",
    FIELD_QUANTITY: "Menge",
    FIELD_PRICE: "Preis",
    FIELD_KWIKCASH: "KwikCash",
    SHARE_THIS_PRODUCT_TO: "Teilen",
    COPY_LINK: "Link kopieren",
    RETURN_TO_HOME_BUTTON: "Zurück zur Startseite",
    COPY_SUCCESS: "Link erfolgreich kopiert",
    TOTAL_KWIKCASH_EARNED: "Summe des verdienten KwikCash",
    TOTAL_CASHED_OUT: "Insgesamt ausgezahlt",
    KWIKCASH_BALANCE: "1Cash-Guthaben",
    CASH_OUT_BUTTON: "Auszahlen lassen ",
    WEEK_COL_NAME: "Woche",
    KWIK_CASH_COL_NAME: "KwikCash",
    PRODUCT_INFO_TITLE: "Produktinfo",
    KWIKCASH_VALUE: "KwikCash-Wert",
    "'DESCRIPTION': 'Description',": "Beschreibung",
    IMPORTANT_INFORMATION: "Wichtige Information",
    "'INGREDIENTS': 'Ingredients',": "Inhaltsstoffe",
    "'USAGE': 'Usage',": "Verwendung",
    HANDLING_INSTRUCTIONS: "Handhabungshinweise",
    "'MANUFACTURER': 'Manufacturer',": "Hersteller",
    ADD_TO_CART_BUTTON: "Zum Warenkorb hinzufügen",
    YOUR_CART_TITLE: "Dein Warenkorb",
    "'PRODUCTS': 'Products',": "Produkte",
    REMOVE_LINK: "Entfernen",
    FIELD_TAX: "Steuer",
    FIELD_TOTAL: "Gesamt",
    PROCEED_TO_CHECKOUT_BUTTON: "Zur Kasse gehen",
    CHECKOUT_TITLE: "Kasse",
    SHIPPING_ADDRESS: "Lieferadresse",
    NEW_LINK: "Neu",
    PAYMENT_BREAKDOWN: "Zahlungsaufschlüsselung",
    SHOW_SAVE_CARDS: "Gespeicherte Karten anzeigen",
    FIELD_NAME_ON_CARD: "Name auf Karte",
    FIELD_CARD_NUMBER: "Kartennummer",
    FIELD_EXPIRY_YEAR: " Ablaufjahr",
    FIELD_EXPIRY_MONTH: " Ablaufmonat",
    FIELD_CVV: "CVC",
    SAVE_THIS_CARD: "Diese Karte speichern",
    BILLING_ADDRESS_IS_SAME_SHIPPING_ADDRESS:
      "Rechnungsadresse ist identisch mit Lieferadresse",
    BILLING_ADDRESS: "Rechnungsadresse",
    FIELD_FIRST_NAME: "Vorname",
    FIELD_LAST_NAME: "Nachname",
    FIELD_ADDRESS_LINE: "Adresszeile",
    FIELD_ZIP: "Postleitzahl",
    FIELD_PHONE: "Telefonnummer",
    FIELD_CITY: "Stadt",
    FIELD_STATE: "Bundesland",
    FIELD_COUNTRY: "Land",
    FIELD_NAME: "Name",
    PLEASE_SELECT: "auswählen",
    "'SHIPPING': 'Shipping',": "Versand",
    CONTINUE_TO_PLACE_ORDER_BUTTON: "Weiter zur Bestellung",
    SAVE_AND_USE_THIS_ADDRESS_BUTTON: "Weiter zum nächsten Schritt",
    "'CONGRATULATIONS': 'Order Complete!',": "Bestellung abgeschlossen!",
    PAYMENT_SUCCESSFUL: "Zahlung erfolgreich",
    "'STANDARD': 'Standard',": "Standard",
    ORDER_ACCEPTED: "Bestellung angenommen",
    CHECKOUT_MESSAGE1:
      "Deine Bestellung Nr. #{{orderId}} ist abgeschlossen und eine E-Mail-Bestätigung gesendet an",
    CHECKOUT_MESSAGE2:
      "Herzlichen Glückwunsch! Verdiene $2.5 mit jedem Mal, wenn jemand mit deinem Promo-Code etwas kauft! Klicke auf den Teilen-Button unten.",
    SHARE_THE_PRODUCT_BUTTON: "Kwik und Geld verdienen",
    TRACK_ORDER: "Bestellung verfolgen",
    WAVES_COL: "Waves",
    NAME_COL: "Name",
    ORDER_K_CASH_COL: "Bestellung gesamt",
    K_CASH_RATE: "K.Cash Rate",
    CASH_HISTORY_TITLE: "Cash History",
    TRANSFER_TO_BANK_TITLE: "Überweisung an Bank",
    SAVED_BANK_LINK: "Gespeicherte Bank",
    ADD_BANK_LINK: "Bank hinzufügen",
    SELECT_LINK: "Auswählen",
    PROCEED_TO_NEXT_BUTTON: "Weiter zum nächsten Schritt",
    FIELD_BANKS_COUNTRY: "Land der Bank",
    FIELD_CURRENCY_CODE: "Währungscode",
    FIELD_NAME_ON_ACCOUNT: "Kontoinhaber",
    FIELD_NAME_ON_ROUTING_NUMBER: "Bankleitzahl",
    FIELD_ACCOUNT_NUMBER: "Kontonummer",
    FIELD_ACCOUNT_TYPE: "Kontoart",
    FIELD_ACCOUNT_TYPE_OPTION_CHECKING: "Bankkonto",
    FIELD_ACCOUNT_TYPE_OPTION_SAVINGS: "Sparkonto",
    FIELD_SWIFT_CODE_BIC: "Swift-Code/BIC",
    FIELD_BANK_NAME: "Bankname",
    FIELD_BANK_NUMBER: "Bankleitzahl",
    FIELD_BRANCH_NAME: "Name der Filiale",
    FIELD_BRANCH_CODE: "Filialcode",
    SAFE_KEEP_MESSAGE:
      "Diese Informationen werden gemäß den Nutzungsbedingungen und der Datenschutzrichtlinie sicher gespeichert",
    SAVE_BANK_DETAILS_BUTTON: "Bankdaten speichern",
    AVAILABLE_BALANCE: "Verfügbarer Saldo",
    TRANSFER_TO_INTRODUCE_MESSAGE:
      "Wähle den Betrag, den du von deinem KwikCash-Konto auf das gewählte Bankkonto überweisen möchtest",
    FIELD_AMOUNT: "Betrag",
    SELECTED_BANK: "Ausgewählte Bank",
    VERIFY_BANK_CARD_INFORMATION:
      "Bitte überprüfe, ob die Bank und der KwikCash-Betrag korrekt sind. Du kannst diese Angaben danach NICHT mehr ändern.",
    TRANSACTION_COMPLETE: "Transaktion abgeschlossen!",
    TRANSACTION_CONSEQUENCE_MESSAGE:
      "Deine Transaktionsnummer ist {{amount}} und aufgegeben. Eine E-Mail-Bestätigung wurde gesendet an {{email}}",
    TRANSACTION_CONSEQUENCE_MESSAGE2:
      "Es kann bis zu 24 Stunden dauern, bis der KwikCash-Saldo aktualisiert wird.",
    RETURN_BUTTON: "Zurück zur Startseite",
    VIEW_TRANSACTION_HISTORY: "Transaktionsverlauf anzeigen",
    ORDER_TEXT: "Bestellen",
    ITEM_LIST_IS_EMPTY: "Bitte wähle ein Produkt",
    CART_MUST_NOT_BE_EMPTY: "Der Einkaufswagen darf nicht leer sein",
    CLICK_SEND_EMAIL:
      "Bitte auf den Button klicken, um eine E-Mail zur Bestätigung des ursprünglichen Passworts zu senden",
    SELECTED_DATE_GREATER_CURRENT_DATE:
      "Das ausgewählte Datum muss größer als das aktuelle Datum sein",
    CARD_NUMBER_FORMAT_IS_INCORRECT: "Das Format der Kartennummer ist falsch",
    ITEM_ADDED_TO_CART:
      "Du hast den Artikel erfolgreich in den Warenkorb gelegt",
    ORDER_NUMBER: "Bestellnummer",
    CREATION_TIME: "Datum",
    ORDER_STATUS: "Bestellstatus",
    ARE_YOU_SURE: "Bist du sicher?",
    "'CANCEL': 'Cancel',": "Abbrechen",
    "'OK': 'Ok',": "OK",
    EMAIL_IS_NOT_UNIQUE_SHARE_LINK:
      "Diese E-Mail hat bereits ein Account bei Kwik. Bitte verwende eine andere E-Mail-Adresse oder logge dich ein, um die Bestellung abzuschließen",
    EMAIL_IS_NOT_UNIQUE:
      "Diese E-Mail-Adresse wird bereits in kwik.com verwendet. Bitte verwende eine andere E-Mail-Adresse, oder gehe zu kwik.com, um dich einzuloggen und Bestellungen für dieses Produkt oder andere aufzugeben.",
    EMAIL_IS_NOT_UNIQUE_ARIIX:
      "Diese E-Mail-Adresse wurde bereits als Kunde von ARIIX registriert. Bitte verwende eine andere E-Mail-Adresse oder gehe auf kwik.com, um dich mit dieser E-Mail-Adresse anzumelden und weitere Kampagnen zu entdecken",
    REQUIRED_FIELD: "Erforderliches Feld",
    INCORRECT_EMAIL_FORMAT: "Falsches E-Mail-Format",
    "'REFUND': 'Refund',": "Erstattung",
    "'DELETE': 'Delete',": "Löschen",
    PLEASE_INPUT_TAGLINK: "Bitte Tag-Link eingeben",
    PLEASE_INPUT_CITY: "Bitte gib Stadt ein",
    UPDATE_SUCCESSFULLY: "Aktualisierung erfolgreich",
    TAGLINK_TEXT: "Tag-Link",
    EXPLORATION_TITLE: "Browsing",
    SEE_ALL_NUM_PRODUCTS: "Alle {{prodNumber}} Produkte anzeigen",
    LEARN_MORE_LINK: "Mehr erfahren",
    KWIKCASH_VALUE_MESS: "KwikCash-Wert",
    SHARE_YOUR_LINK: "TEILE DEINEN LINK",
    SEND_LINK_AND_EARN_KWIKCASH_MESS: "Link senden & KwikCash verdienen",
    PRICE_TEXT: "PREIS",
    OUT_OF_STOCK_TEXT: "Nicht verfügbar",
    ORDER_HISTORY_TEXT: "Bestellhistorie",
    ORDER_HISTORY_TIPS_NEED_PURCHASE: "Du musst erst etwas kaufen!",
    ORDER_HISTORY_EXPLORE_PRODUCTS: "Produkte entdecken",
    ORDER_HISTORY_ORDER_ON: "Bestellt am",
    ORDER_DETAIL_EXPECTED_DATE: "Erwartetes Datum",
    ORDER_DETAIL_TRACKING_ID: "Tracking ID",
    ORDER_DETAIL_BILLING_INFO_SAME_AS_SHIPPING:
      "Rechnungsinformationen identisch mit Versandinformationen",
    ORDER_DETAIL_ORIGINAL_PRICE: "Ursprünglicher Preis",
    ORDER_DETAIL_SHIPPINGN_HANDING: "Versand- und Bearbeitungsgebühren",
    KWIK_CASH_AVAILABLE_BALANCE: "Verfügbarer Saldo",
    KWIK_CASH_PENDING_BALANCE: "Ausstehender Saldo",
    KWIK_CASH_VIEW_HISTORY: "Verlauf anzeigen",
    KWIK_CASH_TRANSFER_BANK: "Überweisung an Bank",
    ACCOUNT_NUMBER_4: "Accountnummer muss mindestens 4 Zeichen enthalten",
    KWIK_CASH_PENDING: "ausstehend",
    KWIK_CASH_PAID: "bezahlt",
    KWIK_CASH_FULFILLED: "erledigt",
    CAMPAIGNS_SHARE_A_CAMPAIGN: "Eine Kampagne teilen",
    CAMPAIGNS_ACTIVE_CAMPAIGN: "Aktive Kampagne",
    CAMPAIGNS_NODATA_TEXT:
      "Um loszulegen, finde ein Produkt, das du empfehlen möchtest",
    CAMPAIGNS_EXPLORE_PRODUCTS: "Produkte entdecken",
    PROGRESS_LOADING: "Lädt…",
    LOGIN_WELCOME_BACK: "Willkommen zurück",
    LOGIN_CREDENTIALS: "Gib deine Anmeldedaten ein, um fortzufahren",
    LOGIN_LABEL_USERNAME: "Benutzername",
    LOGIN_PLACEHOLDER_USERNAME: "Benutzername oder E-Mail-Adresse",
    LOGIN_REQUIRED_USERNAME: "Benutzername ist erforderlich",
    LOGIN__LABEL_PASSWORD: "Passwort",
    LOGIN_PLACEHOLDER_PASSWORD: "Passwort",
    LOGIN_REQUIRED_PASSWORD: "Bitte gib dein Passwort ein!",
    LOGIN_REMEMBER_ME: "Angemeldet bleiben",
    LOGIN_FORGOT_PASSWORD: "Passwort vergessen?",
    LOGIN_BUTTON_LOGIN: "Anmelden",
    LOGIN_NEED_ACCOUNT: "Brauchst du ein Account?",
    LOGIN_CREATE_ACCOUNT: "Neuer Account erstellen",
    VIEWS_REGISTER_1_CREATE_ACCOUNT: "Erstelle dein Account",
    VIEWS_REGISTER_1_FIELDS_REQUIRED:
      "Bitte fülle das folgende Formular aus. Alle Felder müssen ausgefüllt werden.",
    VIEWS_REGISTER_1_LABEL_EMAIL_ADDRESS:
      "E-Mail-Adresse (darf hier noch nicht registriert sein)",
    VIEWS_REGISTER_1_PLACEHOLDER_EMAIL_ADDRESS:
      "E-Mail-Adresse (darf hier noch nicht registriert sein)",
    VIEWS_REGISTER_1_REQUIRED_EMAIL: "E-Mail-Adresse darf nicht leer sein",
    VIEWS_REGISTER_1_LABEL_FIRST_NAME: "Vorname",
    VIEWS_REGISTER_1_PLACEHOLDER_FIRST_NAME: "Vorname",
    VIEWS_REGISTER_1_REQUIRED_FIRST_NAME: "Vorname darf nicht leer sein",
    VIEWS_REGISTER_1_LABEL_LAST_NAME: "Nachname",
    VIEWS_REGISTER_1_PLACEHOLDER_LAST_NAME: "Nachname",
    VIEWS_REGISTER_1_REQUIRED_LAST_NAME: "Nachname darf nicht leer sein",
    VIEWS_REGISTER_1_LABEL_USER_NAME:
      "Benutzername (darf hier noch nicht registriert sein)",
    VIEWS_REGISTER_1_PLACEHOLDER_USER_NAME:
      "Benutzername (darf hier noch nicht registriert sein)",
    VIEWS_REGISTER_1_REQUIRED_USER_NAME: "Benutzername darf nicht leer sein",
    VIEWS_REGISTER_1_LABEL_PHONE: "Telefonnummer",
    VIEWS_REGISTER_1_PLACEHOLDER_PHONE: "Telefonnummer (einmalig)",
    VIEWS_REGISTER_1_REQUIRED_PHONE: "Telefonnummer darf nicht leer sein",
    VIEWS_REGISTER_1_BUTTON_NEXT: "Weiter",
    VIEWS_REGISTER_1_TIPS_DIGIT_SENT:
      "Ein 4-stelliger Code wurde an deine E-Mail-Adresse gesendet",
    VIEWS_REGISTER_1_TIPS_EMAIL_REGISTERED:
      "Diese E-Mail-Adresse existiert bereits bei Kwik",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_FORGOT_PASSWORD:
      "Passwort vergessen",
    VIEWS_REGISTER_1_BUTTON_EMAIL_REGISTERED_CANCEL: "Abbrechen",
    VIEWS_REGISTER_1_TIPS_USERNAME_REGISTERED:
      "Dieser Benutzername existiert bereits bei Kwik",
    VIEWS_REGISTER_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_2_VERIFICATION: "Verifizierung",
    VIEWS_REGISTER_2_TO_VERIFY: "Um zu überprüfen, ob du es bist",
    VIEWS_REGISTER_2_TIPS_ENTER:
      "Gib den 4-stelligen Code ein, der dir zugeschickt wurde an",
    VIEWS_REGISTER_2_BUTTON_NEXT: "Weiter",
    VIEWS_REGISTER_2_NEED_CODE: "Hast du noch keinen Code?",
    VIEWS_REGISTER_2_LINK_RESEND: "Erneut senden",
    VIEWS_REGISTER_2_LOADING: "Lädt…",
    VIEWS_REGISTER_3_TITLE_PASSWORD_CREATE: "Neues Passwort erstellen",
    VIEWS_REGISTER_3_TITLE_ENTER_NEW_PASSWORD:
      "Neues sicheres Passwort eingeben",
    VIEWS_REGISTER_3_CREATE_LABEL: "Passwort erstellen",
    VIEWS_REGISTER_3_CREATE_PLACEHOLDER: "Passwort erstellen",
    VIEWS_REGISTER_3_CREATE_REQUIRED: "Bitte gib dein Passwort ein!",
    VIEWS_REGISTER_3_CONFIRM_LABEL: "Passwort erstellen",
    VIEWS_REGISTER_3_CONFIRM_PLACEHOLDER: "Passwort erstellen",
    VIEWS_REGISTER_3_CONFIRM_REQUIRED: "Bitte gib dein Passwort ein!",
    VIEWS_REGISTER_3_TOAST_PATTERN:
      "Das Passwort muss mindestens acht Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Ziffer enthalten.",
    VIEWS_REGISTER_3_TIPS_MATCH: "Die Passwörter stimmen nicht überein",
    VIEWS_REGISTER_3_BUTTON_NEXT: "Weiter",
    VIEWS_REGISTER_3_BUTTON_BACK: "Zurück",
    VIEWS_REGISTER_3_LOADING: "Lädt…",
    VIEWS_REGISTER_4_TITLE: "Profilbild hochladen",
    VIEWS_REGISTER_4_MESSAGE:
      "Das wird dich berühmt machen und deinem Account mehr Vertrauen verleihen.",
    VIEWS_REGISTER_4_BUTTON_NEXT: "Weiter zum nächsten Schritt",
    VIEWS_REGISTER_4_TIPS_NOT_NOW: "Nicht jetzt?",
    VIEWS_REGISTER_4_LINK_DO_LATER: "Ich möchte es später machen",
    VIEWS_REGISTER_5_TITLE: "Erstelle deinen Account",
    VIEWS_REGISTER_5_MESSAGE: "Bitte gib die folgenden Informationen an",
    VIEWS_REGISTER_5_TIPS_YOUR_BIO: "Deine Bio",
    VIEWS_REGISTER_5_PLACEHOLDER_TYPING: "Beginne hier zu tippen...",
    VIEWS_REGISTER_5_BUTTON_NEXT: "Abschicken und weiter zum nächsten Schritt",
    VIEWS_REGISTER_5_TIPS_NOT_NOW: "Nicht jetzt?",
    VIEWS_REGISTER_5_LINK_DO_LATER: "Ich möchte es später machen",
    VIEWS_REGISTER_6_BUTTON_BACK: "Zurück",
    VIEWS_REGISTER_6_TITLE: "Gib deine persönlichen Daten an",
    VIEWS_REGISTER_6_MESSAGE: "Bitte gib uns ein paar Infos zu dir",
    VIEWS_REGISTER_6_ADDRESS_LINE_1: "Adresszeile 1",
    VIEWS_REGISTER_6_ADDRESS_LINE_2: "Adresszeile 2",
    VIEWS_REGISTER_6_POSTAL_CODE: "Postleitzahl",
    VIEWS_REGISTER_6_BUTTON_NEXT: "Weiter",
    VIEWS_REGISTER_6_COUNTRY_USA: "USA",
    VIEWS_REGISTER_6_COUNTRY_CHA: "China",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL_REGISTERED:
      "Dieser Benutzername existiert bereits bei Kwikclick.",
    VIEWS_REGISTER_SSO_1_BUTTON_OK: "Ok",
    VIEWS_REGISTER_SSO_1_TIPS_SIGNUP: "Registrieren",
    VIEWS_REGISTER_SSO_1_TITLE: "Erstelle dein Account",
    VIEWS_REGISTER_SSO_1_MESSAGE:
      "Herzlichen Glückwunsch! Deine NewAge ID und dein Passwort wurden verifiziert. Bitte gib folgende Informationen an",
    VIEWS_REGISTER_SSO_1_TIPS_EMAIL:
      "E-Mail-Adresse (Wir überprüfen ob deine E-Mail-Adresse bereits existiert)",
    VIEWS_REGISTER_SSO_1_TIPS_FIRST: "Vorname",
    VIEWS_REGISTER_SSO_1_REQUIRED_FIRST: "Vorname darf nicht leer sein",
    VIEWS_REGISTER_SSO_1_TIPS_LAST: "Nachname",
    VIEWS_REGISTER_SSO_1_REQUIRED_LAST: "Nachname darf nicht leer sein",
    VIEWS_REGISTER_SSO_1_TIPS_USERNAME:
      "Benutzername (Wir überprüfen ob dein Benutzername bereits existiert)",
    VIEWS_REGISTER_SSO_1_REQUIRED_USERNAME: "Benutzername darf nicht leer sein",
    VIEWS_REGISTER_SSO_1_TIPS_PHONE: "Telefonnummer",
    VIEWS_REGISTER_SSO_1_REQUIRED_PHONE: "Telefonnummer darf nicht leer sein",
    VIEWS_REGISTER_SSO_1_BUTTON_NEXT: "Weiter",
    CAMPAIGNS_BUTTON_OK: "Ok",
    CAMPAIGNS_LOADING: "Lädt…",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_1:
      "Sorry, du kannst das Produkt nicht teilen",
    CAMPAIGNS_CANNOT_SHARE_MESSAGE_2:
      "Bitte kaufe jetzt dieses Produkt, oder erfülle die Kriterien",
    CAMPAIGNS_TITLE_STATS: "Statistiken",
    CAMPAIGNS_TIPS_CASH_EARNED: "Insgesamt verdientes KwikCash diese Woche",
    CAMPAIGNS_TIPS_TOTAL_KWIKCASH_EARNED: "Insgesamt verdientes KwikCash",
    CAMPAIGNS_TIPS_GENERATE_SALES: "Erzielte Verkäufe",
    CAMPAIGNS_TITLE_CAMPAIGNS: "Kampagnen",
    CAMPAIGNS_TIPS_VIEW_DETAIL: "(Klicke, um Details zu sehen)",
    CAMPAIGNS_TITLE_ALL_STATS: "Alle Kampagnen-Statistiken",
    CAMPAIGNS_TIPS_KWIK_INFO: "Kwik Info",
    CAMPAIGNS_TITLE_TOTAL_BUYERS: "Käufer insgesamt",
    CAMPAIGNS_BUTTON_QR_CODE: "QR-Code",
    CAMPAIGNS_BUTTON_COPY_LINK: "Link kopieren",
    CAMPAIGNS_HEADER_TITLE_CAMPAIGNS_STATS: "Kampagnen-Statistiken",
    CAMPAIGNS_TITLE_TOTAL_CUSTOMERS: "Kunden insgesamt",
    CAMPAIGNS_BUTTON_VIEW_DATA: "Daten anzeigen",
    CAMPAIGNS_TITLE_ACTIVE_CAMPAIGN: "Aktive Kampagne",
    CAMPAIGNS_TITLE_SHARE_CAMPAIGN: "Kampagne teilen",
    CAMPAIGNS_TITLE_CAMPAIGN_DETAILS: "Kampagnen-Details",
    CAMPAIGNS_TITLE_WAVES: "Waves",
    CAMPAIGNS_TIPS_KWIKCASH_EARNED: "Verdientes 1Cash",
    CAMPAIGNS_TITLE_BUYER: "Käufer",
    CAMPAIGNS_COLOR_MEANS_GREEN: "Grün bedeutet, dass KwikCash verfügbar ist",
    CAMPAIGNS_COLOR_MEANS_YELLOW: "Gelb bedeutet, dass KwikCash ausstehend ist",
    CAMPAIGNS_COLOR_MEANS_RED:
      "Rot bedeutet, dass KwikCash nicht lieferbar ist",
    CAMPAIGNS_TITLE_KWIK_INFO: "Kwik Info",
    SHARE_LINK_IMAGE_5M: "Bilder dürfen nicht größer als 5 Megabyte sein",
    SHARE_LINK_REFERRED_BY: "Empfohlen von",
    SHARE_LINK_DESCRIPTION: "Beschreibung",
    SHARE_LINK_ADD_TO_CART: "In den Warenkorb",
    SHARE_LINK_PRODUCTS_DESC: "Produktbeschreibung",
    SHARE_LINK_LEAVE_MESSAGE: "Eine Bewertung schreiben",
    SHARE_LINK_LEARN_MORE: "Mehr erfahren",
    SHARE_LINK_REVIEWS: "Bewertungen",
    SHARE_LINK_RATE_THE_PRODUCT: "Bewerte das Produkt",
    SHARE_LINK_SHARE_YOUR_THOUGHTS_ON_THE_PRODUCT:
      "Teile deine Meinung über das Produkt mit",
    SHARE_LINK_ADD_AN_IMAGE_TO_YOUR_REVIEW:
      "Füge ein Bild zu deiner Bewertung hinzu",
    SHARE_LINK_DRAG_AND_DROP: "DRAG AND DROP",
    SHARE_LINK_YOUR_FILES_TO_ASSETS_OR_BROWSE:
      "deiner Dateien zu den Assets, oder <span>browse</span>",
    SHARE_LINK_LEAVE_REVIEW: "Bewertung schreiben",
    SHARE_LINK_MY_CART: "Mein Warenkorb",
    SHARE_LINK_CHECKOUT: "ZUR KASSE",
    SHARE_LINK_CHECKOUT2: "Zur Kasse gehen",
    SHARE_LINK_DISCOUNT: "Rabatt",
    SHARE_LINK_WILL_BE_CALCULATED_AT_CHECKOUT: "Wird an der Kasse berechnet",
    SHARE_LINK_RETURNING_CUSTOMER: "Wiederkehrender Kunde",
    SHARE_LINK_SIGN_IN_FOR_FASTER_CHECKOUT:
      "Anmelden für schnellere Kaufabwicklung",
    SHARE_LINK_USERNAME_OR_EMAIL: "Benutzername oder E-Mail-Adresse",
    SHARE_LINK_USERNAME_IS_REQUIRED: "Benutzername ist erforderlich",
    SHARE_LINK_PASSWORD: "Passwort",
    SHARE_LINK_OR: "ODER ",
    SHARE_LINK_NEW_CUSTOMER: "Neuer Kunde",
    SHARE_LINK_DONT_HAVE_A_MESSAGE:
      "Noch kein Kwik-Account? Das ist der erste Schritt! Schließe die Transaktion ab, um dein Account zu erstellen!",
    SHARE_LINK_ADD_NEW_ADDRESS: "Neue Adresse hinzufügen",
    SHARE_LINK_TO_MAKE_SURE_MESSAGE:
      "Um sicherzustellen, dass die Verbindung funktioniert, vergewissere dich bitte, dass das die E-Mail-Adresse ist, die du für dein Kwik-Account verwendet hast oder verwenden wirst.",
    SHARE_LINK_ADDRESS: "Adresse",
    SHARE_LINK_APARTMENT_SUITE_ETC: "Adresszusatz (optional)",
    SHARE_LINK_APT_SUITE_ETC: "Adresszusatz (optional)",
    SHARE_LINK_CITY: "Stadt",
    SHARE_LINK_COUNTRY: "Land",
    SHARE_LINK_STATE: "Bundesland",
    SHARE_LINK_ZIP_CODE: "Postleitzahl",
    SHARE_LINK_PHONE: "Telefonnummer",
    SHARE_LINK_CANCEL: "Abbrechen",
    SHARE_LINK_PRODUCTS: "Produkte",
    SHARE_LINK_SHIPPING: "Versand",
    SHARE_LINK_TOTAL: "Gesamt",
    SHARE_LINK_ENTER_YOUR_CARD_DETAILS: "Gib deine Karteninformationen ein",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NAME:
      "Bitte gib den Namen auf der Karte ein!",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_NUMBER:
      "Bitte gib deine Kartennummer ein!",
    SHARE_LINK_EXPIRATION_DATE: "Gültigkeitsdatum",
    SHARE_LINK_EXPIRATION_YEAR: "Gültigkeitsjahr",
    SHARE_LINK_PLEASE_INPUT_YOUR_CARD_CVV: "Gib den CVV der Karte ein!",
    SHARE_LINK_BILLING_ADDRESS_IS_THE_SAME_MESSAGE:
      "Rechnungsadresse ist identisch mit Lieferadresse",
    SHARE_LINK_ENTER_YOUR_BILLING_ADDRESS: "Gib deine Rechnungsadresse ein",
    SHARE_LINK_SAVE_THIS_CARD: "Diese Karte speichern",
    SHARE_LINK_COUNTINUE: "Weiter",
    SHARE_LINK_SHIPPING_ADDRESS: "Lieferadresse",
    SHARE_LINK_EDIT: "Bearbeiten",
    SHARE_LINK_SHIPPING_AND_HANDLING: "Versand- und Bearbeitungsgebühren",
    SHARE_LINK_CHANGE: "Ändern",
    SHARE_LINK_PRICE_COUNT_ITEM: "Preis ({{count}} Artikel)",
    SHARE_LINK_PRICE_TAX: "Steuer",
    SHARE_LINK_PRICE: "PREIS",
    SHARE_LINK_PLACE_YOUR_ORDER: "Deine Bestellung aufgeben",
    SHARE_LINK_PAYMENT_SUCCESSFUL: "Zahlung erfolgt!",
    SHARE_LINK_CONGRATS_MESSAGE:
      "Herzlichen Glückwunsch! Verdiene KwikCash mit jedem Mal, wenn jemand mit deinem Promo-Code etwas kauft! Klicke auf den Teilen-Button unten.",
    SHARE_LINK_SHARE_YOUR_LINK: "TEILEN DEINEN LINK",
    SHARE_LINK_CREATE_MY_ACCOUNT: "Meinen Account erstellen",
    SHARE_LINK_DOWNLOAD_IMAGE: "Bild herunterladen",
    SHARE_LINK_COPY_LINK: "Link kopieren",
    SHARE_LINK_ORDER_ACCEPTED: "Bestellung angenommen",
    SHARE_LINK_SELECT_THE_PRODUCTS_YOU_WOULD_LIKE:
      "Wähle die Produkte, die du möchtest",
    SHARE_LINK_PRODUCT_NOT_AVAILABLE:
      "    Das von dir gewählte Produkt ist in dem ausgewählten Land nicht verfügbar.",
    SHARE_LINK_OUT_OF_STOCK: "Nicht verfügbar",
    SHARE_LINK_PRICE2: "Preis",
    SHARE_LINK_ADD: "Hinzufügen",
    SHARE_LINK_CONTINUE_TO_CHECKOUT: "Weiter zur Kasse",
    SHARE_LINK_SO_YOURE_ALREADY_MESSAGE:
      "Du bist also bereits Mitglied in {{totalAlreadyJoin}} der von dir ausgewählten {{totalCpgn}} Kampagnen. Wenn du den Kauf der Produkte abschließt, wirst du an den {{referName}} ausgewählten {{totalCanJoin}} Kampagnen teilnehmen",
    SHARE_LINK_SINCE_YOU_ALREADY_MESSAGE:
      "Da du bereits mit {{originalName}} an dieser Kampagne teilgenommen hast, erhalten sie die Anerkennung.",
    SHARE_LINK_SINCE_YOU_HAVE_ALREADY_MESSAGE:
      "Du bist bereits allen {{totalAlreadyJoin}} Kampagnen beigetreten. Wenn du den Kauf der Produkte abschließt, erhalten sie die Gutschrift.",
    SHARE_LINK_CLICK_TO_SEE_DETAILS: "Klicke, um Details zu sehen",
    SHARE_LINK_REFERRER: "Werber",
    SHARE_LINK_CAMPAIGN: "Kampagne",
    SHARE_LINK_CAMPAIGNS_TYPE: "Kampagnentyp",
    SHARE_LINK_DATE_JOINED: "Beitrittsdatum",
    SHARE_LINK_SINGLE_CAMPAIGN: "Einzelne Kampagne",
    SHARE_LINK_ULTI_PRODUCT: "ulti – Produkt",
    SHARE_LINK_KWIKCASH: "1Cash",
    SHARE_LINK_QUANTITY: "Menge",
    SHARE_LINK_SUBTOTAL: "Zwischensumme",
    SHARE_LINK_PLEASE_INPUT_YOUR_FIRSTNAME: "Bitte gib deinen Vornamen ein!",
    SHARE_LINK_PLEASE_INPUT_YOUR_LASTNAME: "Bitte gib deinen Nachnamen ein!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ZIP: "Bitte gib deine Postleitzahl ein!",
    SHARE_LINK_PLEASE_INPUT_YOUR_STATE: "Bitte gib dein Bundesland ein!",
    SHARE_LINK_PLEASE_INPUT_YOUR_CITY: "Bitte gib deine Stadt ein!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_LINE1:
      "Bitte gib deine Adresszeile 1 ein!",
    SHARE_LINK_PLEASE_SELECT_YOUR_STATE: "Bitte wähle dein Bundesland!",
    SHARE_LINK_PLEASE_INPUT_YOUR_ADDRESS_PHONE:
      "Bitte gib deine Adresse und deine Telefonnummer ein!",
    SHARE_LINK_EXISTING_KWIK_USER_LOGIN_HERE:
      "Bestehender Kwik User? Hier anmelden",
    SHARE_LINK_STEP_ADDRESS: "Adresse",
    SHARE_LINK_STEP_PAYMENTS: "Zahlungen",
    SHARE_LINK_STEP_SUMMARY: "Zusammenfassung",
    SHARE_LINK_BUTTON_LOGIN: "Anmelden",
    SHARE_LINK_BUTTON_CONTINUE: "Weiter",
    SHOPPING_NEW_AGE_PV: "NewAge PV",
    SHOPPING_PRODUCT_DESCRIPTION: "Produktbeschreibung",
    SHOPPING_REVIEWS: "Bewertungen",
    SHOPPING_LEAVE_REVIEW: "Eine Bewertung schreiben",
    SHOPPING_RATE_PRODUCT: "Bewerte das Produkt",
    SHOPPING_SHARE_THOUGHTS_PRODUCT: "Teile deine Meinung über das Produkt mit",
    SHOPPING_PLACEHOLDER_TYPING: "Beginne zu tippen",
    SHOPPING_PLEASE_TYPING: "Bitte gib Tippen Beginnen ein",
    SHOPPING_TIPS_ADD_IMAGE: "Füge ein Bild zu deiner Bewertung hinzu",
    SHOPPING_BUTTON_REMOVE: "Entfernen",
    SHOPPING_TIPS_IMAGE_UPLOAD_1: "deine Dateien zu Assets, oder ",
    SHOPPING_TIPS_IMAGE_UPLOAD_2: "suche durch",
    SHOPPING_BUTTON_LEAVE_REVIEW: "Eine Bewertung schreiben",
    SHOPPING_BUTTON_DRAG_DROP: "DRAG AND DROP",
    SHOPPING_BUTTON_CHECKOUT: "Zur Kasse gehen",
    SHOPPING_SHARE_LINK_TEXT_PRICE: "PREIS",
    SHOPPING_SHARE_LINK_TEXT_NEW_AGE_PV: "NewAge PV",
    SHOPPING_BUTTON_QR_CODE: "QR-Code",
    SHOPPING_BUTTON_COPY_LINK: "Link kopieren",
    SHOPPING_BUTTON_QUICK_SHARE: "Schnell Teilen",
    SHOPPING_BUTTON_DOWNLOAD_IMAGE: "Bild herunterladen",
    SHOPPING_BUTTON_X: "X",
    SHOPPING_BUTTON_CANCEL: "Abbrechen",
    SHOPPING_CART_TEXT_PRICE: "Preis",
    SHOPPING_CART_TEXT_KWIKASH: "KwikCash",
    SHOPPING_CART_TEXT_SHIP_FROM: "Versand aus",
    SHOPPING_CART_TEXT_SUBTOTAL: "Zwischensumme",
    SHOPPING_BUTTON_CHANGE: "Ändern",
    SHOPPING_TITLE_COUPON: "Gutschein",
    SHOPPING_OPTION_SELECT_COUPON: "Wähle einen für dich verfügbaren Gutschein",
    SHOPPING_REQUIRED_INPUT_CARD_NAME: "Bitte gib den Namen auf der Karte ein!",
    SHOPPING_REQUIRED_INPUT_CARD_NUMBER: "Bitte gib deine Kartennummer ein!",
    SHOPPING_TEXT_EXPIRATION_DATE: "Gültigkeitsdatum",
    SHOPPING_TEXT_EXPIRATION_YEAR: "Gültigkeitsjahr",
    SHOPPING_REQUIRED_INPUT_CARD_CVV: "Gib den CVV der Karte ein!",
    SHOPPING_REQUIRED_INPUT_FIRST_NAME: "Bitte gib deinen Vornamen ein!",
    SHOPPING_REQUIRED_INPUT_LAST_NAME: "Bitte gib deinen Nachnamen ein!",
    SHOPPING_REQUIRED_INPUT_ADDRESS_1: "Bitte gib deine Adresszeile 1 ein!",
    SHOPPING_REQUIRED_INPUT_STATE: "Bitte wähle dein Bundesland!",
    SHOPPING_REQUIRED_INPUT_CITY: "Bitte gib deine Stadt ein!",
    SHOPPING_REQUIRED_INPUT_ZIP: "Bitte gib deine Postleitzahl ein!",
    SHOPPING_REQUIRED_INPUT_PHONE: "Bitte gib deine Telefonnummer ein!",
    SHOPPING_TEXT_SHIPPING_HANDING: "Versand- und Bearbeitungsgebühren",
    SHOPPING_TEXT_SHOW_SAVED_CARD: "Gespeicherte Karten anzeigen",
    SHOPPING_SUCCESS_TEXT_CONGRATS:
      "Herzlichen Glückwunsch! Verdiene KwikCash mit jedem Mal, wenn jemand mit deinem Promo-Code etwas kauft! Klicke auf den Teilen-Button unten.",
    SHOPPING_PAYMENT_TEXT_PAYMENT_SUCCESSFUL: "Zahlung erfolgreich!",
    SHOPPING_PAYMENT_TEXT_SHARE_LINK: "TEILE DEINEN LINK",
    SHOPPING_PAYMENT_TEXT_ORDER_ACCEPTED: "Bestellung angenommen",
    SHOPPING_PASSWORD_TITLE_FORGOT: "Passwort vergessen",
    SHOPPING_PASSWORD_TEXT_VERIFY: "Um zu überprüfen, ob du es bist",
    SHOPPING_PASSWORD_TEXT_ENTER_EMAIL:
      "Gib hier unten die registrierte E-Mail-Adresse ein, um eine Anleitung zum Zurücksetzen des Passworts zu erhalten",
    SHOPPING_PASSWORD_LABEL_EMAIL: "E-Mail-Adresse",
    SHOPPING_PASSWORD_PLACEHOLDER_EMAIL: "E-Mail-Adresse",
    SHOPPING_PASSWORD_REQUIRED_EMAIL: "E-Mail ist erforderlich",
    SHOPPING_PASSWORD_BUTTON_RESET: "Passwort zurücksetzen",
    SHOPPING_PASSWORD_SEND_EMAIL: "Eine E-Mail wurde gesendet!",
    SHOPPING_PASSWORD_SEND_CHECK_INBOX:
      "Bitte überprüfe deinen Posteingang und klicke auf den Link, um dein Passwort zurückzusetzen.",
    SHOPPING_PASSWORD_SEND_BACK_TO_LOGIN: "Zurück zum Login",
    SHOPPING_PASSWORD_SEND_TEXT_DONT_RECEIVE:
      "Hast du den Link nicht erhalten?",
    SHOPPING_PASSWORD_SEND_BUTTON_RESEND: "Erneut senden",
    SHOPPING_PASSWORD_SEND_BUTTON_BACK: "Zurück",
    HEADER_PHOTO_EDIT_IMAGE: "Bild bearbeiten",
    HEADER_PHOTO_OK: "OK",
    HEADER_PHOTO_CANCEL: "Abbrechen",
    HEADER_HOME: "Startseite",
    HEADER_1CASH: "1Cash",
    HEADER_CAMPAIGNS: "Kampagnen",
    HEADER_ORDER_HISTORY: "Bestellhistorie",
    HEADER_SIGN_OUT: "Abmelden",
    HEADER_LOGOUT: "Ausloggen",
    LOGIN_HEADER_TITLE_REPORT_ISSUE: "Ein Problem melden",
    LOGIN_HEADER_LABEL_SUBJECT: "Betreff",
    LOGIN_HEADER_PLACEHOLDER_SUBJECT:
      "Gib hier dein Anliegen zusammengefasst ein",
    LOGIN_HEADER_LABEL_DESCRIPTION: "Beschreibung",
    LOGIN_HEADER_PLACEHOLDER_DESCRIPTION:
      "Gib hier dein Anliegen detailliert ein",
    WELINK_ADDRESS_WE_RE_CURRENTLY:
      "We’re Currently Focused On expanding in the following Metro areas:  Las Vegas, NV; Pheonix, AZ, TUSCON, AZ. WE’LL BE BRINGING OUR WIRELESS FIBER TO EVEN MORE MARKETS IN 2022",
    WELINK_ADDRESS_FIRST_NAME: "Vorname",
    WELINK_ADDRESS_LAST_NAME: "Nachname",
    WELINK_ADDRESS_COMPANY_NAME: "Name des Unternehmens",
    WELINK_ADDRESS_EMAIL: "E-Mail",
    WELINK_ADDRESS_ADDRESS: "Adresse",
    WELINK_ADDRESS_APT_SUITE_ETC_OPTIONAL: "Adresszusatz (optional)",
    WELINK_ADDRESS_CITY: "Stadt",
    WELINK_ADDRESS_COUNTRY: "Land",
    WELINK_ADDRESS_STATE: "Bundesland",
    WELINK_ADDRESS_ZIP_CODE: "Postleitzahl",
    WELINK_ADDRESS_PHONE: "Telefonnummer",
    WELINK_ADDRESS_HOW_MANY_W2_EMPLOYEES_DO_YOU_HAVE:
      "How many w2 Employees do you have?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_BEEN:
      "Has your business been impacted or changed by COVID?",
    WELINK_ADDRESS_HAS_YOUR_BUSINESS_HAD:
      'Has your business had a supply chain "disruption" to your business?',
    WELINK_ADDRESS_PROCEED_TO_NEXT: "Weiter zum nächsten Schritt",
    FIELD_PROVINCE: "Bundesland",
    FIELD_TOWN_CITY: "Stadt",
    FIELD_POSTAL_CODE: "Postleitzahl",
    SSONEWAGE_IF_YOU_ALREADY_SET_UP_MESSAGE:
      'Wenn du dein Kwik-Konto bereits mit "Mit NewAge anmelden" eingerichtet hast, kannst du dich auch mit deiner Kwik-E-Mail und deinem Passwort in der Kwik-App anmelden über <a href="/">hier klickst</a>.',
    SSONEWAGE_SIGN_IN_WITH_NEWAGE: "Mit NewAge anmelden",
    SSONEWAGE_LINK_AN_EXISTING_ACCOUNT_WITH_NEWAGE_ACCOUNT:
      "Verknüpfe ein bestehender Account mit NewAge Account",
    SSONEWAGE_WELCOME_BACK: "Willkommen zurück!",
    SSONEWAGE_ENTER_YOUR_CREDENTIALS_TO_CONTINUE:
      "Gib deine Anmeldedaten ein, um fortzufahren",
    SSONEWAGE_EMAIL: "E-Mail",
    SSONEWAGE_USERNAME: "Benutzername",
    SSONEWAGE_USERNAME_IS_REQUIRED: "Benutzername ist erforderlich",
    SSONEWAGE_PASSWORD: "Passwort",
    SSONEWAGE_NEXT: "Weiter",
    SSONEWAGE_PLEASE_VERIFY_KWIK_ACCOUNT_INFOMATION:
      "Bitte überprüfe die Kwik-Accountinformationen",
    SSONEWAGE_KWIK_ACCOUNT_EMAIL: "Kwik-Account E-Mail",
    SSONEWAGE_FIRST_NAME: "Vorname",
    SSONEWAGE_LAST_NAME: "Nachname",
    SSONEWAGE_PHONE_NUMBER: "Telefonnummer",
    SSONEWAGE_NEWAGE_ID: "NewAge ID",
    SSONEWAGE_YOUR_KWIK_ACCOUNT_HAS_ALREADY_MESSAGE:
      "Dein Kwik-Account wurde bereits mit dieser NewAge ID verknüpft. Wenn das deine korrekte NewAge ID ist, sind keine weiteren Maßnahmen erforderlich.",
    SSONEWAGE_IF_THIS_IS_NOT_MESSAGE:
      "Wenn das nicht deine korrekte NewAge ID ist, kannst du sie aktualisieren.",
    SSONEWAGE_UPDATE: "Aktualisieren",
    SSONEWAGE_IS_THIS_YOU: "Bist du das?",
    SSONEWAGE_YES_AND_PROCEED_TO_NEXT_STEP:
      "Ja und weiter zum nächsten Schritt",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_MESSAGE:
      "Diese NewAge ID {{newAgeID}} ist bereits mit einem anderen Kwik-Account verknüpft . Bitte überprüfe deine NewAge ID und versuche es später. Danke!",
    SSONEWAGE_OK: "OK",
    SSONEWAGE_CONDRATULATIONS_YOUR_NEWAGE_ID_MESSAGE:
      "Herzlichen Glückwunsch! Deine NewAge ID und dein Passwort wurden verifiziert. Möchtest du diese NewAge ID mit deinem Kwik-Account verknüpfen?",
    SSONEWAGE_YES: "Ja",
    SSONEWAGE_NO: "Nein",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_MESSAGE:
      "Dieser Benutzername existiert bereits bei Kwik.",
    SSONEWAGE_OUR_RECORDS_SHOW_THAT_THIS_EMAIL_MESSAGE:
      "Diese E-Mail-Adresse existiert bereits bei Kwik.",
    SSONEWAGE_FORGOT_PASSWORD: "Passwort vergessen",
    FIELD_DUTY: "Pflicht",
    SHARE_LINK_BTGIN_QUALIFYING: "Qualifizierung beginnen",
    "'KWIKCASH': 'KwikCash',": "KwikCash",
    "'CONNECTED': 'Connected!',": "Verbunden!",
    ADD_BANK_ACCOUNT: "Ein Bankkonto hinzufügen",
    CONNECTED_YOUR_ACCOUNT: "Wir haben dein Konto verbunden mit",
    KWIKCASH_SUCCESSFULLY_ADDED_1: "Du hast es erfolgreich hinzugefügt",
    KWIKCASH_SUCCESSFULLY_ADDED_2:
      "zu deinem Account! Jetzt müssen wir bestätigen, dass du Eigentümer dieses Kontos bist. Hier erfährst du, wie wir das machen",
    KWIKCASH_PROCESSING_STEP_1:
      "In den nächsten 1 - 3 Werktagen werden wir zwei kleine Einzahlungen auf dein Bankkonto vornehmen. Die Beträge werden nicht mehr als $1 USD betragen",
    KWIKCASH_PROCESSING_STEP_2:
      "Sobald du diese Einzahlungen auf deinem Bankkonto siehst, gib diese Beträge auf der nächsten Seite ein",
    KWIKCASH_PROCESSING_STEP_3: "Fang an abzuräumen!",
    "'COMPLETE': 'Complete',": "Vervollständigen",
    ENTER_AMOUNT: "Betrag eingeben",
    TRANSFER_AMOUNT_DESC:
      "Wähle den Geldbetrag, den du von deinem KwikCash auf das ausgewählte Bankkonto überweisen möchtest",
    KWIKCASH_SELECT_BANK_ACCOUNT: "Bankkonto auswählen",
    KWIKCASH_AMOUNT_TO_TRANSFER: "Zu überweisender Betrag",
    KWIKCASH_ADD_ACCOUNT: "Konto hinzufügen",
    KWIKCASH_PLEASE_CONFIRM: "Bitte bestätigen",
    KWIKCASH_TRANSFER_AMOUNT: "KwikCash-Überweisungsbetrag",
    KWIKCASH_TO: "zu",
    KWIKCASH_PROCESSING_FEE: "Bearbeitungsgebühr:",
    KWIKCASH_NET_CASHOUT: "Netto-Auszahlung:",
    KWIKCASH_TRANSFER: "Überweisung",
    KWIKCASH_CONFIRM: "Bestätigen",
    KWIKCASH_CANCEL: "Abbrechen",
    KWIKCASH_AMOUNT: "Betrag",
    KWIKCASH_BANK_NAME: "Bankname",
    KWIKCASH_NEXT: "Weiter",
    KWIKCASH_TRANSFER_SUCCESS_1: "Deine Transaktionsnummer lautet",
    KWIKCASH_TRANSFER_SUCCESS_2:
      "und wurde aufgegeben. Eine E-Mail-Bestätigung wurde gesendet an",
    KWIKCASH_TRANSFER_SUCCESS_3:
      "Es kann bis zu 24 Stunden dauern, bis das KwikCash-Saldo aktualisiert wird",
    KWIKCASH_BACK_KWIKCASH: "Zurück zu 1Cash",
    KWIKCASH_SUCCESS_HEADER: "Erfolgreich!",
    KWIKCASH_PHONE_HEADER: "Telefonische Verifizierung",
    KWIKCASH_PHONE_1: "Bitte bestätige, dass du es bist",
    KWIKCASH_PHONE_2:
      "Gib den 4-stelligen Code ein, der dir zugeschickt wurde an",
    KWIKCASH_DIDNT_GET_CODE: "Hast du den Code nicht erhalten?",
    KWIKCASH_RESEND_IT: "Erneut senden",
    KWIKCASH_THE_BANK_NAME: "Das Bankkonto",
    KWIKCASH_BANK_LINKED: "Wurde mit deinem Account verknüpft",
    KWIKCASH_ENTER_DEPOSIT_DESC:
      "Gib zwei Beträge ein, die wir auf dein Konto eingezahlt haben",
    KWIKCASH_DEPOSIT_1: "Einzahlungsbetrag 1",
    KWIKCASH_DEPOSIT_2: "Einzahlungsbetrag 2",
    KWIKCASH_DEPOSIT_DESC:
      "Es kann einige Zeit dauern, bis die Einzahlungen auf deinem Konto erscheinen. Es kann 1-3 Tage dauern, bis du diese siehst.",
    KWIKCASH_VERIFY: "Verifizieren",
    KWIKCASH_BACK: "Zurück",
    KWIKCASH_BANK_VERIFY: "Bankkonto verifizieren",
    KWIKCASH_HISTORY: "KwikCash-Verlauf",
    KWIKCASH_NO_TRANSACTIONS: "Keine aktuellen Transaktionen",
    KWIKCASH_CONNECT: "Verbinden",
    KWIKCASH_BANK_ACCOUNTS: "Bankkonten",
    KWIKCASH_PENDING: "ausstehend",
    KWIKCASH_CONNECT_TO: "Verbinden mit",
    KWIKCASH_FEATURE_TBA:
      "Sorry, diese Funktion befindet sich noch im Aufbau. Bitte kehre zu einem späteren Zeitpunkt zurück",
    KWIKCASH_LINKED_ACCOUNTS: "Verknüpfte Accounts",
    KWIKCASH_VALIDATION_MESSAGE:
      "Bitte fülle das folgende Formular aus. Alle Felder müssen ausgefüllt werden.",
    VENDOR_ALL_VENDORS: "Alle Verkäufer",
    VENDOR_CAMPAIGNS: "Kampagnen",
    VENDOR_CAMPAIGN_LOGO: "Kampagnen-Logo",
    VENDOR_CAMPAIGN_NAME: "Kampagnen-Logo",
    VENDOR_MARKET: "Markt",
    VENDOR_CURRENCY: "Währung",
    VENDOR_START_DATE: "Startdatum",
    VENDOR_END_DATE: "Enddatum",
    VENDOR_ACTIONS: "Aktionen",
    VENDOR_EDIT: "Bearbeiten",
    VENDOR_DELETE: "Löschen",
    VENDOR_BACK_TO_CAMP_LIST: "Zurück zur Kampagnenliste",
    VENDOR_CAMP_DETAIL: "Details zur Kampagne",
    VENDOR_UPDATE: "Aktualisieren",
    VENDOR_SAVE: "Speichern",
    VENDOR_CANCEL: "Abbrechen",
    VENDOR_PLS_INPUT_CAMP_NAME: "Bitte Kampagnennamen eingeben!",
    VENDOR_PLS_SELECT_ONE: "Bitte wähle eine aus!",
    VENDOR_PRTS: "Kauf erforderlich zum Teilen",
    VENDOR_NPRTS: "    Kein Kauf zum Teilen erforderlich",
    VENDOR_FREE_TO_SHARE: "Kostenlos zum Teilen",
    VENDOR_CAMP_IMAGE: "Kampagnenbild",
    VENDOR_DRAG_AND_DROP: "DRAG AND DROP",
    VENDOR_YFTA: "deine Dateien zu Assets, oder",
    VENDOR_BROWSE: "suche durch",
    VENDOR_IMAGE: "Bild",
    VENDOR_PRODUCT_NAME: "Produktname",
    VENDOR_AC_NAME: "Aktionen/Kampagnenname",
    VENDOR_TPHBATTC: "Dieses Produkt wurde der Kampagne zugewiesen",
    VENDOR_AYSYWT_DELETE: "Bist du sicher, dass du es löschen willst?",
    VENDOR_YCLTC_TIPS:
      "Du kannst die Kampagne nicht mit dem Produkt verknüpfen, da sie zu verschiedenen Verkäufern gehören.",
    VENDOR_SEARCH_TIPS: "Suche nach Produkt, Kunde, etc...",
    VENDOR_PRODUCT_ID: "Produkt-ID",
    VENDOR_COUNTRY: "Land",
    VENDOR_REMOVE_FROM_CAMP: "aus Kampagnen entfernen",
    VENDOR_CUSTOMERS: "Kunden",
    VENDOR_HEAD: "Kopf",
    VENDOR_USER_NAME: "Benutzername",
    VENDOR_USER_ID: "Benutzer ID",
    VENDOR_EMAIL_ADDRESS: "E-Mail-Adresse",
    VENDOR_PHONE_NUMBER: "Telefonnummer",
    VENDOR_BACK_TO_CUSTOMER_LIST: "Zurück zur Kundenliste",
    VENDOR_USER_PROFILE: "Benutzerprofil",
    VENDOR_UPDATE_PROFILE: "Profil aktualisieren",
    VENDOR_FIRST_ROMAN_NAME: "Vorname (Romanische Schreibweise)",
    VENDOR_LAST_ROMAN_NAME: "Nachname (Romanische Schreibweise)",
    VENDOR_FIRST_NATIVE_NAME: "Vorname (ursprüngliche Schreibweise)",
    VENDOR_LAST_NATIVE_NAME: "Nachname (ursprüngliche Schreibweise)",
    VENDOR_ADD_LINE_1: "Adresszeile 1",
    VENDOR_ADD_LINE_2: "Adresszeile 2",
    VENDOR_CITY: "Stadt",
    VENDOR_STATE: "Bundesland",
    VENDOR_ZIP_CODE: "Postleitzahl",
    VENDOR_BIO: "Bio",
    VENDOR_BIO_TIPS:
      "Mach es kurz und knackig. Beschreib dich der Welt. Dies wird deine Bio sein, die jeder sehen kann.",
    VENDOR_STATUS: "Status",
    VENDOR_ORDER_HISTORY: "Bestellhistorie",
    VENDOR_ORDERS: "Aufträge",
    VENDOR_DATE: "Datum",
    VENDOR_CUSTOMER: "Kunde",
    VENDOR_PAYMENT_STATUS: "Zahlungsstatus",
    VENDOR_FULFILLMENT_STATUS: "Ausführungsstatus",
    VENDOR_PRICE: "Preis",
    VENDOR_ALL_ORDERS: "Alle Bestellungen",
    VENDOR_OPERATE: "Bearbeiten",
    VENDOR_EXPORT: "Exportieren",
    VENDOR_ORDER_ID: "Auftrags-ID",
    VENDOR_MARK_AS_FULFILLED: "Als erledigt markieren",
    VENDOR_ALL_STATUS: "Alle Status",
    VENDOR_PLS_SELECT: "Bitte auswählen",
    VENDOR_START_TIME_TO_END_TIME: "Startdatum - Enddatum",
    VENDOR_PLS_INPUT_STTET: "Bitte Startdatum - Enddatum eingeben!",
    VENDOR_TRACKING: "Tracking",
    VENDOR_REFUNDED: "Erstattet",
    VENDOR_STAFF_DELETE_TIPS: "Bist du sicher, dass du löschen willst?",
    VENDOR_STAFF: "Mitarbeiter",
    VENDOR_ADD_STAFF: "Mitarbeiter hinzufügen",
    VENDOR_FULL_NAME: "Vollständiger Name",
    VENDOR_DEPARTMENT: "Abteilung",
    VENDOR_ROLE: "Rolle",
    VENDOR_ADD: "Hinzufügen",
    VENDOR_PFTFB: "Bitte fülle das folgende Formular aus.",
    VENDOR_PWD: "Passwort",
    VENDOR_PSYR: "Bitte wähle deine Rolle!",
    VENDOR_PIYUI: "Bitte gib deine Benutzer-ID ein!",
    VENDOR_PIYUN: "Bitte gib deinen Benutzernamen ein!",
    VENDOR_PIYP: "Bitte gib dein Passwort ein!",
    VENDOR_PIYE: "Bitte gib deine E-Mail ein!",
    VENDOR_BSE: "Kaufen. Teilen. Verdienen.",
    VENDOR_BSE_DESC:
      "Kwik ist eine neue Marketplace-Plattform, die Marken mit ihren größten Fans verbindet und so eine starke Verkaufskraft durch Empfehlung schafft.",
    VENDOR_PETIMBTAYA:
      "Bitte gib die unten stehenden Daten ein, um auf dein Account zuzugreifen.",
    VENDOR_PIYEOU: "Bitte gib deine E-Mail oder deinen Benutzernamen ein!",
    VENDOR_KEEP_SIGN_IN: "Angemeldet bleiben",
    VENDOR_DONT_HAVE_ACCOUNT: "Du hast noch kein Account?",
    VENDOR_CREATE_ONE: "Erstelle eins",
    VENDOR_PPTREATRP:
      "Bitte gib die registrierte E-Mail-Adresse an, um das Passwort zurückzusetzen.",
    VENDOR_ALREADY_KNOW_PASSWORD: "Kennwort bereits genutzt",
    VENDOR_GO_TO_SIGNIN: "Gehe zu Anmelden",
    VENDOR_PCYI_CTLTRYP:
      "Bitte überprüfen deinen Posteingang und klicke auf den Link, um Ihr Passwort zurückzusetzen.",
    VENDOR_DIDNOT_RECEIVE_THE_LINK: "Hast du den Link nicht erhalten?",
    VENDOR_CHOOSE_NEW_PWD: "Wähle ein neues Passwort",
    VENDOR_EAUPTCYNP:
      "Gib ein individuelleres Passwort ein, um dein neues Passwort zu erstellen",
    VENDOR_NEW_PWD: "Neues Passwort",
    VENDOR_PIYCP: "Bitte gib dein bestätigtes Passwort ein!",
    VENDOR_SUCESS: "Das hat geklappt",
    VENDOR_YAHBC_PL: "Dein Konto wurde erstellt. Bitte melde dich an",
    VENDOR_CYBAN: "Erstelle jetzt dein Geschäftskonto.",
    VENDOR_PPUWSITCYA:
      "Bitte gib uns einige Informationen, um dein Konto zu erstellen.",
    VENDOR_BUSINESS_NAME: "Businessname",
    VENDOR_PIBN: "Bitte Businessname eingeben",
    VENDOR_BPN: "Telefonnummer des Businesses",
    VENDOR_PIPN: "Bitte Telefonnummer eingeben",
    VENDOR_EAFCA: "E-Mail-Adresse für Firmen-Account",
    VENDOR_PIEA: "Bitte E-Mail Adresse eingeben",
    VENDOR_PIP: "Bitte Passwort eingeben",
    VENDOR_CYP: "Bestätige Dein Passwort",
    VENDOR_PICP: "Bitte Passwort bestätigen",
    VENDOR_INCONSISTENT_PWD: "Passwörter stimmen nicht überein",
    VENDOR_IAGREETOTHE: "Ich akzeptiere die",
    VENDOR_TERMS_CONDITIONS: "Allgemeinen Geschäftsbedingungen",
    VENDOR_PCTT_CONDITONS_AGREEMENT:
      "Bitte die Allgemeinen Geschäftsbedingungen lesen!",
    VENDOR_BUSINESS_INFO: "Businessinformationen",
    VENDOR_BUSINESS_INFO_DESC:
      "Bitte beachte, dass diese Informationen bei der Anmeldung nicht erforderlich sind, aber erforderlich sind, um live zu gehen.",
    VENDOR_BUSINESS_TYPE: "Business-Typ",
    VENDOR_PLS_INPUT_BUSINESS_TYPE: "Bitte gib den Business-Typ ein",
    VENDOR_SSN_EIN: "NIN (oder ERN, falls Business)",
    VENDOR_PLS_INPUT_SSN: "Bitte NIN eingeben",
    VENDOR_WHO_REFER_YOU_TO_KWIK: "Wer hat dir Kwik empfohlen?",
    VENDOR_JSWCGTCTTRP: "Nur damit wir die richtige Person anschreiben können",
    VENDOR_PLS_INPUT_FN: "Bitte Vorname eingeben",
    VENDOR_PLS_INPUT_LN: "Bitte Nachname eingeben",
    VENDOR_PLS_INPUT_EA: "Bitte E-Mail Adresse eingeben",
    VENDOR_BRAND_INDUSTRY: "Brand Industry",
    VENDOR_PLS_INPUT_BRAND_INDUSTRY: "Bitte wähle die Brand Industry",
    VENDOR_CONTACT_INFO: "Kontaktinformationen",
    VENDOR_CONTACT_INFO_DESC:
      "Deine Brand bleibt so lange ausstehend, bis sie genehmigt wurde. Wir brauchen einen Ansprechpartner.",
    VENDOR_BUSINESS_URL: "Business-URL",
    VENDOR_CR: "Unternehmensumsatz (Jahresumsatz des Vorjahres)",
    VENDOR_PLS_INPUT_CR: "Bitte gib die Unternehmenseinnahmen ein",
    VENDOR_SUCCESS: "Erfolgreich",
    VENDOR_REGISTER_SUCCESS_1:
      "Vielen Dank, dass du das Brand-Profil ausgefüllt hast",
    VENDOR_REGISTER_SUCCESS_2:
      "Ein Mitglied unseres Brand-Teams wird sich in Kürze mit dir in Verbindung setzen, um weitere Informationen zu sammeln und dich beim Onboarding deiner Produkte bei Kwik zu unterstützen!",
    VENDOR_REGISTER_SUCCESS_3: "Danke für deine Geduld.",
    VENDOR_REGISTER_SUCCESS_4: "Geschätzte Zeit: 1-3 Tage",
    VENDOR_KWIK_HOME: "Kwik Home",
    VENDOR_STILL_PENDING: "Noch ausstehend",
    VENDOR_REGISTER_PENDING_1:
      "Entschuldige bitte, unser Brand Management Team ist im Moment sehr ausgelastet und das Onboarding dauert länger als erwartet.",
    VENDOR_REGISTER_PENDING_2:
      "Wir arbeiten mit Hochdruck daran, jede Brand auf Kwik zu bringen.",
    VENDOR_REGISTER_PENDING_3:
      "Verwende deine Brand-Login-Daten, um dich anzumelden und zu sehen, was die Nutzer sehen würden!",
    VENDOR_CHECK_OUT_USER: "User Experience checken",
    VENDOR_USER_USERNAME: "Benutzername",
    DASHBOARD_HI_USER_NAME: "Hallo, {{userName}}",
    DASHBOARD_ANALYTIC_REPORT: "Analytischer Bericht",
    DASHBOARD_SEARCH_FOR_PRODUCT_PLACEHOLDER: "Suche nach Produkt, Kunde, usw.",
    DASHBOARD_TOTAL_EARNINGS: "Gesamtverdienst",
    DASHBOARD_EARNINGS_REPORT: "Verdienstbericht",
    DASHBOARD_HERE_IS_THE_UPDATE_OF_YOUR_EARNING:
      "Hier sind die Aktualisierungen deiner Einnahmen.",
    DASHBOARD_THIS_WEEK_ITEM: "Diese Woche",
    DASHBOARD_THIS_MONTH_ITEM: "Diesen Monat",
    DASHBOARD_THIS_YEAR_ITEM: "Dieses Jahr",
    DASHBOARD_YOUR_TOTAL_EARNINGS: "Dein Gesamtverdienst",
    DASHBOARD_GET_ALL_THE_EARNING_MESSAGE:
      "Hier findest du alle Einnahmen der Woche, des Monats und des Jahres an einem Ort.",
    DASHBOARD_REVENUE: "Einkünfte",
    DASHBOARD_USERS: "Benutzer",
    DASHBOARD_ALL_USERS: "Alle Benutzer",
    DASHBOARD_NEW_USERS: "Neue Benutzer",
    DASHBOARD_TOP_SELLING_PRODUCTS: "Meistverkaufte Produkte",
    DASHBOARD_IMAGE_TH: "Bild",
    DASHBOARD_PRODUCT_NAME_TH: "Produktname",
    DASHBOARD_STATUS_TH: "Status",
    DASHBOARD_PRICE_TH: "Preis",
    DASHBOARD_SALES_TH: "Verkäufe",
    DASHBOARD_KWIKCASH_VALUE_TH: "KwikCash-Wert",
    DASHBOARD_INVENTORY_IN_STOCK: "{{inventory}} auf Lager",
    DASHBOARD_TOP_EARNERS: "Top Verdiener",
    DASHBOARD_ACTIVITY: "Aktivität",
    DASHBOARD_PURCHASED: "gekauft",
    PRODUCTS_PRODUCTS_TITLE: "Produkte",
    PRODUCTS_IMAGE_TH: "Bild",
    PRODUCTS_PRODUCT_NAME_TH: "Produktname",
    PRODUCTS_PRODUCT_ID_TH: "Produkt-ID",
    PRODUCTS_COUNTRY_TH: "Land",
    PRODUCTS_CURRENCY_TH: "Währung",
    PRODUCTS_TYPE_TH: "Typ",
    PRODUCTS_PRICE_TH: "Preis",
    PRODUCTS_BUDGET_TH: "Budget",
    PRODUCTS_KWIKCASH_VALUE_TH: "KwikCash-Wert",
    PRODUCTS_ACTIONS_TH: "Maßnahmen",
    PRODUCTS_EDIT_BUTTON: "Bearbeiten",
    PRODUCTS_PREVIEW_BUTTON: "    Vorschau",
    PRODUCTS_DETAIL_UPDATE_PRODUCT: "Update Produkt",
    PRODUCTS_DETAIL_ADD_PRODUCT: "Produkt hinzufügen",
    PRODUCTS_DETAIL_PLEASE_FILL_THE_FORM_BELLOW:
      "Bitte untenstehendes Formular ausfüllen.",
    PRODUCTS_DETAIL_CANCEL_BUTTON: "Abbrechen",
    PRODUCTS_DETAIL_SAVE_PRODUCT: "Produkt speichern",
    PRODUCTS_DETAIL_COUNTRY: "Land",
    PRODUCTS_DETAIL_PLEASE_SELECT_COUNTRY: "Bitte Land auswählen!",
    PRODUCTS_DETAIL_PLEASE_SELECT_WAREHOUSE: "    Bitte Lagerhaus auswählen!",
    PRODUCTS_DETAIL_SELECT_COUNTRY: "Land auswählen",
    PRODUCTS_DETAIL_CURRENCY: "Währung",
    PRODUCTS_DETAIL_SELECT_CURRENCY: "Währung auswählen",
    PRODUCTS_DETAIL_WAREHOUSE: "Lagerhaus",
    PRODUCTS_DETAIL_SELECT_WAREHOUSE: "Lagerhaus auswählen",
    PRODUCTS_DETAIL_GENERAL_INFO: "Allgemeine Info",
    PRODUCTS_DETAIL_PRODUCT_NAME: "Produktname",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_PRODUCT_NAME:
      "Bitte Produktnamen eingeben!",
    PRODUCTS_DETAIL_PRODUCT_SHORT_DESCRIPTION:
      "Kurzbeschreibung Produkt (begrenzt auf 200 Zeichen)",
    PRODUCTS_DETAIL_ADD_PRODUCT_IMAGE: "Produktbild hinzufügen",
    PRODUCTS_DETAIL_REMOVE: "Entfernen",
    PRODUCTS_DETAIL_DRAG_AND_DROP: "DRAG AND DROP",
    PRODUCTS_DETAIL_YOUR_FILES_TO_ASSETS:
      "deine Dateien zu Assets hinzufügen, oder <span>durchsuchen</span>",
    PRODUCTS_DETAIL_ACCEPTED_FILE_TYPE:
      "Akzeptierte Dateitypen: nur PNG und JPEG. ",
    PRODUCTS_DETAIL_RETURN_POLICY: "Rückgabebedingungen",
    PRODUCTS_DETAIL_PLEASE_ENTER_THE_NUMBER: "Bitte Nummer eingeben.",
    PRODUCTS_DETAIL_DAYS: "Tage",
    PRODUCTS_DETAIL_ADD_PRODUCT_VIDEO: "Produktvideo hinzufügen",
    PRODUCTS_DETAIL_VIDEO_URL: "Video-URL",
    PRODUCTS_DETAIL_PRICING: "Preisgestaltung",
    PRODUCTS_DETAIL_PRICE: "Preis",
    PRODUCTS_DETAIL_COMPARE_AT_PRICE: "Preis vergleichen (Verkaufspreis)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SALE_PRICE:
      "Bitte gib deinen Verkaufspreis ein!",
    PRODUCTS_DETAIL_BUDGET: "Budget",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_BUDGET: "Bitte gib dein Budget ein!",
    PRODUCTS_DETAIL_FULL_KWIK_CASH: "Volles KwikCash",
    PRODUCTS_DETAIL_1ST_WAVE_COMMISSION_RATE: "1. Welle Provisionsrate",
    PRODUCTS_DETAIL_VAT_RATE: "Mehrwertsteuersatz",
    PRODUCTS_DETAIL_TAX_RATE: "Mehrwertsteuersatz",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_VAT_RATE:
      "Bitte gib deine Mehrwertsteuersatz ein",
    PRODUCTS_DETAIL_VAT_INCLUSIVE: "Mehrwertsteuer inklusive",
    PRODUCTS_DETAIL_TAX_INCLUSIVE: "Mehrwertsteuer inklusive",
    PRODUCTS_DETAIL_TAX_CATEGORY: "Steuerkategorie",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_TAX_CATEGORY:
      "Bitte gib deine Steuerkategorie ein!",
    PRODUCTS_DETAIL_DUTY_RATE: "Zollsatz",
    PROUDCTS_DETAIL_DUTY_INCLUSIVE: "Zoll Inklusive",
    PRODUCTS_DETAIL_NEWAGE_CAMPAIGN: "NewAge Kampagne",
    PRODUCTS_DETAIL_FULFILED_BY_NEWAGE: "Durchgeführt von NewAge",
    PRODUCTS_DETAIL_PV: "PV",
    PRODUCTS_DETAIL_INVENTORY: "Bestand",
    PRODUCTS_DETAIL_SKU_STOCK_KEPING_UNIT: "SKU (Stock Keeping Unit)",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_SKU: "Bitte gib deine SKU ein!",
    PRODUCTS_DETAIL_QUANTITY: "Menge",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_INVENTORY:
      "Bitte gib deinen Bestand ein!",
    PRODUCTS_DETAIL_SHIPPING: "Versand",
    PRODUCTS_DETAIL_WEIGHT: "Gewicht",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_WEIGHT: "Bitte gib dein Gewicht ein!",
    PRODUCTS_DETAIL_CANADA_NFR_LIMITS:
      "Höchstwerte für den Nicht-Wiederverkauf (NFR) in Kanada",
    PRODUCTS_DETAIL_PLEASE_INPUT_YOUR_NFR_LIMITS:
      "Bitte gib deinen NFR-Höchstwert ein!",
    PRODUCTS_DETAIL_PRODUCT_STATUS: "Produktstatus",
    PRODUCTS_DETAIL_SCHEDULE_LAUNCH_TIME: "Markteinführung festlegen",
    PRODUCTS_DETAIL_PRODUCT_LONG_DESCRIPTION:
      "Ausführliche Produktbeschreibung",
    PRODUCTS_DETAIL_ORGANIZATION: "Organisation",
    PRODUCTS_DETAIL_PRODUCT_CATEGORY: "Produktkategorie",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_PRODUCT_CATEGORY:
      "Bitte wähle deine Produktkategorie!",
    PRODUCTS_DETAIL_PLEASE_SELECT: "Bitte auswählen",
    PRODUCTS_DETAIL_SUBCATEGORY: "Unterkategorie",
    PRODUCTS_DETAIL_PLEASE_SELECT_YOUR_SUBCATEGORY:
      "Bitte wähle deine Unterkategorie aus!",
    PRODUCTS_DETAIL_VARIANTS_INFO: "Varianten-Info",
    PRODUCTS_DETAIL_VARIANT_NAME: "Variantenname",
    PRODUCTS_DETAIL_ADD_OPTION: "Option hinzufügen",
    PRODUCTS_DETAIL_ADD_VARIANT: "Variante hinzufügen",
    PRODUCTS_DETAIL_VARIANTS_TH: "Varianten",
    PRODUCTS_DETAIL_IMAGE_URL_TH1: "    Bild1",
    PRODUCTS_DETAIL_IMAGE_URL_TH2: "    Bild2",
    PRODUCTS_DETAIL_IMAGE_URL_TH3: "    Bild3",
    PRODUCTS_DETAIL_IMAGE_URL_TH4: "    Bild4",
    PRODUCTS_DETAIL_DETELE_TH: "Löschen",
    PRODUCTS_DETAIL_DELETE_IT_TH: "Willst du es löschen?",
    PRODUCTS_DETAIL_SKU_TH: "SKU",
    PRODUCTS_DETAIL_PRICE_TH: "PREIS",
    PRODUCTS_DETAIL_COMPARE_TO_TH: "VERGLEICHEN_MIT",
    PRODUCTS_DETAIL_POINTS_TH: "    PUNKTE",
    PRODUCTS_DETAIL_BUDGET_TH: "BUDGET",
    PRODUCTS_DETAIL_KCASH_TH: "KCASH",
    PRODUCTS_DETAIL_INVENTORY_TH: "BESTAND",
    PRODUCTS_DETAIL_START_DATE_TH: "START_DATUM",
    PRODUCTS_DETAIL_END_DATE_TH: "END_DATUM",
    PRODUCTS_DETAIL_STATUS_TH: "STATUS",
    PRODUCTS_DETAIL_ACTIVE: "Aktiv",
    PRODUCTS_DETAIL_HIDDEN: "Versteckt",
    PRODUCTS_DETAIL_WEIGHT_TH: "GEWICHT",
    WAREHOUSE_PRODUCTS: "Produkte",
    WAREHOUSE_WAREHOUSE: "Lagerhaus",
    WAREHOUSE_ADD_WAREHOUSE_BUTTON: "Lagerhaus hinzufügen",
    WAREHOUSE_NAME_TH: "Name",
    WAREHOUSE_COUNTRY_TH: "Land",
    WAREHOUSE_ADDRESS1_TH: "Adresse 1",
    WAREHOUSE_ADDRESS2_TH: "Adresse 2",
    WAREHOUSE_CITY_TH: "Stadt",
    WAREHOUSE_STATE_TH: "Zustand",
    WAREHOUSE_POSTAL_CODE_TH: "Postleitzahl",
    WAREHOUSE_CONTACT_TH: "Kontakt",
    WAREHOUSE_PHONE_TH: "Telefonnummer",
    WAREHOUSE_SHIPPING_VENDOR_TH: "Versandhändler",
    WAREHOUSE_ACTIONS_TH: "Aktionen",
    WAREHOUSE_EDIT_BUTTON: "Bearbeiten",
    WAREHOUSE_DETAIL_BACK_TO_WAREHOUSE_LIST: "Zurück zur Lagerhausliste",
    WAREHOUSE_DETAIL_WAREHOUSE_DETAIL: "Lagerhaus Details",
    WAREHOUSE_DETAIL_UPDATE: "Aktualisieren",
    WAREHOUSE_DETAIL_SAVE: "Speichern",
    WAREHOUSE_DETAIL_CANCEL: "Abbrechen",
    WAREHOUSE_DETAIL_FORM_NAME: "Name",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_NAME: "Bitte Namen eingeben!",
    WAREHOUSE_DETAIL_FORM_COUNTRY: "Land",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_COUNTRY: "Bitte Land eingeben!",
    WAREHOUSE_DETAIL_FORM_SELECT_COUNTRY: "Land auswählen",
    WAREHOUSE_DETAIL_FORM_PLEASE_SELECT: "Bitte auswählen",
    WAREHOUSE_DETAIL_FORM_ADDRESS1: "Adresse 1",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_ADDR1: "Bitte Adresszeile 1 eingeben!",
    WAREHOUSE_DETAIL_FORM_ADDRESS2: "Adresse 2",
    WAREHOUSE_DETAIL_FORM_CITY: "Stadt",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_CITY: "Bitte Stadt eingeben!",
    WAREHOUSE_DETAIL_FORM_STATE: "Bundesland",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_STATE: "Bitte Bundesland eingeben!",
    WAREHOUSE_DETAIL_FORM_POSTAL_CODE: "Postleitzahl",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_POSTAL_CODE:
      "Bitte Postleitzahl eingeben!",
    WAREHOUSE_DETAIL_FORM_CONTACT: "Kontakt",
    WAREHOUSE_DETAIL_FORM_PHONE: "Telefonnummer",
    WAREHOUSE_DETAIL_FORM_PLEASE_INPUT_PHONE: "Bitte Telefonnummer eingeben!",
    WAREHOUSE_DETAIL_FORM_SHIPPING_VENDOR: "Versandhändler",
    INVENTORY_PRODUCTS: "Produkte",
    INVENTORY_INVENTORY: "Bestand",
    INVENTORY_IMAGE: "Bild",
    INVENTORY_PRODUCT_NAME: "Produktname",
    INVENTORY_SUPPLIER: "Lieferant",
    INVENTORY_SKU: "SKU#",
    INVENTORY_QTY_ALLOTED: "Zugewiesene Menge",
    INVENTORY_QTY_SOLD: "Verkaufte Menge",
    INVENTORY_QTY_ON_HAND: "Vorrätige Menge",
    INVENTORY_SALES: "Verkauf",
    SIDEBAR_MENU: "Menü",
    SIDEBAR_OVERVIEW: "Übersicht",
    SIDEBAR_PRODUCTS: "Produkte",
    SIDEBAR_WAREHOUSE: "Lager",
    SIDEBAR_INVENTORY: "Bestand",
    SIDEBAR_ADD_PRODUCT: "Produkt hinzufügen",
    SIDEBAR_GRAPH_VIEW: "Grafische Ansicht",
    SIDEBAR_CAMPAIGNS: "Kampagnen",
    SIDEBAR_CREATE_EDIT_CAMPAIGNS: "Kampagnen erstellen/bearbeiten",
    SIDEBAR_MAP_CAMPAIGNS_PRODUCTS: "Kampagnen/Produkte abbilden",
    SIDEBAR_CUSTOMERS: "Kunden",
    SIDEBAR_ORDERS: "Bestellungen",
    SIDEBAR_PAYOUTS: "Auszahlungen",
    SIDEBAR_STAFF_MANAGEMENT: "Mitarbeiterverwaltung",
    SIDEBAR_SETTINGS: "Einstellungen",
    SETTINGS_GENERAL_STORE_DETAILS: "Laden-Details",
    SETTINGS_GENERAL_STORE_ADDRESS: "    Shop-Adresse",
    SETTINGS_GENERAL_YOUR_CUSTOMERS_WILL_MESSAGE:
      "Deine Kunden werden diese Informationen nutzen, um mit dir in Kontakt zu treten.",
    SETTINGS_GENERAL_STORE_NAME: "Name des Ladens",
    SETTINGS_GENERAL_CONTACT_EMAIL: "Kontakt-E-Mail",
    SETTINGS_GENERAL_ADD_LOGO: "Logo hinzufügen",
    SETTINGS_GENERAL_DRAG_AND_DROP: "DRAG AND DROP",
    SETTINGS_GENERAL_YOUR_FILES_TO_ASSETS: "<span>durchsuchen</span>",
    SETTINGS_ACCEPTED_FILE_TYPE: "Akzeptierte Dateitypen: nur PNG und JPEG. ",
    SETTINGS_ACCEPTED_ADD_HERO_BANNER: "Herobanner hinzufügen",
    SETTINGS_ACCEPTED_REMOVE: "Entfernen",
    SETTINGS_GENERAL_UPLOAD_TERMS_AND_CONDITIONS:
      "Allgemeine Geschäftsbedingungen Hochladen",
    SETTINGS_GENERAL_ENTER_YOUR_TEXT: "Gib deinen Text ein",
    SETTINGS_GENERAL_STORE_INFORMATION: "Laden-Informationen",
    SETTINGS_GENERAL_SHARE_BIO_LIMIT_CHARACTERS:
      "Bio teilen (120 Zeichen Limit)",
    SETTINGS_GENERAL_COPY_AND_PASTE_YOUR_MESSAGE:
      "Kopiere deine Geschäftsbedingungen und füge sie hier ein",
    SETTINGS_GENERAL_ENTER_URL_S: "URL eingeben",
    SETTINGS_GENERAL_WEBSITE_URL: "Website-URL",
    SETTINGS_GENERAL_FACEBOOK_URL: "Facebook-URL",
    SETTINGS_GENERAL_INSTAGRAM_URL: "Instagram-URL",
    SETTINGS_GENERAL_TWITTER_URL: "Twitter-URL",
    SETTINGS_GENERAL_UPLOAD_RETURN_POLICY_HERE:
      "Rückgabebedingungen hier hochladen",
    SETTINGS_GENERAL_UPLOAD_SHIPPING_POLICY_HERE:
      "Versandbedingungen hier hochladen",
    SETTINGS_GENERAL_ACTIVE_STATUS: "Aktiver Status",
    SETTINGS_GENERAL_PENDING: "Ausstehend",
    SETTINGS_GENERAL_APPROVED: "Genehmigt",
    SETTINGS_GENERAL_LIVE: "Live",
    SETTINGS_GENERAL_DISCARD: "Verwerfen",
    SETTINGS_GENERAL_SAVE: "Speichern",
    SETTINGS_PROFILE_SAVE_PROFILE: "Profil speichern",
    SETTINGS_PROFILE_PREVIEW: "Vorschau",
    SETTINGS_BANKINFO_CONNECT_BANK_ACCOUNT: "Bankkonto verbinden",
    SETTINGS_BANKINFO_ACCEPT_PAYMENTS_ON_YOUT_MESSAGE:
      "Akzeptiere Zahlungen in deinem Shop über Drittanbieter wie PayPal oder andere Zahlungsmethoden",
    SETTINGS_BANKINFO_ADD_BANK_ACCOUNT: "Bankkonto hinzufügen",
    SETTINGS_BANKINFO_EDIT: "Bearbeiten",
    SETTINGS_BANKINFO_MANUAL_VERIFICATION: "Manuelle Verifizierung",
    SETTINGS_BANKINFO_AT_KWIK_YOUR_SECURITY_MESSAGE:
      "Bei Kwik ist uns deine Sicherheit sehr wichtig, deshalb werden wir dein Bankkonto verifizieren, indem wir zwei sehr kleine Einzahlungen auf dein Konto vornehmen. Bitte gib diese Beträge ein, wenn sie auf deinem Konto erscheinen",
    SETTINGS_BANKINFO_GO_BACK: "Zurück",
    SETTINGS_BANKINFO_CONTINUE: "Weiter",
    SETTINGS_BANKINFO_PLEASE_VERIFY_THE_MESSAGE:
      "Bitte überprüfe die kleinen Einzahlungen, die wir auf dein Konto/ deine Konten vorgenommen haben",
    SETTINGS_BANKINFO_CHARGE1: "Einzahlung 1",
    SETTINGS_BANKINFO_ENTER_AMOUNT: "Betrag eingeben",
    SETTINGS_BANKINFO_CHARGE2: "Einzahlung 2",
    SETTINGS_BANKINFO_TO_VERIFY_YOUR_MESSAGE:
      "Um dein Bankkonto zu überprüfen, wirst du in den nächsten zwei bis drei Tagen zwei Einzahlungen und zwei Abhebungen auf deinem Kontoauszug sehen. Jeder Betrag wird weniger als 1 USD betragen",
    SETTINGS_BANKINFO_PLEASE_MAKE_SURE_MESSAGE:
      "Bitte stelle sicher, dass dein Guthaben mindestens 2 USD beträgt, um Überziehungsgebühren zu vermeiden",
    SETTINGS_BANKINFO_BANK_ROUTING_NUMBER: "Bankleitzahl",
    SETTINGS_BANKINFO_ROUTING_NUMBER: "Bankleitzahl",
    SETTINGS_BANKINFO_ACCOUNT_NUMBER: "Kontonummer",
    SETTINGS_BANKINFO_CONFIRM_ACCOUNT_NUMBER: "Bestätige Kontonummer",
    SETTINGS_BANKINFO_ACCOUNT_NAME: "Kontoinhaber",
    SETTINGS_BANKINFO_ENTER_ACCOUNT_NAME: "Kontoinhaber eingeben",
    SETTINGS_BANKINFO_SET_YOUR_SHIPPING_RATES: "Versandkosten festlegen",
    SETTINGS_BANKINFO_SET_YOUR_VARIOUS_SHIPPING_RATES:
      "Deine verschiedenen Versandkosten festlegen",
    SETTINGS_BANKINFO_ADD_RATE: "Versandkosten hinzufügen",
    SETTINGS_BANKINFO_ADD_A_NEW_SHIPPING_RATES: "Neue Versandkosten hinzufügen",
    SETTINGS_BANKINFO_PRICING: "Preisgestaltung",
    SETTINGS_BANKINFO_ADD_CONDITIONS: "Bedingungen hinzufügen",
    SETTINGS_BANKINFO_BASED_ON_ITEM_WEIGHT: "Basierend auf Artikelgewicht",
    SETTINGS_BANKINFO_BASED_ON_ORDER_PRICE: "Basierend auf Bestellpreis",
    SETTINGS_BANKINFO_NUMBER_OF_UNITS: "Anzahl der Einheiten",
    SETTINGS_BANKINFO_SAVE_RATE: "Preis speichern",
    SETTINGS_BANKINFO_CANCEL: "Abbrechen",
    SETTINGS_SHIPPINGCOST_SHOW_ALL: "Alle anzeigen",
    SETTINGS_SHIPPINGCOST_ADD_SHIPPING_FORMULA:
      "Formel für Versandkosten hinzufügen",
    SETTINGS_SHIPPINGCOST_EDIT_SHIPPING_FORMULA:
      "Formel für Versandkosten bearbeiten",
    SETTINGS_SHIPPINGCOST_SAVE: "Speichern",
    SETTINGS_SHIPPINGCOST_SKU_ID: "SKU ID",
    SETTINGS_SHIPPINGCOST_PRODUCT_NAME: "Produktname",
    SETTINGS_SHIPPINGCOST_DELETE: "Löschen",
    SETTINGS_SHIPPINGCOST_BY_PRICE: "Nach Preis",
    SETTINGS_SHIPPINGCOST_BY_WEIGHT: "Nach Gewicht",
    SETTINGS_SHIPPINGCOST_BY_COUNT: "Nach Anzahl",
    SETTINGS_SHIPPINGCOST_FROM_PRICE: "Von Preis",
    SETTINGS_SHIPPINGCOST_TO_PRICE: "Bis Preis",
    SETTINGS_COUNTRY_CODE: "    Ländercode",
    SETTINGS_VAT_ID: "    USt-IdNr",
    SHIPPINGS_SHIPPINGCOST_FROM_LBS: "Von lbs",
    SHIPPINGS_SHIPPINGCOST_TO_LBS: "Bis lbs",
    SHIPPINGS_SHIPPINGCOST_FROM_COUNTS: "Von Anzahl",
    SHIPPINGS_SHIPPINGCOST_TO_COUNTS: "Nach Anzahl",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_VENDOR: "Bitte Verkäufer auswählen",
    SHIPPINGS_SHIPPINGCOST_PLEASE_SELECT_SHIPPING_METHOD:
      "Bitte Versandart auswählen",
    SHIPPINGS_SHIPPINGCOST_ITEM_ALREADY_EXISTS: "Artikel existiert bereits",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_CANNOT_BE_ADDED:
      "Der Bis-Preis ist #{{unlimited}} und es können keine neuen Daten hinzugefügt werden",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_CANNOT_BE_ADDED:
      "Bis Lbs ist #{{unlimited}} und neue Daten können nicht hinzugefügt werden",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_CANNOT_BE_ADDED:
      "Nach Anzahl ist #{{unlimited}} und neue Daten können nicht hinzugefügt werden",
    SHIPPINGS_SHIPPINGCOST_FORMULA_save_successfully:
      "Formel(n) erfolgreich gespeichert",
    SHIPPINGS_SHIPPINGCOST_DATA_MUST_NOT_BE_EMPTY:
      "Daten dürfen nicht leer sein",
    SHIPPINGS_SHIPPINGCOST_TO_PRICE_DATA_FORMAT_ERROR:
      "Bis Preis Datenformatfehler",
    SHIPPINGS_SHIPPINGCOST_TO_LBS_DATA_FORMAT_ERROR:
      "Bis Lbs Datenformatfehler",
    SHIPPINGS_SHIPPINGCOST_TO_COUNT_DATA_FORMAT_ERROR:
      "Nach Anzahl Datenformatfehler",
    SHIPPINGS_SHIPPINGCOST_PLEASE_EDIT_UNDER_THE_CORRESPONDING_TYPE:
      "Bitte unter dem entsprechenden Typ eingeben",
    SHIPPINGS_SHIPPINGCOST_NUMBERS_CAN_NOT_BE_NEGATIVE:
      "Zahlen dürfen nicht negativ sein",
    CHECKOUT_PAGE_MY_CART: "Mein Warenkorb",
    CHECKOUT_PAGE_SHIPPING_ADDRESS: "Versandadresse",
    CHECKOUT_PAGE_SAVE: "Speichern",
    CHECKOUT_PAGE_CHANGE: "Ändern",
    CHECKOUT_FIELD_NAME: "Name",
    CHECKOUT_FIELD_ADDRESS: "Anschrift",
    CHECKOUT_FIELD_APT_SUITE_ETC: "Wohnung, Appartement, etc. (optional)",
    CHECKOUT_FIELD_CITY: "Stadt",
    CHECKOUT_FIELD_ZIP: "Postleitzahl",
    CHECKOUT_FIELD_PROVINCE: "Bundesland",
    CHECKOUT_FIELD_STATE: "Landkreis",
    CHECKOUT_IS_BILLING_ADDRESS_DIFFERENT: "Abweichende Rechnungsadresse?",
    CHECKOUT_ITEM: "Artikel",
    CHECKOUT_ITEMS: "Artikel",
    CHECKOUT_PLEASE_FILL_OUT_NAME_FOR_CARD:
      "Bitte gib den Namen auf der Karte ein",
    CHECKOUT_TEXT_CHECKOUT: "Zur Kasse Gehen",
    CHECKOUT_ENTER_CREDIT_CARD: "Kreditkarte Eingeben",
    CHECKOUT_FIRST: "Erste",
    CHECKOUT_LAST: "Letzte",
    CHECKOUT_SAVE_SAVE_TO_MY_ACCOUNT: "Karte in meinem Konto speichern",
    CHECKOUT_BY_CLICKING_CONFIRM_MESSAGE:
      "Indem du auf Bestätigen klickst, stimmst du den Kwik's <span>Datenschutzbestimmungen</span> zu.",
    CHECKOUT_CONFIRM: "Bestätige",
    CHECKOUT_CARD_NUMBER: "Kartennummer",
    CHECKOUT_CARD_MM_YY: "MM/JJ",
    CHECKOUT_CARD_CVC: "CVV",
    CHECKOUT_BILLING_ADDRESS: "Rechnungsadresse",
    CHECKOUT_SAVE_ADDRESS: "Adresse speichern",
    CHECKOUT_SAVE_SUCCESS: "Erfolgreich gespeichert!",
    CHECKOUT_SAVE_FAILED:
      "Bitte fülle das Formular unten aus. Alle Felder sind Pflichtfelder",
    SHARING_PRO_YOU_CAN_SHARE: "Produkte, Die Du Teilen Kannst",
    SHARING_UWTTEE: "Exponentiell Verdienen Mit Waves Tech",
    SHARING_UWTTEE_DESC:
      "Das Werkzeug, mit dem du dein wahres Potenzial ausschöpfen kannst, um online zu verdienen und deinen wahren Einfluss zu maximieren. Hol dir einen Link von unten, um die Kwik Waves Technologie zu testen und für deinen wahren Einfluss entlohnt zu werden.",
    SHARING_CLOSE: "Schließen",
    SHARING_FIVE_TIMES: "Du wirst das nur noch 5 Mal sehen",
    SHARING_SHARE_FULL_CAMP: "Komplette Kampagne Teilen",
    SHARING_SINGLE_PRO: "Einzelne Produkte Teilen",
    SHARING_MOST_SHARED: "Meistgeteilter Link von",
    ALL_PRO_POLICIES: "Richtlinien",
    SS_THANK_YOU: "Danke",
    SS_SHARE_TIPS:
      "Gefällt dir dein Kauf? Super! Warum nicht belohnt werden, wenn du dieses Produkt mit einem Freund teilst!",
    SS_SHARE_TIPS_DESC:
      "Erstelle einen Account und fange an, deine KwikLinks zu teilen! Dein Link trackt die Einkäufe von Freunden und Verwandten und die Vermittlungsprovisionen werden direkt deinem Kwik-Account gutgeschrieben.",
    SS_CUSTOMER_INFO: "Kundeninformationen",
    SS_ADDRESS_INFO: "Adressinformationen",
    SS_CHECK_YOUR_EARNING: "Check deine Einnahmen!",
    SS_WHMIETSYA: "Wir haben es dir leicht gemacht, dein Account einzurichten!",
    SS_RETURN_HOME: "Zurück zur Startseite",
    SS_CREATE_HOME: "Account erstellen",
    SS_NEWAGE_PV: "NewAge PV",
    SS_FOOTER_HEAR_YOU: "Wir würden uns freuen, von dir zu hören!",
    SS_FOOTER_EMAIL: "support@wer1.com",
    SS_FOOTER_PPTOU: "Datenschutzrichtlinien | Nutzungsbedingungen ",
    SS_FOOTER_COPY_RESERVED: "Copyright. ©2023 Alle Rechte vorbehalten",
    SS_FOOTER_HOME: "Startseite",
    SS_FOOTER_HOW_IT_WORKS: "Wie es funktioniert",
    SS_FOOTER_FOR_BRANDS: "Für Brands",
    SS_FOOTER_WHAT_NEW: "Was ist neu?",
    SS_FOOTER_HELP_SUPPORT: "Hilfe und Support",
    SS_FOOTER_PRIVACY_POLICY: "Datenschutzrichtlinien ",
    SS_TERMS_OF_USE: "Nutzungsbedingungen",
    SS_FOOTER_SUB_FOR_UPDATES: "Updates abonnieren",
    SS_FOOTER_FOLLOW_US: "FOLGE UNS",
    SS_SUCESS: "Ergebnisse für erfolgreiches Teilen",
    SS_REGISTER_YSSYP:
      "Du hast dein Produkt erfolgreich geteilt. Erstelle jetzt ein Account, um deine Einnahmen zu verwalten!",
    SS_REGISTER_BSUFAK:
      "Mit der Erstellung eines Kwik Accounts stimme ich den Allgemeinen Geschäftsbedingungen zu.",
    SS_REGISTER_YAAD: "Fasst geschafft!",
    SS_REGISTER_WHSAVCT:
      "Wir haben einen Verifizierungscode an die E-Mail-Adresse gesendet, die du bei der Bestellung verwendet hast. Wenn du einen anderen Code benötigst, klicke bitte auf erneut senden.",
    LEGAL_INFO: "Rechtliche Informationen",
    LEGAL_WELCOME_TO_KWIK: "Willkommen bei WeR1!",
    LEGAL_TC: "Allgemeine Geschäftsbedingungen",
    HEADER_MENU_SHARING: "Teilen",
    HEADER_MENU_SHOPPING: "Shopping",
    HEADER_MENU_HELP: "Hilfe",
    HEADER_MENU_ACCOUNT_SETTING: "Account-Einstellungen",
    HEADER_LAYER_ACCOUNT: "Account",
    HEADER_LAYER_EDIT_ACCOUNT: "Account bearbeiten",
    HEADER_LAYER_LOGOUT: "Abmelden",
    HEADER_LAYER_HELP_CONTACT: "Hilfe/Kontakt",
    HEADER_LAYER_HELP_LEGAL: "Rechtliches",
    HEADER_LAYER_HELP_LANGUAGE: "Sprache",
    HEADER_LAYER_HELP_SELECT_YOUR_GEOGRAPHICAL_REGION:
      "Wähle deine geografische Region",
    HEADER_LAYER_HELP_SELECT_YOUR_PREFERRED_LANGUAGE:
      "Wähle deine bevorzugte Sprache",
    SETTING_HEADER_ACCOUNT: "Account",
    SETTING_HEADER_HELP_CONTACT: "Hilfe Kontakt",
    SETTING_HEADER_LEGAL: "Rechtliches",
    SETTING_HEADER_SETTINGS: "Einstellungen",
    SETTING_ACCOUNT_CHANGE_IMAGE: "Bild ändern ",
    SETTING_ACCOUNT_FIRST_NAME: "Vorname",
    SETTING_ACCOUNT_FIRST_NAME_IS_REQUIRED: "Vorname ist erforderlich",
    SETTING_ACCOUNT_LAST_NAME: "Nachname",
    SETTING_ACCOUNT_LAST_NAME_IS_REQUIRED: "Nachname ist erforderlich",
    SETTING_ACCOUNT_USER_NAME: "Benutzername",
    SETTING_ACCOUNT_USER_NAME_IS_REQUIRED: "Benutzername ist erforderlich",
    SETTING_ACCOUNT_PROFILE_CONTACT_INFO: "Profil-Kontaktinformation",
    SETTING_ACCOUNT_PHONE_NUMBER: "Telefonnummer",
    SETTING_ACCOUNT_PHONE_NUMBER_IS_REQUIRED: "Telefonnummer ist erforderlich",
    SETTING_ACCOUNT_EMAIL: "E-Mail",
    SETTING_ACCOUNT_EMAIL_IS_REQUIRED: "E-Mail ist erforderlich",
    SETTING_ACCOUNT_PLEASE_NOTE_MESSAGE:
      "Bitte beachte: Auf diese Weise können dich andere Personen über deine Profilseite kontaktieren. Aktualisiere diese Angaben, damit die Leute wissen, wie sie dich erreichen können.",
    SETTING_ACCOUNT_YOUR_LOGIN_EMAIL_MESSAGE:
      "Deine Anmeldungs-E-Mail und deine Account-Telefonnummer bleiben unverändert.",
    SETTING_ACCOUNT_SECURITY: "Sicherheit",
    SETTING_ACCOUNT_PASSWORD: "Passwort",
    SETTING_ACCOUNT_DISCARD: "Verwerfen",
    SETTING_ACCOUNT_CHANGE_PASSWORD: "Passwort ändern",
    SETTING_CONTACT_HELP_CONTACT: "Hilfe & Kontakt",
    SETTING_CONTACT_CONTACT_US_AT: "Kontaktiere uns über",
    SETTING_CONTACT_ADDRESS: "Adresse",
    SETTING_CONTACT_EMAIL: "E-Mail",
    SETTING_CONTACT_PHONE: "Telefonnummer",
    SETTING_CONTACT_WHAT_TYPE_OF_PROBLEM: "Welches Problem",
    SETTING_CONTACT_PROBLEM_IS_REQUIRED: "Problemangabe ist erforderlich",
    SETTING_CONTACT_THIS_FIELD_IS_REQUIRED: "Dieses Feld ist erforderlich",
    SETTING_CONTACT_PLEASE_GIVE_US_DETAILS_MESSAGE:
      "Bitte schildere uns das Problem, das du melden möchtest. Deinen Namen, deine E-Mail-Adresse und ggf. deine Bestellnummer.",
    SETTING_CONTACT_DETAIL_IS_REQUIRED: "Einzelheiten sind erforderlich",
    SETTING_CONTACT_ATTACH_ANY_IMAGES_MESSAGE:
      "Bilder oder Screenshots anfügen",
    SETTING_CONTACT_DRAG_AND_DROP_MESSAGE:
      "Ziehe eine Videodatei per Drag & Drop zu den Assets, oder durchsuche sie",
    SETTING_CONTACT_SUBMIT: "Senden",
    SORRY_YOU_CAN_T_SHARE_PRODUCT_MESSAGE:
      "Leider kannst du das Produkt #{{names}} nicht teilen. Bitte kaufe dieses Produkt jetzt, oder beantrage die Teilnahmeberechtigung.",
    USER_REGISTER_INVLID_INPUT_CHARACTERS: "    Ungültige Zeicheneingabe",
    CHECKOUT_PAYMENT: "    Zahlung",
    ADD_PRODUCT_RETAIL: "    Einzelhandelspreis",
    ADD_PRODUCT_WHOLESALE: "    Großhandelspreis",
    ADD_PRODUCT_PLEASE_INPUT_YOUR_WHOLESALE:
      "    Bitte gib deinen Großhandelspreis ein!",
    ADD_PRODUCT_RETAIL_SHOULD_NOT_MESSAGE:
      "    Der Großhandelspreis sollte niedriger sein als der Einzelhandelspreis",
    ADD_PRODUCT_PROMOTIONAL_INSTANT_KWIK_CASH_ACCRUAL:
      "    Promotional Instant KwikCash Zugewinn",
    ADD_PRODUCT_OF_RETAIL: "    des Einzelhandelspreises",
    ADD_PRODUCT_BRAND_PAYOUT: "    Brand-Auszahlung (angepasster Großhandel)",
    ADD_PRODUCT_KWIK_REVENUE: "    Kwik-Einnahmen",
    ADD_PRODUCT_OF_DELTA: "    von Delta",
    ADD_PRODUCT_ADMINISTRATION_FEE: "    Verwaltungsgebühr",
    ADD_PRODUCT_REFERRAL_FEE: "    Vermittlungsgebühr",
    ADD_PRODUCT_INSTANT_KWIK_CASH_ACCRUAL: "    Instant KwikCash Zugewinn",
    ADD_PRODUCT_COMMISSION_ALLOCATION: "    Provisionszuteilung",
    ADD_PRODUCT_TRUE_COMMISSION_ALLOCATION: "    Echte Provisionszuteilung",
    ADD_PRODUCT_LEVEL_WAVE_OF_COMMISSION: "    {{level}} Welle der Provision",
    VENDOR_SETTINGS_BRAND_ID: "    Brand ID",
    VENDOR_SETTINGS_KWIK_REVENUE: "    Kwik-Umsatz(%)",
    VENDOR_SETTINGS_ADMIN_FEE: "    Verwaltungsgebühr(%)",
    VENDOR_SETTINGS_RETAIL_MULTIPLLER: "    Einzelhandelsmultiplikator",
    VENDOR_SETTINGS_FEE_MULTIPLLER: "    Gebührenmultiplikator",
    VENDOR_SETTINGS_REFERRAL_FEE: "    Vermittlungsgebühr(%)",
    VENDOR_SETTINGS_IKCA: "    Instant KwikCash Zugewinn(%)",
    VENDOR_SETTINGS_REFERRAL_EMAIL: "    E-Mail-Adresse der Vermittlungsperson",
    VENDOR_SETTINGS_TP: "    Befristete Aktion(%)",
    VENDOR_SETTINGS_NEWAGE_CAMPAIGN: "    NewAge Brand Engagement",
    VENDOR_SETTINGS_FULL_BY_NEWAGE: "    Ausgeführt von NewAge",
    VENDOR_SETTINGS_CTPV:
      "    Prozentualer Anteil der Provision am PV-Wert (%)",
    VENDOR_SETTINGS_DPP: "    Dollar pro PV",
    PRODUCTS_DETAIL_VENFOR_PAYOUT: "    Verkäufer-Auszahlung",
    PRODUCTS_DETAIL_PAYOUT_REMITTENCE: "    Auszahlungsüberweisung",
    PRODUCTS_DETAIL_CASHBACK_STRUCTRUE: "    Cashback-Struktur",
    PRODUCTS_DETAIL_CASHBACK: "    Cashback",
    PRODUCTS_DETAIL_PROMOTIONAL_CASHBACK: "    Promotional Cashback",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE: "    Wave-Provisionsstruktur",
    PRODUCTS_DETAIL_WAVE_COMM_STRUCTURE_DESC:
      "    Abhängig vom Einzelhandelspreis - Gesamtverkaufspreis. Passe diese an, um Änderungen in der Wellenstruktur zu sehen",
    PRODUCTS_DETAIL_TOTAL_WAVE_FUNDING: "    Gesamte Wellenfinanzierung",
    PRODUCTS_DETAIL_1ST_OF_RETAIL: "    1. Welle in % des Verkaufspreises",
    PRODUCTS_DETAIL_TEMPORARY_PROMOTIONS: "    Befristete Aktionen",
    PRODUCTS_DETAIL_OPTIONAL: "    Optional",
    PRODUCTS_DETAIL_TPR: "    Befristete Auszahlungsüberweisung",
    PRODUCTS_DETAIL_SALES_CHANNEL: "    Vertriebsweg",
    PRODUCTS_DETAIL_SALES_CHANNEL_DESC:
      "    Bitte beachte, dass diese zusätzlichen Kanäle optional sind. Wenn du dich für einen davon entscheidest, kann dies Auswirkungen auf die verschiedenen Wellenbeträge haben.",
    PRODUCTS_DETAIL_DIRECT_DISTRIBUTE: "    Direktvertrieb",
    VENDOR_SETTINGS_WRONG_TYPE: "    Bitte gib die Art der Nummer ein",
    PRODUCTS_DETAIL_TAX_VAT_DUTY: "    Steuern/Mehrwertsteuer/Zölle",
    PRODUCTS_DETAIL_REQUIRE_EU: "    - Erforderlich für EU-Länder",
    PRODUCTS_DETAIL_REQUIRE_AUS: "    - Erforderlich für Australien",
    PRODUCTS_DETAIL_REQUIRE_CAN:
      "    - Erforderlich für grenzüberschreitenden e-Commerce nach Kanada",
    SHARE_LINK_PRICE_VAT: "    Mehrwertsteuer",
    LEGAL_CONTENT:
      'Willkommen bei Kwik!  \nKwik ist ein idealer Marktplatz, auf dem Sie verkaufen, kaufen, teilen und durch Ihren Online-Engagement Geld verdienen können. Wir wünschen uns, dass alle, die unsere Website besuchen und unsere Produkte nutzen, eine positive Erfahrung machen. Zu unseren Produkten zählen unsere Internetseite, unsere mobile App usw.\nDies ist ein rechtsverbindlicher Vertrag zwischen Ihnen und Kwik. Durch die Nutzung von Kwik Products erklären Sie sich mit den folgenden Allgemeinen Geschäftsbedingungen einverstanden - unseren Regeln, die allen Nutzern die bestmögliche Nutzung ermöglichen. Sollten Sie mit diesen Bedingungen nicht einverstanden sein, nutzen Sie Kwik Products bitte nicht.  \nBitte beachten Sie, dass diese Allgemeinen Geschäftsbedingungen keine Partnerschaft, kein Joint Venture, kein Arbeitsverhältnis und keine Franchise-Beziehung zwischen Ihnen und Kwik darstellen.\nWenn Sie Interesse haben, über Kwik zu verkaufen, müssen Sie auch unsere Verkäuferpolitik verstehen und dieser zustimmen.\nIhr Konto\nUm unsere Produkte nutzen zu können, müssen Sie ein Konto anlegen. Klicken Sie hier, wenn Sie wissen möchten, wie Sie ein Konto bei Kwik einrichten können. Mit der Einrichtung eines Kontos erklären Sie sich mit den folgenden Bedingungen einverstanden:\nPro Person kann nur ein Konto eingerichtet werden; Sie sind für Ihr Konto verantwortlich.\nSie müssen 18 Jahre oder älter sein. Jugendliche über 13 Jahre dürfen Kwik nur über das Konto eines Elternteils oder Erziehungsberechtigten nutzen. Sie tragen die Verantwortung für die Nutzung der Dienste Ihres Kontos durch einen Minderjährigen. Kinder unter 13 Jahren dürfen unsere Produkte nicht nutzen.\nDie Angaben, die Sie über sich selbst machen, müssen wahrheitsgemäß und korrekt sein. Es ist untersagt, sich in Ihrem Konto als eine andere Person oder ein anderes Unternehmen auszugeben.\nSie sind dafür verantwortlich, Ihr Konto und Ihr Passwort zu schützen.\nVerwendung von Kwik Products\nDurch die Nutzung von Kwik Products bestätigen Sie, dass Sie die folgenden Bedingungen verstanden haben und diesen zustimmen. Bei der Nutzung von Kwik:\nGreifen Sie nicht auf die Daten von Kwik Products zu, indem Sie automatische Programme (Robots, Spiders) oder andere automatisierte Methoden verwenden, für die Sie keine Zugriffsberechtigung haben.\nSpeichern, kopieren, nutzen, übertragen oder verkaufen Sie keine Daten von Kwik Products, die Ihnen nicht von Kwik zur Verfügung gestellt wurden.\nLaden Sie keinen unbefugten Link zu einer externen Website hoch.\nLaden Sie keine bösartigen Codes oder Viren auf Kwik Products hoch und helfen Sie auch nicht beim Hochladen.\nTun Sie nichts, was die Rechte anderer verletzt, darunter auch die Rechte an geistigem Eigentum\nBeeinträchtigen Sie nicht die ordnungsgemäße Funktion der Kwik Products\nVerletzen Sie keine regionalen oder internationalen Gesetze, Marken, Rechte oder geistige Eigentumsrechte \nBefolgen Sie unsere Markenzeichenpolitik\nBezahlen Sie alle an Kwik geschuldeten Gebühren\nInhalt\nDurch die Nutzung von Kwik haben Sie verschiedene Möglichkeiten, Inhalte zu erstellen. Zu den von Ihnen erstellten Inhalten gehören unter anderem Bewertungen, Kommentare, Fotos, Profilbilder, Beschreibungen in Ihrem Profil und Nachrichten an Verkäufer. Sie sind für die Inhalte verantwortlich, die in Ihrem Konto veröffentlicht oder hochgeladen werden.\nUm eine angenehme Nutzung für alle Kwik-Mitglieder zu gewährleisten, gibt es bestimmte Arten von Inhalten, die wir nicht auf Kwik Products veröffentlichen möchten. Durch die Nutzung unserer Produkte erklären Sie sich damit einverstanden, keine Inhalte zu erstellen, die in irgendeiner Weise hasserfüllt, beleidigend, bedrohend, vulgär, obszön, falsch, irreführend oder trügerisch sind. \nKwik verpflichtet sich, die Rechte an geistigem Eigentum zu schützen. Wenn Sie Inhalte hochladen oder veröffentlichen, die das geistige Eigentum eines Dritten verletzen, sehen wir uns gezwungen, entsprechende Maßnahmen zu ergreifen. Dies kann die vorübergehende Sperrung Ihres Kontos oder die Kündigung Ihres Kontos beinhalten, wenn Sie wiederholt das geistige Eigentum anderer nutzen oder verletzen. Sollte dies der Fall sein, werden wir Sie über diese Änderungen informieren. Wenden Sie sich an Kwik, wenn Inhalte, die Ihnen gehören oder an denen Sie Rechte haben, ohne Ihre Zustimmung veröffentlicht wurden.\nWenn Sie ein Verkäufer sind, finden Sie in unseren Geschäftsbedingungen für Verkäufer weitere Informationen zu unseren Standards.\nIhre Daten\nWir verpflichten uns zur Einhaltung des Schutzes Ihrer Privatsphäre und Ihrer persönlichen Daten. Im Folgenden wird beschrieben, welche persönlichen Daten Kwik erfasst und wie sie verwendet werden. Wenn Sie nicht möchten, dass Kwik Ihre Daten auf die unten beschriebene Weise verwendet, dürfen Sie Kwik-Produkte nicht benutzen.\nKwik kann von Ihnen freiwillig zur Verfügung gestellte Informationen erhalten. Um Kwik Products zu nutzen und ein Konto zu erstellen, müssen Sie eine gültige E-Mail-Adresse und einen Namen angeben, der mit Ihrem Konto verknüpft wird.  Sie können in Ihrem Konto auch andere Informationen angeben, z. B. Geburtstag, Lebenslauf, Wohnort oder Geschlecht. Sie können auch Bewertungen zu Produkten oder andere Beiträge einstellen. Diese Informationen sind für andere Kwik-Besucher und -Mitglieder zugänglich.\nWenn Sie Einnahmen aus Wave Ausschüttungen (oder Kwik Cash) erzielen, müssen Sie zusätzliche Bankdaten angeben (z. B. Kreditkarten- und Kontonummern, Transaktionsdetails und Zahlungsart). Wenn Sie beabsichtigen, über Kwik zu verkaufen, finden Sie in unseren Richtlinien für Verkäufer zusätzliche Informationen, die Kwik zur Verfügung gestellt werden müssen, um Ihre Identität und Ihre Kreditdaten zu verifizieren, damit Sie von Ihren Verkäufen profitieren können.\nWenn Sie Inhalte über Kwik Products einstellen, gewähren Sie Kwik eine Lizenz zur Nutzung dieser Inhalte. Wir erheben keinen Anspruch auf die Inhalte. Wir verwenden und teilen Inhalte, die von Verkäufern gepostet werden, um Produkte von Verkäufern bei anderen Verkäufern und Käufern auf der Grundlage ihrer Angebote, Suchen und der Nutzung von Kwik Products zu bewerben. Diese Berechtigung erlaubt es Kwik auch, bestimmte Anpassungen am Inhalt vorzunehmen, wie z.B. ein Foto zu vergrößern oder zu verkleinern oder den Inhalt bei Bedarf in eine andere Sprache zu übersetzen.\nKwik sammelt auch automatisch Informationen, wenn Sie unsere Produkte, einschließlich unserer Internetseite und unserer mobilen App, nutzen. Dazu kann Ihre IP-Adresse, eine andere eindeutige Gerätekennung oder die Version der von Ihnen verwendeten mobilen App zählen. Diese Informationen können uns dabei helfen, Betrug durch Nutzer zu verhindern. Kwik sammelt auch automatisch Daten über Ihre Nutzung der Internetseite, wie z.B. die von Ihnen besuchten Seiten und wie Sie mit diesen Seiten interagieren (z.B. durch Klicken auf einen Link oder die Verweildauer auf einer Seite). Dies hilft uns, Ihr Nutzererlebnis zu personalisieren und Werbung auf der Grundlage Ihrer Interessen zu ermöglichen.\nSowohl Kwik als auch die Verkäufer sammeln personenbezogene Daten der Käufer und sind beide für die Verarbeitung der Daten verantwortlich. Wenn Sie einen Artikel über Kwik kaufen, stellen Sie den Verkäufern auch Informationen zur Verfügung, die Ihren Namen, Ihre Adresse, Ihre Rechnungsadresse und Ihre Zahlungsinformationen beinhalten können. Verkäufer müssen sich an die Standards zum Schutz der Privatsphäre des Käufers halten, die in unseren Richtlinien für Verkäufer dargelegt sind. Während des Bezahlvorgangs können wir Kreditkarteninformationen, die Rechnungsadresse und andere Informationen speichern, um Ihre Transaktion zu bearbeiten und für die Rechnungsstellung und Zahlung. Mitglieder in einigen Ländern können sich dafür entscheiden, dass Kwik ihre Daten speichert, um zukünftige Einkäufe zu erleichtern.\nAndere Informationen, die wir einholen, können von Ihnen bereitgestellt werden, wenn Sie den Kundendienst kontaktieren. \nVerdienen von Kwik Cash\nInfluencer können Kwik Cash verdienen, wenn sie ein Produkt kaufen, einen eindeutigen Link zu diesem Produkt in den sozialen Medien teilen, dieser Link angeklickt wird, um die Produktseite zu besuchen, und dadurch ein Verkauf zustande kommt. Der Influencer MUSS das Produkt kaufen und der Verkauf muss über den Link des Influencers erfolgen, damit der Influencer Kwik Cash erhält. Wie oben erwähnt, müssen Sie zusätzliche Informationen, einschließlich Kreditdaten, einreichen, um Ihr Kwik Cash zu erhalten.\nIn den Vereinigten Staaten, wo Kwik tätig ist, müssen sich Influencer an die "Disclosure of Material Connection" der Federal Trade Commision (FTC) halten [Link]. Dies ist erforderlich, wenn die materielle Verbindung (z.B. Bezahlung, ein kostenloses Produkt oder eine kostenlose Dienstleistung oder ein Sponsoring) die Glaubwürdigkeit der Befürwortung des Influencers beeinträchtigen würde (z. B. wenn die Befürwortung nur deshalb positiv wäre, weil der Influencer davon profitiert) oder wenn das Zielpublikum dies nicht erwarten würde, weil keine offensichtliche Verbindung zur Marke besteht.\nUm Kwik Cash zu verdienen, müssen sich Influencer an die folgenden Regeln halten:\nDer Influencer muss eindeutig offenlegen, dass eine wesentliche Verbindung zu den Produkten, Waren oder Dienstleistungen des Verkäufers besteht. Hier sind einige Beispiele, wie Sie dies offenlegen können:\nOffenlegung: Wenn ich auf diesen Link klicke und [Markenprodukt] bei Kwik kaufe, erhalte ich Kwik Cash.\nDeutlich sichtbare Hashtags wie #advertisement, #sponsored, #[Brand]ad, oder #ad\nDer Hinweis muss im Beitrag des Influencers über das Produkt enthalten und deutlich sichtbar sein.\nDer Influencer muss ehrlich sein und darf das Produkt nicht irreführend beschreiben.\nDer Influencer darf keine falschen Behauptungen über das Produkt aufstellen, einschließlich offener Unwahrheiten, nicht repräsentativer Aussagen (z.B. über die Wirkung eines Produkts, die nicht auf alle zutrifft, z.B. "diese Gesichtscreme lässt mich fünf Jahre jünger aussehen") oder unbegründeter Behauptungen (der Influencer hat keine ausreichende Erfahrung mit dem Produkt, um es zu empfehlen).\nWenn Sie sich außerhalb der Vereinigten Staaten befinden, gelten möglicherweise ähnliche Gesetze. In Kanada wohnhafte Personen sollten das Competition Act [link] des Competition Bureau und die darin vorgesehenen Strafen für Verstöße gegen die Influencer-Vorschriften kennen. Wenn Sie sich im Vereinigten Königreich aufhalten, beachten Sie die Vorschriften für Social Media Influencer, die von der Advertising Standards Authority (ASA), dem Committee of Advertising Practice (CAP) und der Competition and Markets Authority (CMA) veröffentlicht wurden. [Sie sind dafür verantwortlich, die Gesetze des Landes, in dem Sie Ihren Wohnsitz haben, zu verstehen und Ihren Einfluss in den sozialen Medien entsprechend zu gestalten.\n401(k)-Ausschlusspolitik\nWenn Sie Kwik Cash verdienen, verstehen Sie, dass Kwik nicht dafür verantwortlich ist, Ihnen einen 401(k)-Plan anzubieten, da Sie kein Mitarbeiter von Kwik sind.\nStreitfallpolitik\nFall-Politik \nWenn Sie ein Problem mit einem Produkt haben, bitten wir Sie, sich zunächst direkt an den Verkäufer zu wenden, um das Problem zu lösen. Wenn der Verkäufer nicht reagiert oder das Problem nicht löst, können Sie einen Fall bei Kwik eröffnen. \nEin Fall kann eröffnet werden, wenn der Artikel ankommt und nicht der Beschreibung oder Abbildung im Shop des Verkäufers entspricht oder wenn er aufgrund von Handlungen des Verkäufers nicht geliefert wird. Der Käufer muss ein Foto für einen Artikel zur Verfügung stellen, von dem er behauptet, dass er nicht wie beschrieben oder wie im Shop des Verkäufers abgebildet ist. Beispiele hierfür könnten ein oder mehrere Gegenstände sein, die \naus einem anderen Material oder mit einem anderen Muster als dem beschriebenen gefertigt sind\neine andere Größe, Farbe, ein anderes Modell oder eine andere Version darstellen\nsich in einem anderen Zustand als beschrieben befindet (d.h. als neu beschrieben, aber gebraucht ist)\ndie falsche Menge an Artikeln aufweist\nbeschädigt sind \nfehlende Einzelteile oder Elemente\nunvollständig zugesagte Leistungen\nDer Verkäufer muss einen gekauften Artikel innerhalb eines angemessenen Zeitrahmens versenden oder einen zugesagten Liefertermin einhalten. Es kann jedoch kein Fall eröffnet werden, wenn der Artikel beschädigt, nicht oder verspätet geliefert wurde, da weder der Verkäufer noch Kwik ein Verschulden trifft. \nDie Fälle werden gelöst, wenn\nder Käufer eine Rückerstattung erhält.\nder Käufer den Fall abschließt.\nDer Fall wegen Nichtlieferung geöffnet wurde und der Verkäufer den Nachweis erbringt, dass der Artikel rechtzeitig an die Adresse des Käufers versandt wurde.\nWeitere Informationen über die Verantwortlichkeiten des Verkäufers finden Sie in unseren Richtlinien für Verkäufer.\nStreitigkeiten mit Dritten\nWenn ein Problem mit einem Produkt oder einer Transaktion mit einem Verkäufer oder einem anderen Kwik-Mitglied auftritt, befolgen Sie bitte die oben aufgeführten Schritte in unserer Fall-Politik. Wir werden alles in unserer Macht Stehende tun, um Ihnen bei der Lösung von Problemen mit unserer Politik zu helfen. Wir sind jedoch nicht verpflichtet, Streitigkeiten, die Sie mit anderen Kwik-Mitgliedern oder Dritten haben, beizulegen. Sie stellen Kwik von allen Ansprüchen, Schäden oder Forderungen frei, die sich aus Streitigkeiten mit anderen Mitgliedern oder Parteien ergeben. \nStreitigkeiten mit Kwik\nEgal ob Sie ein Verkäufer oder Käufer sind, wenn Sie einen Konflikt mit uns haben, kontaktieren Sie uns bitte zuerst und wir werden unser Bestes tun, um das Problem zu lösen. Wenn Streitigkeiten nicht durch unseren Kundendienst gelöst werden können, lesen Sie bitte unsere Richtlinien für das weitere Vorgehen unten.\nGeltendes Recht\nDiese Allgemeinen Geschäftsbedingungen unterliegen dem Recht der Vereinigten Staaten. Wenn Sie außerhalb der Vereinigten Staaten leben, sind Sie möglicherweise durch die vorgeschriebenen Verbraucherschutzgesetze in Ihrem Land geschützt.\nWenn Sie ein bestimmtes Problem mit uns haben, wenden Sie sich bitte an uns und wir werden uns bemühen, das Problem zu lösen. Sollte das Problem jedoch nicht gelöst werden können, so gelten die folgenden Regeln für alle Rechtsstreitigkeiten in Bezug auf Kwik und seine Produkte.\nSchiedsverfahren \nDurch die Nutzung unserer Dienste erklären Sie sich damit einverstanden, alle Streitigkeiten mit Kwik durch ein verbindliches individuelles Schiedsverfahren beizulegen. Dies bedeutet, dass Streitigkeiten von einem Schiedsrichter behandelt und nicht von einem Richter oder einer Jury entschieden werden. Sie verzichten auf jegliches Recht zur Teilnahme an Sammelklagen, Sammelschiedsverfahren oder repräsentativen Klagen. (Sammelschlichtungen sind nur möglich, wenn sie von einer der Parteien gemäß der Schiedsgerichtsordnung für Sammelklagen beantragt und vom Schiedsrichter genehmigt werden). Das Schiedsverfahren wird von der American Arbitration Association (AAA) nach den jeweils geltenden Verbraucherschiedsregeln (AAA Rules) durchgeführt, sofern nicht gesetzlich anders vorgeschrieben. Jede Partei hat das Recht, nach der endgültigen Entscheidung des Schiedsgerichts oder des Schlichters vor einem zuständigen Gericht Klage zu erheben.\nAnstelle eines Schiedsverfahrens können Sie Ihre Ansprüche auch vor einem Gericht für geringfügige Forderungen geltend machen, sofern Ihr Fall dafür in Frage kommt. Ihr Fall darf auch nur auf individueller Basis vorankommen (nicht klassenübergreifend und nicht repräsentativ). Das Bundesschiedsgerichtsgesetz (Federal Arbitration Act, FAA") und die geltenden Gesetze sind für die Auslegung und Durchsetzung dieser Geschäftsbedingungen maßgeblich. \nDie Gebühren für alle angemessenen AAA-Verfahren, einschließlich der Verwaltungs- und Schiedsrichtergebühren, werden nach den AAA-Schiedsgerichtsregeln für Verbraucher festgelegt. Wenn der Wert Ihrer Forderung 10.000 USD nicht übersteigt, übernimmt Kwik die mit dem Schiedsverfahren verbundenen angemessenen Akten-, Verwaltungs- und Schiedsgerichtskosten. Stellt der Schlichter jedoch fest, dass Ihre Forderung oder der von Ihnen angestrebte Rechtsbehelf unseriös ist oder zu einem unzulässigen Zweck vorgebracht wurde, ist Kwik nicht zur Zahlung verpflichtet. \nHaftungsbeschränkung\nWenn Sie Kwik Products nutzen, erklären Sie sich damit einverstanden, Kwik nicht für die folgenden Dinge haftbar zu machen: \nGekaufte Gegenstände und Verwendung von Gegenständen \nWenn Sie einen Artikel auf Kwik Products kaufen, erkennen Sie an, dass Sie keinen Artikel von Kwik kaufen. Artikel, die auf Kwik Products eingestellt und über Kwik Products verkauft werden, stammen von unabhängigen Verkäufern. Wenn Sie ein Problem mit dem Artikel haben, wenden Sie sich an den Verkäufer oder eröffnen Sie einen Fall bei Kwik, wie oben beschrieben. \nKwik ist nicht verantwortlich für die Folgen, die sich aus dem Gebrauch des Artikels ergeben. Wenn Ihr Gebrauch oder Missbrauch eines Artikels zu Verletzungen oder Schäden an dem Artikel führt, erklären Sie sich damit einverstanden, Kwik dafür nicht haftbar zu machen.  \nInternetseiten oder Dienste von Dritten\nInhalte von Verkäufern und Kwik-Mitgliedern können Links zu Internetseiten, Diensten, Social-Media-Seiten oder anderen Online-Marktplätzen von Dritten enthalten. Sie verstehen, dass diese nicht von Kwik kontrolliert oder beeinflusst werden. Viele dieser Websites und Dienste haben ihre eigenen Geschäftsbedingungen, denen Sie zustimmen müssen, und es liegt in Ihrer Verantwortung, diese zu kennen. Ebenso greifen Sie auf Kwik-Produkte zu, indem Sie ein Gerät wie z. B. ein Mobiltelefon benutzen, das ebenfalls nicht mit Kwik in Verbindung gebracht wird.\nInhalt und Austausch mit den Mitgliedern\nAls Kwik-Mitglied können Sie Inhalte über Ihr Profil teilen, indem Sie eine Bewertung hinterlassen oder eine Nachricht senden. Ihre Erfahrungen sind uns wichtig, und deshalb bitten wir alle Kwik-Mitglieder, sich an unsere Standards zu halten. Die von einem Mitglied eingestellten Inhalte spiegeln jedoch nicht die Meinung von Kwik wider und wir übernehmen keine Verantwortung für die eingestellten Inhalte. Kwik ist nicht verantwortlich für die Rechtmäßigkeit, die Richtigkeit, die Einhaltung des Urheberrechts oder die Einhaltung unserer Standards von Inhalten, die von Mitgliedern veröffentlicht werden, auf die Sie über unsere Produkte zugreifen. Sie entbinden Kwik von jeglicher Haftung in Bezug auf Mitgliederinhalte.\n Kwik ist auch nicht für Ihre Kontaktaufnahme mit anderen Personen über Kwik verantwortlich. Bitte haben Sie Verständnis dafür, dass wir die Benutzer unserer Produkte nicht überprüfen, obwohl Mitglieder Fälle als Reaktion auf beschädigte oder nicht gelieferte Produkte eröffnen können und Kwik ein Konto kündigen wird, wenn bestimmte Regeln verletzt werden (siehe unten). Sie entbinden Kwik von jeglicher Haftung in Bezug auf Ihre Kommunikation mit anderen Nutzern. Seien Sie bei allen Aktivitäten mit anderen auf Kwik oder anderen Diensten vorsichtig und gehen Sie mit Bedacht vor. Es ist zum Beispiel nicht immer eine gute Idee, sich mit jemandem persönlich zu treffen, mit dem man online Kontakt aufgenommen hat.\nSchadensersatz \nFür den seltenen Fall, dass Kwik aufgrund Ihrer Handlungen, der Nutzung oder des Missbrauchs unserer Produkte, der Verletzung dieser Allgemeinen Geschäftsbedingungen oder der Verletzung der Rechte eines Dritten vor Gericht gestellt wird, stimmen Sie zu, Kwik zu entschädigen. Das bedeutet, dass Sie uns gegenüber allen rechtlichen Ansprüchen oder Forderungen, einschließlich angemessener Anwaltskosten, verteidigen oder entschädigen werden (einschließlich Mitarbeiter, verbundene Unternehmen und Tochtergesellschaften). \nWir behalten uns das Recht vor, unseren Rechtsbeistand so zu gestalten, wie wir es für richtig halten. Dies gilt auch dann, wenn Sie uns entschädigen; in diesem Fall verpflichten Sie sich zur Zusammenarbeit mit uns.\nÄnderungen der Allgemeinen Geschäftsbedingungen \nWir werden Sie über wesentliche Änderungen unserer Geschäftsbedingungen 30 Tage vor deren Inkrafttreten informieren. Indem Sie Kwik Products weiterhin nutzen, erklären Sie sich mit allen Aktualisierungen einverstanden. Wenn Sie mit einer Änderung unserer Bedingungen nicht einverstanden sind, können Sie Kwik schriftlich benachrichtigen oder Ihr Konto kündigen, bevor die Änderungen in Kraft treten.\nStreitigkeiten in Bezug auf Änderungen\nWie bei allen Änderungen und Modifikationen unserer Bedingungen werden Sie benachrichtigt und haben die Wahl, die Änderungen zu akzeptieren oder sie abzulehnen, indem Sie Ihr Konto kündigen. Wenn Sie die aktualisierten Bedingungen ablehnen und eine Streitigkeit mit Kwik haben, erklären Sie sich mit der Schlichtung der Streitigkeit in Übereinstimmung mit unserer Streitbeilegungsrichtlinie einverstanden, einschließlich aller Änderungen, die vor der Ablehnung vorgenommen wurden. Wenn wir nach dem Datum, an dem Sie die Bedingungen zuletzt akzeptiert haben, Änderungen an der Streitbeilegungspolitik vornehmen, einschließlich der fortgesetzten Nutzung unserer Produkte, nachdem Sie über die Änderungen informiert wurden, gelten diese Änderungen nicht für Ansprüche, die vor dem Datum des Inkrafttretens der Änderungen in einem Gerichtsverfahren gegen Kwik eingereicht wurden. Wenn Sie Ihr Konto kündigen und es dann wieder öffnen, erklären Sie sich mit der aktuellen Version dieser Bedingungen einverstanden.\nAuflösung Ihres Kontos\nDie Auflösung Ihres Kontos kann auf zwei Arten erfolgen: durch uns oder durch Sie. Sie können Ihr Konto jederzeit über die Einstellungen Ihres Kontos löschen. Wenn Sie Ihr Konto kündigen, bleiben die von Ihnen erstellten und veröffentlichten Inhalte (wie Kommentare, Bewertungen oder hochgeladene Fotos) auf Kwik Products erhalten. Beachten Sie, dass Sie möglicherweise andere mit Ihrem Konto in Verbindung stehende Informationen verlieren.\nWir können Ihr Konto sperren oder kündigen, wenn wir Grund zu der Annahme haben, dass Sie bei der Nutzung von Kwik Products gegen diese Allgemeinen Geschäftsbedingungen verstoßen haben. Falls wir dies tun, sollten Sie wissen, dass Sie kein gesetzliches oder vertragliches Recht haben, unsere Produkte weiterhin zu nutzen. So können Sie beispielsweise nach der Kündigung Ihres Kontos nicht mehr über unseren Online-Marktplatz kaufen oder verkaufen. Sofern Sie nicht wiederholt gegen unsere Bedingungen verstoßen haben oder wir rechtliche oder politische Gründe haben, dies nicht zu tun, werden wir Sie über jede Änderung Ihres Kontos informieren.\nKwik behält sich das Recht vor, seine Produkte und die Art und Weise, wie Sie mit ihnen interagieren, einzustellen, auszusetzen oder zu ändern. Durch die Nutzung unserer Produkte verstehen Sie, dass Kwik nicht für die Auswirkungen einer Änderung oder Einstellung unserer Produkte verantwortlich ist. \nDiese Bedingungen gelten auch nach Auflösung Ihres Kontos.\nSonstige Rechtsangelegenheiten \nDiese Allgemeinen Geschäftsbedingungen ersetzen alle anderen Vereinbarungen, die Sie mit Kwik getroffen haben. Sollte ein Teil der Bedingungen nicht anwendbar sein, so wird dieser Teil auf das notwendige Mindestmaß beschränkt, und die Bedingungen bleiben ansonsten in vollem Umfang in Kraft. Wenn wir einen Teil dieser Bedingungen nicht sofort umsetzen, erkennen Sie an, dass wir uns das Recht vorbehalten, diesen oder einen anderen Teil der Bedingungen später umzusetzen.\nFragen zu den Allgemeinen Geschäftsbedingungen  \nWenn Sie Fragen zu diesen Allgemeinen Geschäftsbedingungen haben, wenden Sie sich an den Kundendienst unter support@wer1.com.',
    SHARELINK_PRODUCT_DETAIL_NO_DATA:
      "Dieses Produkt ist in deinem Land nicht verfügbar!",
    VENDOR_SHIPPING_COST_SHIPPING_METHODS: "Versandart",
    CHECKOUT_SAVE_SHIPPING_ADDRESS_MESSAGE:
      "Bitte fülle das folgende Formular aus",
    SORRY_YOUR_PAYMENT_DID_NOT_GO_THROUGH:
      "Wir konnten deine Zahlung nicht bearbeiten. Bitte versuche es erneut.",
    ORDER_HISTORY_ORDER_MORE: "Mehr bestellen",
    ORDER_HISTORY_SHARE_PRODUCT: "Produkt teilen",
    ORDER_HISTORY_EDIT_REVIEW: "Eine Bewertung bearbeiten",
    ORDER_HISTORY_ADD_REVIEW: "Eine Bewertung schreiben",
    ORDER_HISTORY_SHIPPING_DETAIL: "Versanddetails",
    ORDER_HISTORY_ARRIVAL_DATE: "Ankunftsdatum",
    ORDER_HISTORY_TRACKING_NUMBER: "Sendungsverfolgungsnummer",
    ORDER_HISTORY_ORDER_INFO: "Bestellinformationen",
    ORDER_HISTORY_TOTAL_COST: "Gesamtkosten",
    ORDER_HISTORY_ORDER_DATE: "Bestelldatum",
    ORDER_HISTORY_SHIP_DATE: "Versanddatum",
    ORDER_HISTORY_SHIP_LOCATION: "Versandort",
    CHECKOUT_PRE_VAT_SUBTOTAL: "Zwischensumme vor MwSt.",
    CHECKOUT_VAT_TOTAL: "Mehrwertsteuer Gesamt",
    CHECKOUT_PRE_VAT_SHIPPING: "Versand vor MwSt.",
    CHECKOUT_SHIPPING_VAT: "Versand Mehrwertsteuer",
    CHECKOUT_ORDER_TOTAL: "Bestellsumme",
    CHECKOUT_ORDER_INFORMATION_ERROR_MESSAGE:
      "Fehler bei der Bestellinformation, bitte wende dich an den Kundenservice.",
    SHARING_MFSP: "Am häufigsten geteilte Produkte",
    SHARING_KWIK: "Kwik",
    SHARING_ESS: "Entdecken, Einkaufen, Teilen",
    SHARING_FYNCTEM: "Finde deine nächste Kampagne, um mehr zu verdienen",
    ACCOUNT_PHONE_UNIQUE:
      "Diese Telefonnummer ist bereits mit einem Kwik-Konto verbunden. Bitte gib eine neue Telefonnummer ein",
    CHECKOUT_ADDRESS_INVALID_FORMAT: "Ungültiges Format",
    VENDOR_INVENTORY_PLEASE_SELECT_WAREHOUSE: "Bitte Lagerhaus auswählen",
    VENDOR_INVENTORY_ADD_INVENTORY_FOR_SKU: "Lagerbestand für SKU# hinzufügen",
    ORDER_HISTORY_VIEW_DETAILS: "Details anzeigen",
    VENDOR_INVENTORY_EDIT_INVENTORY: "Bestand bearbeiten",
    SHARING_NEW_TITLE: "Willkommen bei WeR1",
    VENDOR_PRODUCT_PSTCAW: "Bitte wähle das Land und das Lagerhaus aus!",
    VENDOR_PRODUCT_PSDCAW: "Bitte wähle ein anderes Land und Lagerhaus!",
    VENDOR_INVENTORY_ENTER_A_POSITIVE_OR_NEGATIVE_MESSAGE:
      "Gib eine positive oder negative Zahl ein, um die zugeteilte Menge zu erhöhen oder zu verringern.",
    VENDOR_INVENTORY_INVALID_VALUE: "Ungültiger Wert?",
    PRODUCT_DETAIL_UPPER_LIMIT_OF_THE_INVENTORY: "Obere Grenze für den Bestand",
    PRODUCTS_COPY_BUTTON: "Kopieren",
    PRODUCT_DETAIL_BACK_TO_PRODUCT_LIST: "Zurück zur Produktliste",
    NEW_PRODUCT_ID: "Neue Produkt-ID",
    NEW_PRODUCT_NAME: "Neuer Produktname",
    SHARING_TOP_DESC1: "Kaufen, Teilen, Geld verdienen mit Kwik!",
    SHARING_TOP_DESC2_1: "Befolge die",
    SHARING_TOP_DESC2_2: "Kurzanleitung",
    SHARING_TOP_DESC2_3: "unten",
    SHARING_TOP_DESC3_1: "und verdiene",
    SHARING_TOP_DESC3_2: "$5 KwikCash!",
    SHARING_CHECKBOX_1: "Erstelle ein Kwik-Konto",
    SHARING_CHECKBOX_2: "An einer Kampagne teilnehmen",
    SHARING_CHECKBOX_3: "Teile deinen Link",
    SHARING_CHECKBOX_4: "Schau dir dein KwikCash an",
    SHARING_CHECKBOX_5: "Überprüfe deine Wellen",
    SHARING_ALL_PRODUCT: "Alle Produkte teilen",
    KWIKCASH_ADD_PAYPAL: "PayPal hinzufügen",
    ERC__CLICKING_CONFIRM_MESSAGE:
      'Ich stimme den <a href="https://cms.kwik.com/Terms%26ConditionsWeR1.pdf" target=""_blank""><span>Nutzungsbedingungen</span></a> und <a href="https://cms.kwik.com/PrivacyPolicyWeR1.pdf.pdf" target=""_blank""><span>Datenschutzbestimmungen von WeR1 zu</span></a>',
    KWIKCASH_CONNECT_TO_PAYPAL: "Mit Paypal verbinden",
    KWIKCASH_PLEASE_INPUT_THE_AMOUNT: "Bitte geben Sie den Betrag ein!",
    ENTER_LOGIN_EMAIL:
      "Gib deine E-Mail ein, um loszulegen oder melde dich an!",
    I_FORGOT_PASSWORD: "Ich habe mein Passwort vergessen",
    KWIKCASH_THE_ACCOUNT_NUMBER_SHOULD_BE_EMAIL_ADDRESS:
      "Die Kontonummer sollte eine E-Mail-Adresse sein",
    REGISTER_WE_JUST_SEND_YOU_A_VERIFY_MESSAGE:
      "Wir haben dir gerade einen Bestätigungscode geschickt. Bitte schau in deinen Spam- und Werbeordner.",
    REGISTER_RESEND_CODE: "Code erneut senden",
    REGISTER_CREATE_ACCOUNT: "Konto erstellen",
    REGISTER_DONT_RECEIVED: "Noch nicht erhalten?",
    REGISTER_SIGN_IN: "Anmelden",
    REGISTER_ALREADY_A_MEMBER: "Bereits Mitglied?",
    YOUR_EMAIL: "Deine E-Mail",
    LET_FIND_LINK: "Lass uns deinen Link finden!",
    ENTER_EMAIL_FIND_LINK:
      "Gib deine E-Mail ein, damit wir sehen können, ob du einen Link hast!",
    ENTER_LOGIN_CRED: "Gib deine Anmeldedaten ein, um fortzufahren",
    SHARING_TOP_DESC2_NEW:
      "Um dir den Einstieg zu erleichtern, haben wir eine Checkliste für den Einstieg erstellt!",
    SHARING_TOP_DESC3_NEW: "Klicke HIER, um mehr über Kwik zu erfahren.",
    SHARING_NO_LINK_TO_SHARE: "Keine Links zum Teilen?",
    SHARING_ITEM_TEXT_1: "Erforsche den Kwik-Marktplatz",
    SHARING_ITEM_TEXT_2: "Kaufe ein Produkt von einer Brand, die du liebst",
    SHARING_ITEM_TEXT_3: "Teile einen Produktlink",
    SHARING_ITEM_TEXT_4: "KwikCash verdienen",
    YOU_MAY_ALSO_LIKE: "Das könnte dir auch gefallen",
    ADD_REVIEW: "Eine Bewertung hinzufügen",
    BE_FIRST_REVIEW: "Sei der Erste, der eine Bewertung abgibt",
    COMMENT: "Kommentar",
    REFERRAL_MESSAGE: "Vermittlungsnachricht",
    VERIFIED_PURCHASER: "Verifizierter Käufer",
    COMMENTS: "Kommentare",
    COPY_FROM_PROD: "Von Produkt kopieren",
    COPY_TO_PROD: "In Produkt(e) kopieren",
    KWIKCASH_PAYPAL_EMAIL_ADDRESS: "E-Mail-Adresse",
    SHARELINK_PRODUCT_DETAIL_CASHBACK_ON_PURCHASE: "Cashback beim Kauf",
    SHARE: "Teilen",
    CASHBACK_ON_PURCHASE: "Cashback beim Kauf",
    EMAIL_NOT_REGISTERED: "Diese E-Mail ist nicht registriert",
    SEND_SUCCESS: "Erfolgreich senden",
    LOGIN_KIHTM: "WeR1 ist da, um tägliche",
    LOGIN_ERE: "Empfehlungen einfacher zu machen",
    PROCEED: "Fortfahren",
    TSIPBRATGPP:
      "Diese Seite ist durch reCAPTCHA und die Google-Datenschutzrichtlinie geschützt",
    BRAND_NEW_TO_KWIK: "Brandneu bei WeR1",
    CLICK_HERE_TO_CREATE: "Hier klicken, um zu erstellen",
    LOOKING_TO_FIND_YOUR_LINK: "Dein Link wird gesucht",
    CLICK_HERE_TO_FIND_IT: "Hier klicken, um ihn zu finden",
    SHARE_INFO_LAYER_CREATE_A_SHARE_LINK: "Einen Link zum Teilen erstellen",
    SHARE_INFO_LAYER_GIVE_A_RATING: "Gib eine Bewertung ab (Optional)",
    SHARE_INFO_LAYER_ADD_A_MESSAGE: "Eine Nachricht hinzufügen (Optional)",
    SHARE_INFO_LAYER_250_WORDS_LEFT: "{{count}} Wörter übrig",
    SHARE_INFO_LAYER_ADD_ADDITIONAL_MEDIA: "Zusätzliche Medien hinzufügen",
    SHARE_INFO_LAYER_UPLOAD: "Hochladen",
    SHARE_INFO_LAYER_SHARE_YOUR_LINK: "Teile deinen Link",
    SHARE_INFO_LAYER_COPY_LINK: "Link kopieren",
    SHARE_INFO_LAYER_THE_MAXIMUM_FILE_SIZE:
      "Die maximale Dateigröße beträgt 80 MB",
    SHARE_INFO_LAYER_THE_FILE_FORMAT_IS_INCORRECT: "Das Dateiformat ist falsch",
    SHARE_INFO_LAYER_VERIFIED_PURCHASER: "Verifizierter Käufer",
    SHARE_INFO_LAYER_SUPER_AMAZING_PRODUCT: "SUPER TOLLES PRODUKT!",
    USER_HAS_GOT_PASSWORD: "Der Benutzer hat bereits ein Passwort!",
    INVALID_EMAIL: "Ungültige E-Mail-Adresse",
    HEY_WE_MISS_YOU: "Hey {{name}}, wir haben dich vermisst!",
    LAST_REMEMBER_YOU: "Wir erinnern uns noch an dich",
    SAVE_YOUR_INFO_TEXT:
      "Wir haben gehofft, dass du zurückkommst, also haben wir beschlossen, deine Daten zu speichern.",
    PHONE_HAS_REGISTERED: "Das Telefon wurde registriert",
    IMPACT_OF_YOUR_RECOMMENDATIONS_1: "Sieh die wahre Wirkung deiner",
    IMPACT_OF_YOUR_RECOMMENDATIONS_2: "Empfehlungen.",
    FULL_NAME_NOT_BE_EMPTY: "Vollständiger Name darf nicht leer sein",
    CODE_VERIFICATION: "Code-Überprüfung",
    ENTER_4_DIGIT_TIPS:
      "Bitte gib den 4-stelligen Code ein, der dir zugesandt wurde",
    CHECK_JUNK_EMAIL_FOLDER:
      "Wenn du eine E-Mail von KwikClick nicht leicht finden kannst, überprüfe bitte deinen Junk- oder Spam-Ordner. Wenn du Gmail verwendest, schaue bitte im Promotions-Tab nach.",
    PRODUCT_DETAIL_PAGE_CASHBACK_IS_THE_AMOUNT_MESSAGE:
      "Cashback ist der Betrag, den du beim Kauf dieses Produkts sofort erhältst. Er steht dir nach Ablauf der Rückgabefrist zur Verfügung.",
    LINK_HEADER_ALREADY_A_USER: "Bist du bereits Nutzer?",
    RESET_PASSWORD_PASS_RECOVERY: "Passwort-Wiederherstellung",
    RESET_PASSWORD_ENTER_EMAIL_TIPS:
      "Gib die E-Mail-Adresse ein, die du für WeR1 verwendest",
    RESET_PASSWORD_SEND_TITLE: "Setze dein Passwort zurück",
    RESET_PASSWORD_SEND_TIPS_1: "Wir haben Anweisungen gesendet an: ",
    RESET_PASSWORD_SEND_TIPS_2:
      "Wenn du die E-Mail nicht erhalten hast, frag nach erneuter Zusendung der Anweisungen.",
    RESET_PASSWORD_SEND_BTN_BACK_SIGN_IN: "Zurück zur Anmeldung",
    RESET_PASSWORD_SEND_LINK_RESEND: "Anweisungen erneut senden",
    RESET_PASSWORD_UPDATE_TIPS_SAME_PASS:
      "Das Passwort stimmt nicht mit dem Bestätigungspasswort überein",
    RESET_PASSWORD_UPDATE_TIPS_CONFIRM: "Neues Passwort bestätigen",
    RESET_PASSWORD_UPDATE_SAVE_PASS: "Passwort speichern",
    RESET_PASSWORD_SUCCESS_TIPS:
      "Dein Passwort wurde erstellt. Bitte kehre zum Anmeldefenster zurück.",
    RESET_PASSWORD_SUCCESS_LOGIN_ACCOUNT: "Melde dich in deinem Konto an",
    RESET_PASSWORD_SUCCESS_BACK_HOME: "Zurück zur Homepage",
    RESET_PASSWORD_REQUIRED_EMAIL: "E-Mail erforderlich",
    RESET_PASSWORD_RESEND_SUCCESS: "Erneut senden erfolgreich",
    RESET_PASSWORD_CHOOSE_PASSWORD: "Wähle dein neues Passwort",
    ALL_TIME: "Gesamtzeitraum",
    LAST_DAY: "Letzte {{day}} Tage",
    MY_CAMPAIGNS: "Meine Kampagnen",
    SHOW_MORE: "Mehr anzeigen",
    SHOW_LESS: "Weniger anzeigen",
    OTHER_PRODUCTS: "Andere Produkte",
    CLICK_PRODUCT_SHOW:
      "Klicke auf ein Produkt, um die dazugehörigen Daten zu sehen!",
    SEARCH_PRODUCT: "Ein Produkt suchen",
    SHOWING_PAGE: "Zeige {{Pagination}}",
    REFERRAL: "{{referral}} Empfehlungen",
    PREVIOUS: "Vorherige",
    NEXT: "Nächste",
    CASH: "Cash",
    LEARN_KWIK: "Kwik lernen",
    KWIK_TIPS: "Kwik-Tipps",
    WANT_LEARN_ABOUT: "Möchtest du erfahren, welche Daten Kwik liefert?",
    TOTAL_REFERRAL: "Insgesamt generierte Empfehlungen",
    DIRECT_REFERRAL: "Direkte Empfehlungen",
    WAVE_DEPTH: "Wave-Tiefe",
    RECENT_ADDITIONS: "Neueste Erweiterungen",
    TRANSACTIONS: "Waves",
    TOP_SHARED_PRODUCT: "Top {{count}} Geteilte Produkte",
    VIEW_ALL: "Alle anzeigen",
    TOP_COUNTRIES: "Top-Länder",
    ANALYTICS: "Analysen",
    PEOPLE_REACHED: "Erreichte Personen",
    SHARES: "Shares",
    LINK_CLICKS: "Link-Klicks",
    RECENT_SHARES: "Kürzliche Shares",
    DATE: "Datum",
    PLATFORM: "Plattform",
    OPENED: "Ansichten",
    CONVERTED: "Konvertiert",
    SIGNED_UP: "Angemeldet",
    CLAIMS: "Ansprüche",
    ORDERED: "Bestellt",
    WAVE_SOURCES: "Wave-Quellen",
    REFERRAL_SUCCESS_RATE: "Empfehlungserfolgsrate",
    OPEN_RATE: "Öffnungsrate",
    CONVERSION: "Konvertierung",
    IMPACT_RECOMMENDATIONS: "Erfolgreichste Empfehlungen",
    REFFERED_BRANDS: "Empfohlene Brands",
    REFERRED_BRANDS_DESCRIPTION:
      "Dies sind die Brands, die du an Kwik empfohlen hast.",
    SEARCH_BRAND: "Suche eine Brand",
    SELECTED_CAMPAIGN: "Ausgewählte Kampagne",
    ACTIVE_CAMPAIGN: "Aktive Kampagne",
    SELECTED_CAMPAIGN_DESCRIPTION:
      "Du siehst Daten für die Kampagne “{{campaignName}}” an",
    SELECT_SPECIFIC_CAMPAIGN:
      "Wähle eine bestimmte Kampagne aus, um nur Daten zu dieser Kampagne zu sehen.",
    SEARCH_CAMPAIGN: "Suche nach einer Kampagne",
    GENERAL_SALES_INFO:
      "Das ist der Umsatz in Dollar, den du mit deinen Empfehlungen erzielt hast.",
    KWIKCASH_INFO:
      "Dies ist der Umsatz, den du durch deine Empfehlungen verdient hast.",
    TOTAL_REFERRALS: "Gesamte Weiterempfehlungen",
    SALES_GENERATED: "Erzielte Verkäufe",
    WAVE_NUMBER: "Wave {{number}}",
    MEMBERS: "Mitglieder",
    MEMBERS_NUMBER: "Mitglieder ({{number}})",
    SEARCH_MEMBER: "Nach Mitglied suchen",
    RECENT_REFERRALS: "Neueste Empfehlungen",
    ALL_REFERRALS: "Alle Empfehlungen",
    SHOPPING_PV: "PV",
    POLICY_POLICIES: "Richtlinien",
    POLICY_VTPTTBHUTK:
      "Die Richtlinien anzeigen, die die Brand bei Kwik hochgeladen hat",
    POLICY_SHIPPING_POLICY: "Versandbedingungen",
    POLICY_TAC: "Allgemeine Geschäftsbedingungen",
    POLICY_RP: "Rückgabebedingungen",
    POLICY_PP: "Datenschutzrichtlinie",
    POLICY_NOT_SEEING:
      "Du siehst nicht, was du willst? Kontaktiere die Brand direkt",
    DASHBOARD_PROFILE_STATUS: "Erste Schritte",
    DASHBOARD_GET_5_CASHBACK:
      "Erfülle die 5 Schritte, um $5 Cashback zu verdienen!",
    DASHBOARD_COMPLETE_STEPS_EXPERT:
      "Erfülle diese Schritte, um Experte zu werden!",
    DASHBOARD_CREATE_ACCOUNT: "Erstelle ein Konto",
    DASHBOARD_ALREADY_CREATED: "Bereits erstellt",
    DASHBOARD_DONE: "Erledigt!",
    DASHBOARD_FAPOCWAB: "Finde ein Produkt oder verbinde dich mit einer Brand",
    DASHBOARD_MAKE_A_REFER: "Eine Empfehlung abgeben",
    DASHBOARD_SEE_ROLLIN: "Schön! Beobachte, wie das Geld fließt",
    DASHBOARD_SRAPTAF: "Empfehle erfolgreich ein Produkt an eine/n Freund/in",
    DASHBOARD_SHOW_ME_MONEY: "Zeig mir das Geld",
    DASHBOARD_SEE_YOUR_IMPACT: "Verfolge deinen Einfluss",
    DASHBOARD_CLAIM_REWARD: "Prämie einfordern",
    DASHBOARD_UPLOAD_IMAGE: "Bild hochladen",
    DASHBOARD_HEY: "Hey",
    DASHBOARD_WELCOME_TO_KWIK:
      "Willkommen bei WeR1! Dies ist das Dashboard. Hier erfährst du alles, was du über WeR1 wissen musst und wie du mit dem Teilen und Verdienen anfangen kannst. Außerdem gibt es in der Rubrik “Erste Schritte“ auf der rechten Seite kostenloses Geld!",
    DASHBOARD_WELCOME_TO_KWIK_MOBILE:
      "Willkommen bei WeR1! Dies ist das Dashboard. Hier erfährst du alles, was du über WeR1 wissen musst und wie du mit dem Teilen und Verdienen anfangen kannst. Außerdem gibt es in der Rubrik “Erste Schritte“ unten kostenloses Geld!",
    DASHBOARD_WELCOME_TO_KWIK2:
      "Willkommen bei WeR1! Wir freuen uns über deinen jüngsten Kauf! Wir möchten dir dabei helfen, ihn mit deinen Bekannten auf sinnvolle Weise zu teilen.",
    DASHBOARD_WELCOME_TO_KWIK3:
      "Hier könnte alles ein bisschen anders aussehen. Wenn du das letzte Update verpasst hast, klicke hier, um alle neuen Funktionen von WeR1 zu sehen!",
    DASHBOARD_WELCOME_TO_KWIK4:
      "Willkommen bei WeR1. Das ist die einfachste und lohnendste Art, Freunden und Followern deine Produkte zu empfehlen.",
    DASBOARD_LOOK_TO_THE_RIGHT: "Schau nach rechts",
    DASBOARD_LOOK_TO_BELOW: "Schau nach unten",
    DASHBOARD_SALES_GENERATED: "Generierte Verkäufe",
    DASHBOARD_VIEW_ANALYTICS: "Analysen ansehen",
    DASHBOARD_NOTIFICATION: "Benachrichtigungen",
    DASHBOARD_PURCHASED_FORM_YOUR_LINK: "Über deinen Link gekauft",
    MOST_RECENT: "Neueste",
    KWIK: "Kwik",
    KB_VERSION: "KB",
    KB_THANKYOU: "Danke!",
    KB_TITLE_01: "Neue E-Mails",
    KB_TITLE_02: "KwikCash Upgrades",
    KB_TITLE_03: "Änderungen der Seite teilen",
    KB_TITLE_04: "Kleine Verbesserungen",
    KB_TITLE_05: "Das ist alles, Leute",
    KB_TITLE_06: "Fehlerbehebungen",
    WELCOME_KWIK:
      "Willkommen zu 1.3.7! Das ist eine große Sache, denn die App hat gerade einen weitere komplette Überarbeitung bekommen. Schau dir das Update an und erfahre mehr über weitere Änderungen.",
    THANKYOU_KWIK:
      "Wir sind sehr zufrieden mit dieser Version und freuen uns schon auf die nächste. Lass uns deine Meinung unter <span>hello@wer1.com</span> wissen, wir lesen alle Kommentare und berücksichtigen sie!",
    WELCOME_KWIK_01: "Schau dir an, was es Neues gibt!",
    VERSION_DESC_01:
      "Es gibt ganz neue E-Mails bei Kwik! Sie passen zu unserem einzigartigen Stil und sind viel effektiver als die bisherigen E-Mails.",
    VERSION_DESC_02:
      "Das Geld, das mit Kwik verdient wird, ist entscheidend! Das Design spiegelt das jetzt wider.",
    VERSION_DESC_03:
      "Mit jeder neuen Version wollen wir das Teilen leichter und angenehmer machen. Schau dir also das neue Design an.",
    VERSION_DESC_04:
      "Es gibt viele kleine Änderungen in dieser Version, hier sind einige.",
    VERSION_DESC_05:
      "Vielen Dank, dass du an der Kwik-Beta teilgenommen hast. Bitte schicke dein Feedback an <span>hello@wer1.com</span>. Wir wollen deine Vorschläge hören. Viel Spaß mit 1.3.7.",
    VERSION_DESC_06:
      "In 1.3.6 gibt es viele neue Fehlerkorrekturen. Schau dir die Versionshinweise an, um mehr zu erfahren, oder schau dich einfach bei Kwik um. Alle Details wurden verbessert!",
    BASEHEADER_LINK_DASHBOARD: "Dashboard",
    NEW_SHARE_LINK_SAVE_FOR_LATER: "Für später speichern",
    NEW_SHARE_LINK_CART_TEXT_WHAT_WANT_SAVED:
      "Willst du sehen, was du gespeichert hast? ",
    NEW_SHARE_LINK_CART_TEXT_OR: " oder ",
    NEW_SHARE_LINK_CART_TEXT_CREATE_ACCOUNT: "Ein Konto erstellen",
    NEW_SHARE_LINK_CART_TEXT_SIGN_IN: "Anmelden",
    NEW_CHECKOUT_SELECT_SHIPPING_RATE: "Wähle eine Versandmethode pro Brand",
    NEW_CHECKOUT_TITLE_CART: "Warenkorb:",
    DASHBOARD_WELCOME_BACK: "Willkommen zurück",
    DASHBOARD_MY_ORDERS: "Meine Bestellungen",
    DASHBOARD_NO_ORDERS: "Keine Bestellungen",
    DASHBOARD_MADE_ORDER_TIPS:
      "Es scheint, als hättest du keine Bestellungen von einer Brand über Kwik! aufgegeben",
    DASHBOARD_RECENT_SHARE: "Zuletzt geteilt",
    DASHBOARD_SHARE_OTHER_PRODUCTS: "Andere Produkte teilen",
    DASHBOARD_SEE_MORE: "Mehr anzeigen",
    DASHBOARD_SHOW_LESS: "Weniger anzeigen",
    DASHBOARD_WELCOME: "Willkommen",
    ALREADY_SHARED_FAVOURITE:
      "Du teilst bereits deine Lieblingsprodukte. Wir machen es dir leicht, die Provisionen zu bekommen, die du verdienst.",
    SHOW_ME_HOW: "Zeig mir wie",
    ALREADY_BRAND_AMBASSADOR:
      "— Du bist bereits ein offizieller Brand-Botschafter",
    WHY_MAKE_AMBASSADOR:
      "Warum es nicht amtlich machen? Kwik gibt dir die Werkzeuge an die Hand, die du brauchst, um das Teilen und Verdienen einfach zu machen und Spaß zu haben",
    MEET_SHARE_PAGE: "— Entdecke die Share Page",
    MEET_SHARE_PAGE_DESC:
      "Sie ist dein neuer bester Freund. Hier findest du alle deine Empfehlungslinks und Produktkampagnen.",
    SHARE_PAGE_FEATURE: "— Share Page Features",
    SHEARCH_FAVOURITE_PRODUCT:
      "<ul><li>Suche deine Lieblingsprodukte und Brands, die du teilen kannst.</li><li>Teile einzelne Produkte oder den gesamten Markenkatalog.</li></ul>",
    CUSTOM_LINKS_COLLECTION: "— Benutzerdefinierte Links und Sammlungen",
    PERSONAL_SHARE_LINK:
      "<ul><li>Personalisiere deinen Share-Link mit eigenen Nachrichten, Bildern, Videos und Bewertungen. </li><li>Erstelle eine Sammlung mit mehreren Produkten, die auf gemeinsamen Interessen und Aktivitäten basieren.</li></ul>",
    GOT_IT: "Verstanden",
    MEET_KWIK_CASH: "— Lerne KwikCash kennen!",
    BEST_PART_USING_KWIK:
      "Das Beste an der Nutzung von Kwik ist das Geld! \n KwikCash wird in zwei Formen angezeigt: verfügbar und ausstehend. Die Einnahmen werden verfügbar, wenn der Rückgabezeitraum endet.",
    MONEY_MOVES: "— Geldbewegungen",
    MONEY_MOVE_DESC:
      "<ul><li>Zahlungen über ACH oder PayPal</li><li>Sieh dir dein KwikCash an und erfahre, wo du es verdient hast, wie du es ausgegeben hast und wann deine neuesten Einnahmen verfügbar sein werden.</li><li>Erfahre hier mehr über KwikCash.</li></ul>",
    MEET_CAMPAIGNS: "— Kampagnen kennenlernen",
    MEET_CAMPAIGNS_DESC:
      "Hier bringen wir unsere Blockchain-Technologie zum Einsatz. \n Wir verfolgen jeden Link, damit du die wahre Wirkung deiner Produktempfehlungen sehen kannst",
    KEY_FEATURES: "— Hauptfunktionen",
    KEY_FEATURE_DESC:
      "<ul><li>Die Daten werden in drei Levels unterteilt: alle Kampagnen, einzelne Kampagnen und einzelne Produkte.</li><li>Benutze Waves, um zu sehen, wie aus einer Empfehlung viele werden können!</li></ul>",
    ADDITIONAL_FEATURES: "— Zusätzliche Funktionen",
    ADDITIONAL_FEATURES_DESC:
      "<ul><li>Verloren? Klicke auf das 'I'-Symbol, um weitere Informationen zu erhalten.</li><li>Für weitere Details zur Funktionsweise von Waves-Einkünften oder zur Funktionsweise von Kampagnen, <a href='https://kwik.com/work' target='_blank'>klicke hier</a>.</li></ul>",
    KWIK_TEAM: "— Kwik Team",
    KWIK_TEAM_QUESTION:
      "<p>Du hast Fragen oder Feedback? Wir wollen von dir hören! Schreib uns eine E-Mail an <a href='mailto:hello@wer1.com'>hello@wer1.com</a></p><p>PS: Wir lesen jede Nachricht :) Danke, dass du uns hilfst, Kwik noch besser zu machen!</p>",
    IAMREADY: "Ich bin bereit",
    DASHBOARD_PAGE: "— Dashboard-Seite",
    DASHBOARD_DESCRIPTION:
      "<p>Dein Daten-Dashboard zeigt dir vergangene Bestellungen, Benachrichtigungen, Kampagnen und Tipps, wie du mit Produktempfehlungen Waves erzeugen kannst.</p><p>Du solltest hier einige Basisdaten finden, die dir den Einstieg erleichtern!</p>",
    I_GOT_IT: "Verstanden",
    DASHBOARD_CHECK_YOUR_EARINGS: "Schau dir deine Einkünfte an",
    DASHBOARD_BLOG_ARTICLES: "Blog / Artikel",
    SETTINGS_GENERAL_CONTACT_REFERRER_FIRST_NAME: "Vorname des Empfehlenden",
    SETTINGS_GENERAL_CONTACT_REFERRER_LAST_NAME: "Nachname des Empfehlenden",
    SETTINGS_GENERAL_CONTACT_REFERRER_NAME: "Name des Empfehlenden",
    SETTINGS_GENERAL_CONTACT_REFERRER_EMAIL: "E-Mail-Adresse des Empfehlenden",
    VENDOR_FINANCE_TABLE_HD_DATE: "Datum",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_STATUS: "Transaktionsstatus",
    VENDOR_FINANCE_TABLE_HD_TRANSACTION_METHOD: "Transaktionsmethode",
    VENDOR_FINANCE_TABLE_HD_NET_PAYMENT: "Nettozahlung",
    VENDOR_FINANCE_TABLE_HD_TYPE: "Art",
    VENDOR_FINANCE_TABLE_HD_KWIKCASH_TYPE: "Art des KwikCash",
    VENDOR_FINANCE_TABLE_HD_AMOUNT: "Betrag",
    VENDOR_FINANCE_TABLE_HD_BALANCE: "Saldo",
    CAMPAIGNS_SELECTED_KWIKCASH: "1Cash",
    CAMPAIGNS_MY_CAMPAIGNS_THESE_ARE_THE_MESSAGE:
      "Dies sind die Kampagnen, an denen du teilnimmst. Um mehr Kampagnen zu erhalten, kaufe entweder ein Produkt dieser Brand oder bewirb dich direkt bei der Marke, um Botschafter zu werden.",
    CAMPAIGNS_IMPACTFULRECOMMEND_THIS_WILL_SHOW_MESSAGE:
      "Hier siehst du, wer dir das meiste Einkommen verschafft hat, von denen, die du geworben hast.",
    DASHBOARD_SEE_LESS: "Weniger anzeigen",
    SHARELIINK_REGISTER_PASSWORD_PLACEHOLDER: "Passwort 8+ Zeichen",
    JOIN_CAMPAIGN_INFO:
      "Um an einer Kampagne teilnehmen zu können, musst du Erfahrung mit dem Produkt haben. Entweder kaufst du das Produkt, für das du werben möchtest, oder du kontaktierst den Kundendienst bezüglich früherer Käufe, die du getätigt hast, bevor du Kwik beigetreten bist. Bald gibt es mehr Möglichkeiten, einer Kampagne beizutreten.",
    MAKE_REFERRAL_INFO:
      "Teile einen Link zu einem beliebigen Produkt mit jedem. Wenn diese Person ein Produkt kauft, hast du eine erfolgreiche Empfehlung gemacht und kannst sie auf deiner Liste abhaken!",
    CHECK_EARNINGS_INFO:
      "Ganz einfach, gehe über die Navigation auf die KwikCash-Seite.",
    CHECK_WAVES_INFO: "Gehe über das Navigationsmenü auf die Kampagnenseite.",
    CAMPAIGNS_ALL_CAMPAIGNS: "Alle Kampagnen",
    CAMPAIGNS_WAVE_INSTANT_CASH_BACK: "Sofortiges Cashback",
    CAMPAIGNS_WAVE_RECENT_CASH_BACK_ORDERS: "Letzte Cashback-Bestellungen",
    CAMPAIGNS_WAVE_ALL_CASH_BACK_ORDERS: "Alle Cashback-Bestellungen",
    CAMPAIGNS_WAVE_CASHBACK_EARNED: "Verdientes Cashback",
    ALL_TIME2: "Gesamtzeitraum",
    DASHBOARD_THIS_MONTH_ITEM2: "Dieser Monat",
    LAST_DAY2: "Letzte {{day}} Tage",
    CAMPAIGNS_NO_SHARED_PRODUCTS: "Keine geteilten Produkte",
    CAMPAIGNS_NO_MADE_REFERRALS:
      "Es scheint, als hättest du noch keine Empfehlungen abgegeben.",
    CAMPAIGNS_SHARE_SOMETHING: "Etwas teilen",
    CAMPAIGNS_NO_WAVES: "Keine Waves",
    CAMPAIGNS_ONLY_WORKS:
      "Waves funktioniert nur, wenn du mit deinen Freunden teilst!",
    CAMPAIGNS_WAVE_TEXT_REFERRALS: "Weiterempfehlungen",
    YOUR_ACCOUNT_ALMOST_CREATED: "Dein Konto ist fast erstellt!",
    ORDER_DETAIL_REVIEW_CONTENT_MESSAGE: "Bitte hinterlasse deine Bewertung!",
    NEW_CHECKOUT_DELIVERY_INFORMATION: "Lieferinformationen",
    NEW_CHECKOUT_EDIT: "Bearbeiten",
    NEW_CHECKOUT_SHIPPING_METHOD: "Versandart",
    NEW_CHECKOUT_PAYMENT_METHOD: "Zahlungsmethode",
    ENTER_LOGIN_EMAIL_NEW:
      "Gib deine E-Mail-Adresse ein und wir erledigen den Rest!",
    KWIKCASH_BALANCE_TITLE_AVAILABLE: "Verfügbarer Saldo",
    KWIKCASH_BALANCE_TITLE_PENDING: "Ausstehend",
    KWIKCASH_BALANCE_SEARCH_TRANSACTION_ID: "Transaktionen / ID suchen",
    KWIKCASH_BALANCE_VIEW_TRANSACTIONS: "Transaktionen anzeigen",
    KWIKCASH_ALL_TIME: "Gesamtzeitraum",
    KWIKCASH_THIS_MONTH: "Dieser Monat",
    KWIKCASH_LAST_7_DAYS_1: "Letzte",
    KWIKCASH_LAST_7_DAYS_2: "7 Tage",
    KWIKCASH_TEXT_TRANSACTIONS: "Transaktionen",
    KWIKCASH_TEXT_JOINED_WAVES: "Verbundene Waves",
    KWIKCASH_TEXT_Earnings: "Einkünfte",
    KWIKCASH_CASH_OUT_TITLE: "Auszahlungsmethoden",
    KWIKCASH_BTN_CASH_OUT: "Auszahlung",
    KWIKCASH_ADD_PAYMENT_BTN_NEXT_STEP: "Nächster Schritt",
    KWIKCASH_ADD_PAYMENT_BTN_BACK: "Zurück",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_TITLE: "Art des Kontos wählen",
    KWIKCASH_ADD_PAYMENT_SELECT_TYPE_MSG:
      "Wähle die Art des Kontos aus, das du hinzufügen möchtest.",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_TITLE: "Bank hinzufügen",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_1: "Bitte gib unten deine Daten ein, um ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_2: "ein Bankkonto hinzuzufügen",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_3:
      "Diese Informationen werden sicher gespeichert gemäß den ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_4: "Nutzungsbedingungen & ",
    KWIKCASH_ADD_PAYMENT_ADD_BANK_MSG_5: "Datenschutzbestimmungen",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_1:
      "Bitte gib die nachstehenden Daten ein, um ",
    KWIKCASH_ADD_PAYMENT_ADD_PAYPAL_MSG_2: "ein PayPal-Konto hinzuzufügen",
    KWIKCASH_CASH_OUT_TRANSFER_AMOUNT: "Betrag überweisen",
    KWIKCASH_CASH_OUT_MSG1:
      "*Du kannst den Betrag ganz einfach auf eines der verknüpften Konten überweisen",
    KWIKCASH_CASH_OUT_METHOD: "Auszahlungsmethoden",
    KWIKCASH_CASH_OUT_MSG21: "Leg los, indem du deine erste ",
    KWIKCASH_CASH_OUT_MSG22: "Auszahlungsmethode",
    KWIKCASH_CASH_OUT_MSG23: "hinzufügst",
    KWIKCASH_CASH_OUT_ADD: "Methode hinzufügen",
    KWIKCASH_CASH_OUT_LEARN_MORE: "Mehr erfahren",
    KWIKCASH_TRANSACTION_STATUS_TIPS_DELIVERED: "Du solltest dein Geld haben!",
    KWIKCASH_TRANSACTION_STATUS_TIPS_INPROCESS:
      "Die Auszahlung durchläuft gerade den Prozess, um auf deinem Konto anzukommen",
    KWIKCASH_TRANSACTION_STATUS_TIPS_CANCELED:
      "Diese Auszahlung wurde storniert",
    KWIKCASH_TRANSACTION_STATUS_TIPS_ONHOLD:
      "Die Auszahlung wird gerade von unserem Team überprüft. Alle Auszahlungen über 500 $ werden vom Kwik-Team überprüft. Es sollte weniger als 24 Stunden dauern.",
    KWIKCASH_TRANSACTION_CASH_OUT: "Auszahlungstransaktionen",
    KWIKCASH_TRANSACTION_EXPORT: "Export",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TYPE: "Art",
    KWIKCASH_TRANSACTION_TABLE_HEADER_DATE: "Datum",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_ID: "Transaktions-ID",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AMOUNT: "Betrag",
    KWIKCASH_TRANSACTION_TABLE_HEADER_STATUS: "Status",
    KWIKCASH_TRANSACTION_TABLE_HEADER_TRANSACTION_TYPE: "Transaktionsart",
    KWIKCASH_TRANSACTION_TABLE_HEADER_BALANCE: "Saldo",
    KWIKCASH_TRANSACTION_TABLE_HEADER_WAVE: "Wave",
    KWIKCASH_TRANSACTION_TABLE_HEADER_INFLUENCER: "Influencer",
    KWIKCASH_TRANSACTION_TABLE_HEADER_AVAILABLE_DATE: "Verfügbares Datum",
    KWIKCASH_TRANSACTION_NO_DATA_TITLE: "Keine Transaktion zum Anzeigen",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION1:
      "Beginne damit, deine Produkte mit Freunden zu teilen, um ",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION2: "1Cash zu verdienen",
    KWIKCASH_TRANSACTION_NO_DATA_DESCRIPTION3:
      " Dann lass dir deine Einnahmen auszahlen und sie werden hier angezeigt :)",
    KWIKCASH_TRANSACTION_NO_DATA_BTN_START_SHARING: "Mit dem Teilen beginnen",
    KWIKCASH_TRANSACTION_DETAIL_BACK: "Zurück",
    KWIKCASH_TRANSACTION_DETAIL_TRANSACTIONS: "Transaktionen",
    KWIKCASH_TRANSACTION_DETAIL_NO_DATA: "Keine Transaktion zum Anzeigen",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION1:
      "Beginne damit, deine Produkte mit Freunden zu teilen, um ",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION2: "KwikCash verdienen",
    KWIKCASH_TRANSACTION_DETAIL_DESCRIPTION3:
      " Dann lass dir deine Einnahmen auszahlen und sie werden hier angezeigt :)",
    KWIKCASH_VERIFY_NUMBER_TEXT_1:
      "Bevor du mit 1Cash weitermachst, überprüfe bitte deine",
    KWIKCASH_VERIFY_NUMBER_TEXT_2: " E-Mail-Adresse",
    KWIKCASH_VERIFY_NUMBER_BTN: "Jetzt verifizieren",
    KWIKCASH_CASH_OUT_TIPS_SELECT_CARD: "Bitte wähle eine Bankkarte aus!",
    KWIKCASH_CASH_OUT_MINIMUM_AMOUNTS:
      "Mindestbeträge sollten {{currency}}{{amount}} sein!",
    KWIKCASH_CASH_OUT_TIPS_AMOUNT_INVALID:
      "Du kannst nicht mehr als dein verfügbares Guthaben auszahlen",
    KWIKCASH_CASH_OUT_TIPS_SENT_SUCCESS: "Code erfolgreich gesendet",
    KWIKCASH_CASH_OUT_MODAL_TITLE: "Auszahlung",
    KWIKCASH_CASH_OUT_TIPS_MSG1: "Bitte gib deinen",
    KWIKCASH_CASH_OUT_TIPS_MSG2: "4-Ziffern-Code ein",
    KWIKCASH_CASH_OUT_TIPS_MSG3: "zur Auszahlung",
    KWIKCASH_CASH_OUT_TITLE_VERIFY: "Auszahlung verifizieren",
    KWIKCASH_CASH_OUT_TIPS_SENT_TO1: "Code wird gesendet an ",
    KWIKCASH_CASH_OUT_TIPS_DONT_RECEIVE: "Hast du keinen Code erhalten? ",
    KWIKCASH_CASH_OUT_LINK_REQUEST_AGAIN: "Erneut anfordern",
    KWIKCASH_CASH_OUT_CONTENT_MSG1: "Wähle deine ",
    KWIKCASH_CASH_OUT_CONTENT_MSG2: "Auszahlungsmethode",
    KWIKCASH_CASH_OUT_CONTENT_MSG3:
      " dann gib den Betrag ein und drücke auf Überweisen!",
    KWIKCASH_CASH_OUT_AVAILABLE_BALANCE: "Verfügbarer Saldo",
    KWIKCASH_CASH_OUT_SELECT_METHOD: "Wähle eine Auszahlungsmethode",
    KWIKCASH_CASH_OUT_TO_CITY_BANK: "An City Bank",
    KWIKCASH_CASH_OUT_TITLE_SUCCESS: "Überweisung erfolgreich!",
    KWIKCASH_CASH_OUT_SUCCESS_MSG1:
      "Deine Zahlung wurde erfolgreich überwiesen, ",
    KWIKCASH_CASH_OUT_SUCCESS_MSG2: "die Bearbeitung dauert ",
    KWIKCASH_CASH_OUT_SUCCESS_MSG3: "9-10 Arbeitstage",
    KWIKCASH_VERIFY_ENTER_EMAIL: "Bitte gib eine gültige E-Mail-Adresse ein",
    KWIKCASH_VERIFY_ENTER_4_CODE: "Bitte gib den 4-stelligen Code ein",
    KWIKCASH_VERIFY_EMAIL: "E-Mail verifizieren",
    KWIKCASH_VERIFY_TIPS_1:
      "Wir senden dir einen Code an deine E-Mail-Adresse, um zu überprüfen, ob sie dir gehört",
    KWIKCASH_VERIFY_TIPS_ENTER_EMAIL: "Bitte gib deine E-Mail-Adresse ein",
    KWIKCASH_VERIFY_MAKE_SURE_EMAIL:
      "Bitte vergewissere dich, dass du die richtige E-Mail-Adresse eingegeben hast.",
    KWIKCASH_VERIFY_CODE_SENT_TO: "Der Code wurde gesendet an ",
    KWIKCASH_VERIFY_ENTER_EMAIL_CHECK:
      "Die E-Mail-Adresse muss die Anmelde-E-Mail-Adresse sein",
    KWIKCASH_ADD_DIFFERENT_NUM: "Die beiden Kontonummern sind unterschiedlich",
    KWIKCASH_ADD_SELECT_PAYMENT: "Bitte wähle eine Zahlungsart",
    KWIKCASH_ADD_ACCOUNT_ADDED: "Bankkonto hinzugefügt",
    KWIKCASH_ADD_ADDED_TIPS_1:
      "Sieht so aus, als wärst du startklar! Dein Bankkonto wird jetzt als Auszahlungsoption angezeigt! Viel Spaß mit deinem Geld :)",
    KWIKCASH_ADD_ADDED_PAYPAL: "PayPal-Konto hinzugefügt",
    KWIKCASH_ADD_ADDED_TIPS_PAYPAL_1:
      "Sieht so aus, als wärst du startklar! Dein PayPal-Konto wird jetzt als Auszahlungsoption angezeigt! Viel Spaß mit deinem Geld :)",
    KWIKCASH_ADD_VERIFY_TIPS_1: "Bitte gib deinen 4-stelligen ",
    KWIKCASH_ADD_VERIFY_TIPS_2: "Zifferncode ein ",
    KWIKCASH_ADD_VERIFY_TIPS_3: "um ",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_PAYPAL: "PayPal hinzuzufügen",
    KWIKCASH_ADD_VERIFY_TIPS_ADD_BANK: "Bank hinzufügen",
    KWIKCASH_EDIT_BANK_ACCOUNT: "Bankkonto bearbeiten",
    KWIKCASH_EDIT_VERIFY_REALLY_YOU: "Bestätige, dass du das wirklich bist",
    KWIKCASH_EDIT_PAYPAL_ACCOUNT: "PayPal Konto bearbeiten",
    KWIKCASH_EDIT_PAYPAL_MSG_1:
      "Diese Informationen werden sicher gespeichert gemäß den ",
    KWIKCASH_EDIT_PAYPAL_MSG_2: "Allgemeinen Geschäftsbedingungen & ",
    KWIKCASH_EDIT_PAYPAL_MSG_3: "Datenschutzbestimmungen",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_1: "Bitte bestätige, dass du das bist, um ",
    KWIKCASH_EDIT_PAYPAL_VERIFY_MSG_2: "Ein PayPal-Konto zu bearbeiten",
    KWIKCASH_EDIT_BANK_VERIFY_MSG_2: "Ein Bankkonto zu bearbeiten",
    KWIKCASH_TIPS_SELECT_COUNTRY: "Bitte wähle ein Land",
    KWIKCASH_TIPS_SELECT_CURRENCY: "Bitte wähle eine Währung",
    KWIKCASH_MANAGE_CASH_OUT_METHOD: "Verwalte deine Auszahlungsmethoden",
    KWIKCASH_CASH_OUT_METHOD2: "Auszahlungsmethoden",
    KWIKCASH_ITS_EASY: "Es ist super einfach!",
    KWIKCASH_MANAGE_BTN_ADD: "+ Hinzufügen",
    KWIKCASH_MANAGE_BTN_EDIT: "Bearbeiten",
    KWIKCASH_MANAGE_BTN_CANCEL: "Abbrechen",
    KWIKCASH_MANAGE_TIPS_SELECT_METHOD:
      "Wähle eine Auszahlungsmethode zum Bearbeiten",
    KWIKCASH_MANAGE_REMOVE_PAYPAL: "PayPal entfernen",
    KWIKCASH_MANAGE_REMOVE_CARD: "Konto entfernen",
    KWIKCASH_MANAGE_TO_REMOVE_PAYPAL: ", um dein PayPal zu entfernen",
    KWIKCASH_MANAGE_TO_REMOVE_CARD: " um deine Konto zu entfernen",
    KWIKCASH_MANAGE_VERIFY_REMOVE: "Verifizieren, um zu entfernen ",
    KWIKCASH_MANAGE_VERIFY_TO: "Verifizieren, um ",
    KWIKCASH_MANAGE_WORD_PAYPAL: "PayPal",
    KWIKCASH_MANAGE_WORD_CARD: "Konto",
    KWIKCASH_MANAGE_WORD_BANK: "Bank",
    KWIKCASH_MANAGE_ACCOUNT_REMOVED: " Konto entfernt",
    KWIKCASH_MANAGE_REMOVE_TIPS_1:
      "Sobald du eine Karte entfernst, wird sie aus Kwik gelöscht.",
    KWIKCASH_MANAGE_BANK_ACCOUNT_UPDATED: "Bankkonto aktualisiert",
    KWIKCASH_MANAGE_PAYPAL_ACCOUNT_UPDATED: "PayPal-Konto aktualisiert",
    KWIKCASH_MANAGE_BTN_ADD_ACCOUNT: "Konto verifizieren & hinzufügen",
    KWIKCASH_BTN_CONFIRM_NUMBER: "Nummer bestätigen",
    KWIKCASH_BTN_CONFIRM_EMAIL: "E-Mail-Adresse bestätigen",
    VENDOR_SETTINGS_UP: "Nutzer & Berechtigungen",
    VENDOR_SETTINGS_MWUCSODIYS:
      "Verwalten, was Nutzer in deinem Shop sehen oder tun können",
    VENDOR_SETTINGS_BRAND_OWER: "Brand-Eigentümer",
    VENDOR_SETTINGS_ADDS_MEMBERS_TIPS: "Hinzugefügte Mitglieder (bis zu 15)",
    VENDOR_SETTINGS_NO_DATA_TIPS:
      "Du hast noch keine Benutzer hinzugefügt. Bitte füge Benutzer hinzu, um Details zu sehen",
    VENDOR_SETTINGS_LAST_LOGIN: "Letzter Login war",
    VENDOR_SETTINGS_ADD_USERS: "Benutzer hinzufügen",
    VENDOR_SETTINGS_EDIT_USERS: "Benutzer bearbeiten",
    VENDOR_SETTINGS_ETU_GOVERNMENTID:
      "Gib den Vor- und Nachnamen des Benutzers so ein, wie er im Personalausweis steht.",
    VENDOR_SETTINGS_SELECT_PERMISSIONS: "Berechtigungen auswählen",
    VENDOR_SETTINGS_SELECT_ALL: "Alle auswählen",
    VERSION_DETAIL_01: "Händler-Bio",
    VERSION_DETAIL_02: "Kurzbeschreibungen entfernen",
    VERSION_DETAIL_03: "Informationen zu Händlerempfehlungen",
    VERSION_DETAIL_04: "Keine Namen bei Bewertungen",
    VERSION_DETAIL_05: "Einkaufswagen bearbeiten",
    VERSION_DETAIL_06: "Händler-Logo auf dem Bildschirm nach dem Kauf anzeigen",
    VERSION_DETAIL_07: "Grammatikkorrekturen",
    VERSION_DETAIL_08: "Falsche Daten",
    VERSION_DETAIL_09: "Produktspezifische Daten anzeigen",
    INVALID_LINK: "Ungültiger Link",
    ORDER_LIST_ORDER_DATE: "Bestelldatum",
    VENDOR_ACCEPTING_ORDERS_STEP_1: "SCHRITT 1",
    VENDOR_ACCEPTING_ORDERS_STEP_2: "SCHRITT 2",
    VENDOR_ACCEPTING_ORDERS_STEP_3: "SCHRITT 3",
    VENDOR_ACCEPTING_ORDERS_STEP_4: "SCHRITT 4",
    VENDOR_ACCEPTING_ORDERS_STEP_5: "SCHRITT 5",
    VENDOR_ACCEPTING_ORDERS_STEP_6: "SCHRITT 6",
    VENDOR_ACCEPTING_ORDERS_TITLE_1:
      "Einrichten, von wo aus deine Produkte versendet werden",
    VENDOR_ACCEPTING_ORDERS_TITLE_2: "Produkte hinzufügen",
    VENDOR_ACCEPTING_ORDERS_TITLE_3: "Deine Kampagnen anpassen",
    VENDOR_ACCEPTING_ORDERS_TITLE_4: "Lege deine Versandtarife fest",
    VENDOR_ACCEPTING_ORDERS_TITLE_5: "Deine Brand anpassen",
    VENDOR_ACCEPTING_ORDERS_TITLE_6: "Deine Brand anpassen",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_1:
      "Das stellt sicher, dass die Menge richtig verfolgt wird und hilft bei der Koordination des Versands. Wir haben bereits eine Adresse als deine Geschäftsadresse festgelegt. Aktualisiere sie, wenn sie falsch ist oder du mehr als einen Standort hast.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_2:
      "Sag uns, welche deiner Produkte du kwikifizieren möchtest, und wir kümmern uns darum! Wir brauchen nur ein paar Informationen zu jedem Produkt, das du möchtest. Füge diese Informationen mit unserem Shopify Plugin, CVS Import oder manuell hinzu.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_3:
      "Es ist einfacher, eine einzige Kampagne zu haben, deshalb haben wir sie bereits standardmäßig so eingerichtet. Das heißt, wenn jemand deiner Kampagne beitritt, kann er alle deine Produkte teilen. Wenn du sie in verschiedene Kampagnen aufteilen möchtest, kannst du das gerne tun!",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_4:
      "Dieser Schritt ist nur erforderlich, wenn du am Kwik-Marktplatz teilnehmen möchtest. Wenn du daran interessiert bist, klicke einfach hier und wir zeigen dir die Vorteile :) Wenn nicht, klick dich einfach durch und alles wird gut! ",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_5:
      "Wir brauchen ein paar deiner coolen Brand-Designs, um das Erlebnis deiner Kunden bei Kwik noch besser zu machen. Gib uns ein paar Farben, Bilder, Bio usw.",
    VENDOR_ACCEPTING_ORDERS_MESSAGE_6:
      "Wir brauchen ein paar deiner coolen Brand-Designs, damit deine Kunden Kwik noch besser kennenlernen können. Gib uns ein paar Farben, Bilder, Bio usw.",
    VENDOR_ACCEPTING_ORDERS_BTN_11_NAME: "Lagerhaus bearbeiten",
    VENDOR_ACCEPTING_ORDERS_BTN_21_NAME: "Produkte hinzufügen",
    VENDOR_ACCEPTING_ORDERS_BTN_31_NAME: "Kampagnen anpassen",
    VENDOR_ACCEPTING_ORDERS_BTN_41_NAME: "Versandtarife festlegen",
    VENDOR_ACCEPTING_ORDERS_BTN_42_NAME: "Ich bin nicht interessiert",
    VENDOR_ACCEPTING_ORDERS_BTN_51_NAME: "Meine Brand anpassen",
    VENDOR_ACCEPTING_ORDERS_BTN_61_NAME: "Mein Bankkonto anpassen",
    VENDOR_ACCEPTING_ORDERS_MENU_1: "Deine Lagerhäuser anpassen",
    VENDOR_ACCEPTING_ORDERS_MENU_2: "Produkte hinzufügen",
    VENDOR_ACCEPTING_ORDERS_MENU_3: "Deine Kampagnen anpassen",
    VENDOR_ACCEPTING_ORDERS_MENU_4: "Deine Kampagnen einrichten",
    VENDOR_ACCEPTING_ORDERS_MENU_5: "Deine Brand anpassen",
    VENDOR_ACCEPTING_ORDERS_MENU_6: "Verbinde dein Bankkonto",
    VENDOR_ACCEPTING_ORDERS_TEXT_OF_6: " von 6",
    VENDOR_ACCEPTING_ORDERS_TEXT_COMPLETED: " Abgeschlossen",
    VENDOR_ANALYTIC_REPORT_TITLE: "Analytischer Bericht",
    VENDOR_ANALYTIC_REPORT_TITLE_1: "Gesamtumsatz",
    VENDOR_ANALYTIC_REPORT_TITLE_2: "Bestellungen insgesamt",
    VENDOR_ANALYTIC_REPORT_TITLE_3: "Neue Kunden",
    VENDOR_ANALYTIC_REPORT_TITLE_4: "Kunden teilen",
    VENDOR_ANALYTIC_REPORT_TIPS_1: "-----",
    VENDOR_OVERVIEW_COMPLETE_STEP_TITLE: "Einrichtung abschließen",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_TITLE:
      "Richte deine Steuersätze ein",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_MESSAGE:
      "Wir müssen sicherstellen, dass du rechtmäßig arbeitest und bereit bist, Steuern zu zahlen",
    VENDOR_OVERVIEW_COMPLETE_STEP_TAX_RATES_BTN_NAME: "Steuersatz festlegen",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_TITLE: "Botschafter hinzufügen",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_MESSAGE:
      "Du hast keine zusätzlichen Sharer, gib einigen deiner treuen Kunden einen Link",
    VENDOR_OVERVIEW_COMPLETE_STEP_ADD_BTN_NAME: "Benutzer hinzufügen",
    VENDOR_OVERVIEW_CUSTOMIZATION_TITLE: "Anpassen",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_TITLE: "Passe deine Brand an",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_MESSAGE:
      "Aktualisiere die Farben und Logos, die du den Nutzern zeigen willst. Mach deine Marke zu deiner.",
    VENDOR_OVERVIEW_CUSTOMIZATION_BRAND_BTN_NAME: "Anpassen",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_TITLE:
      "Füge deine Finanzdaten hinzu",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_MESSAGE:
      "Stelle sicher, dass du dein Geld für Verkäufe bekommst und eine Methode hast, um die Verkäufer deiner Produkte zu bezahlen!",
    VENDOR_OVERVIEW_CUSTOMIZATION_FINANCES_BTN_NAME: "Jetzt aktualisieren",
    VENDOR_OVERVIEW_EARNERS_TITLE: "Topverdiener",
    VENDOR_OVERVIEW_TABLE_TITLE: "Meistverkaufte Produkte",
    VENDOR_OVERVIEW_TABLE_HEADER_1: "Bild",
    VENDOR_OVERVIEW_TABLE_HEADER_2: "Produktname",
    VENDOR_OVERVIEW_TABLE_HEADER_3: "Bestand",
    VENDOR_OVERVIEW_TABLE_HEADER_4: "Preis",
    VENDOR_OVERVIEW_TABLE_HEADER_5: "Verkäufe",
    VENDOR_OVERVIEW_TABLE_HEADER_6: "KwikCash-Wert",
    SHOP_BY_CATEGORY: "Shoppen nach Kategorien",
    NEWEST_PRODUCTS: "Neueste Produkte",
    PRODUCT_YOU_MIGHT_LIKE: "Produkte, die dir gefallen könnten",
    HIGHEST_KCASH: "Höchstes 1Cash",
    HIGHEST_INS_CASHBACK: "Höchstes Instant Cashback",
    SEE_ALL: "Alle anzeigen",
    NEW_BRANDS_ON_KWIK: "Neue Brands bei Kwik",
    SHOP_BY_BRAND: "Nach Brand shoppen",
    SHOPPING_EMAIL_TITLE1:
      "Willst du wissen, wann neue Brands auf den Markt kommen?",
    SHOPPING_EMAIL_DESC1:
      "Lass dich benachrichtigen, wenn neue Brands bei Kwik auf den Markt kommen und sei der Erste, der einen Link erhält!",
    SHOPPING_EMAIL_TITLE2: "Deine Empfehlung reicht weit",
    SHOPPING_EMAIL_DESC2:
      "Ein Produkt zu finden, das du liebst, ist der erste Schritt, um eine Empfehlung abzugeben!",
    SHOPPING_EMAIL_DESC3:
      "Finde ein Produkt, das du gerne benutzt, und Kwik macht es dir leicht, es deinen Freunden zu empfehlen und dafür bezahlt zu werden!",
    ALL: "Alle",
    RECENT_PURCHASES: "Kürzliche Einkäufe",
    RECENTLY_PURCHASED_PRODUCTS: "Kürzlich gekaufte Produkte",
    PAGE: "Seite",
    PREV: "Vorherige",
    TOP_SHARED_PRODUCTS: "Top geteilte Produkte",
    YOUR_PRODUCTS: "Deine Produkte",
    MOST_EARNED: "Am meisten verdient",
    MOST_SHARED: "Am meisten geteilt",
    SEARCH: "Suche",
    SEARCH_BY_PRODUCT_NAME: "Suche nach Produktname",
    CAMPAIGNS_YOU_HAVENT_JOINED_TEXT:
      "Du bist noch keiner Kampagne beigetreten :(",
    CAMPAIGNS_FIND_PRODUCTS_OR_CONNECT_TEXT:
      "Finde Produkte oder verbinde dich mit Brands, um Links zu erhalten!",
    CAMPAIGNS_FIND_THE_BRANDS_TEXT: "Finde die Brands",
    CAMPAIGNS_SHARES: "Shares",
    CAMAPIGNS_NO_DATA: "Keine Daten",
    CAMPAIGNS_LOOKS_LIKE_YOU_HAVE_MESSAGE:
      "Sieht so aus, als hättest du noch keine Empfehlungen abgegeben.",
    CAMPAIGNS_LEARN_MORE_AT: "Erfahre mehr unter",
    CAMPAIGNS_SALES_FROM: "Verkäufe ab",
    DESCRIPTION: "Description",
    INGREDIENTS: "Ingredients",
    USAGE: "Usage",
    MANUFACTURER: "Manufacturer",
    SHIPPING: "Shipping",
    CONGRATULATIONS: "Order Complete!",
    STANDARD: "Standard",
    FIELD_NAME_IBAN: "IBAN",
    FIELD_NAME_RE_IBAN: "Re-IBAN",
    FIELD_NAME_SORT_CODE: "Sort Code",
    FIELD_NAME_STATE: "State",
    FIELD_NAME_SWIFT_CODE: "Swift Code",
    FIELD_NAME_ZIP_CODE: "Postal Code",
    FIELD_RE_ACCOUNT_NUMBER: "Re-Enter Account Number",
    FIELD_SWIFT_CODE: "SWIFT",
    FIELD_BIC: "BIC",
    FIELD_BIC_CODE_SORT: "BIC/Sort Code",
    FIELD_BANK_BSB: "BSB",
    CANCEL: "Cancel",
    OK: "Ok",
    REFUND: "Refund",
    DELETE: "Delete",
    HEADER_SHOPPING: "Shopping",
    HELP: "Help",
    FIELD_REQUIRED: "This field is required",
    ACCONT_CONFIRM:
      "Changes to this type of account may require you to confirm the account. This will be done by entering the amounts of two small deposits into the account.",
    SS_FOOTER_MAIL_TO: "mailto:support@wer1.com",
    SS_FOOTER_HELLO_EMAIL: "hello@wer1.com",
    ORDER_AGAIN: "Order Again",
    VENDOR_SETTINGS_REFERRAL_NAME: "Referrer's Name",
    VENDOR_ACCEPTING_ORDERS_BTN_PREVIOUS: "Previous Step",
    VERSION_DETAIL_01_3_0_2: "Order Date in Order History",
    VERSION_DETAIL_02_3_0_2: "Share page keeps data when changing countries",
    VERSION_DETAIL_03_3_0_2: "Accurate numbers in product categories",
    VERSION_DETAIL_04_3_0_2: "Can’t share removed products",
    VERSION_DETAIL_05_3_0_2: "Campaigns search message",
    VERSION_DETAIL_06_3_0_2: "Available dates for pending Kwikcash",
    VERSION_DETAIL_07_3_0_2: "Post-purchase coin animation for guest users",
    VERSION_DETAIL_08_3_0_2:
      "Image shows in order history for removed products",
    VERSION_DETAIL_09_3_0_2:
      "Terms, Conditions, and Privacy Policy links updated",
    VERSION_DETAIL_10_3_0_2: "Typos!",
    VERSION_DETAIL_11_3_0_2: "Exported reports show countries for brands",
    VERSION_DETAIL_12_3_0_2:
      "Phone Number field is mandatory during brand sign up",
    VERSION_DETAIL_13_3_0_2: "Min & Max on vendor cashouts",
    VERSION_DETAIL_14_3_0_2: "Fixed vendor cash out issues",
    VERSION_DETAIL_15_3_0_2: "Added vendor password reset option",
    USER_SETTING_ACCOUNT_SETTINGS: "Account Settings",
    USER_SETTING_UPDATE_PROFILE: "Update Profile",
    USER_SETTING_ACCOUNT_INFO: "Account info",
    USER_SETTING_PUBLIC_ACCOUNT_NAME: "Public Account Name",
    USER_SETTING_PUBLIC_ACCOUNT_NAME_IS_REQUIRED:
      "Public Account Name is required",
    USER_SETTING_USERNAME: "Username",
    USER_SETTING_PUBLIC_ACCOUNT_USERNAME_IS_REQUIRED:
      "Public Account Username is required",
    USER_SETTING_CONTACT_DETAIL: "Contact Detail",
    USER_SETTING_EMAIL_ADDRESS: "Email Address",
    USER_SETTING_UPDATE_EMAIL_ADDRESS: "Update Email Address",
    USER_SETTING_UPDATE: "Update",
    USER_SETTING_PHONE_NUMBER: "Phone number",
    USER_SETTING_UPDATE_PHONE_NUMBER: "Update Phone Number",
    USER_SETTING_LOGIN: "Login",
    USER_SETTING_PASSWORD: "Password",
    USER_SETTING_LAST_UPDATED_AGO: "Last updated {{lastUpdatePwd}} ago",
    USER_SETTING_UPDATE_PASSWORD: "Update Password",
    USER_SETTING_LANGUAGE: "Language",
    USER_SETTING_UPDATE_LANGUAGE: "Update Language",
    USER_SETTING_COUNTRY: "Country",
    USER_SETTING_UPDATE_COUNTRY: "Update Country",
    USER_SETTING_ACCOUNT_DETAILS: "Account Details",
    USER_SETTING_THESE_CAN_BE_USED_TO_MAKE_MESSAGE:
      'These can be used to make sure that it\'s really you signing in or to contact you. To update these details contact our <a target="_blank" href="mailto:support@wer1.com">Customer Support</a>',
    USER_SETTING_LEGAL_NAME: "Legal Name",
    USER_SETTING_RECENT_LOGIN: "Recent Login",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER1:
      "{{sessionNum}} Session on {{system}} Computer",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_COMPUTER2:
      "{{sessionNum}} Sessions on {{system}} Computer",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE1:
      "{{sessionNum}} Session on {{system}} mobile phone",
    USER_SETTING_NUM_SESSION_ON_SYSTEM_MOBILE2:
      "{{sessionNum}} Sessions on {{system}} mobile phone",
    USER_SETTING_CHANGE_PASSWORD: "Change Password",
    USER_SETTING_ENTER_THE_DETAILS_BELOW_MESSAGE:
      "Enter the details below to <span>Change password</span> on WeR1.",
    USER_SETTING_ENTER_CURRENT_PASSWORD: "Enter Current Password",
    USER_SETTING_CURRENT_PASSWORD_IS_REQUIRED: "Current Password is required",
    USER_SETTING_INCORRECT_PASSWORD_FORMAT: "Incorrect password format",
    USER_SETTING_YOUR_NEW_PASSWORD: "Your New Password",
    USER_SETTING_NEW_PASSWORD_IS_REQUIRED: "New Password is required",
    USER_SETTING_RE_ENTER_YOUR_NEW_PASSWORD: "Re-Enter Your New Password",
    USER_SETTING_INCONSISTENT_PASSWORDS: "Inconsistent passwords",
    USER_SETTING_THIS_INFORMATION_WILL_BE_MESSAGE:
      'This information will be securely saved as per  the <span><a href="https://help.kwik.com/en/support/solutions/70000319669" target="_blank"><u>Terms of Service & Privacy Policy </u></a></span>',
    USER_SETTING_BACK: "Back",
    USER_SETTING_PASSWORD_SUCCESSFULLY_CHANGED: "Password Successfully Changed",
    USER_SETTING_YOU_CAN_NOW_USE_YOUR_MESSAGE:
      "You can now use your new password to <span>Log in to your account</span>",
    USER_SETTING_CHOOSE_A_LANGUAGE: "Choose a Language",
    USER_SETTING_YOUR_LANGUAGE_WILL_MESSAGE:
      "Your language will save the next time you load Kwik.",
    USER_SETTING_DEFAULT: "Default",
    USER_SETTING_SAVE: "Save",
    USER_SETTING_CHOOSE_A_COUNTRY: "Choose a Country",
    USER_SETTING_YOUR_COUNTRY_WILL_MESSAGE:
      "Your Country will save the next time you load Kwik.",
    USER_SETTING_MENU_SAVED_INFORMATION: "Saved Information",
    USER_SETTING_MENU_ADDRESSES: "Addresses",
    USER_SETTING_MENU_CASH_OUT_METHODS: "Cash Out Methods",
    USER_SETTING_MENU_PRIVACY_SETTINGS: "Privacy Settings",
    USER_SETTING_MENU_NOTIFICATION: "Notification",
    USER_SETTING_ADD_ADDRESS: "Add Address",
    USER_SETTING_ZIP_CODE: "Zip code",
    USER_SETTING_EDIT: "Edit",
    USER_SETTING_REMOVE: "Remove",
    USER_SETTING_SUBMIT: "Submit",
    USER_SETTING_PHONE_NUMBER2: "Phone Number",
    USER_SETTING_PHONE_NUMBER_IS_REQUIRED: "Phone Number is required",
    USER_SETTING_NAME: "Name",
    USER_SETTING_NAME_IS_REQUIRED: "Name is required",
    USER_SETTING_ADDRESS: "Address",
    USER_SETTING_ADDRESS_IS_REQUIRED: "Address is required",
    USER_SETTING_APARTIMENT_SUITE_ETC_OPTIONAL:
      "Apartment, Suite, Etc. (Optional)",
    USER_SETTING_CITY: "City",
    USER_SETTING_CITY_IS_REQUIRED: "City is required",
    USER_SETTING_STATE: "State",
    USER_SETTING_STATE_IS_REQUIRED: "State is required",
    USER_SETTING_POSTAL_CODE: "Postal Code",
    USER_SETTING_POSTAL_CODE_IS_REQUIRED: "Postal Code is required",
    USER_SETTING_EMAIL: "Email",
    USER_SETTING_EMAIL_IS_REQUIRED: "Email is required",
    USER_SETTING_GET_STARTED_BY_ADDING_MESSAGE:
      "Get started by adding your first <span>cash out</span> method!",
    USER_SETTING_ADD_METHOD: "Add Method",
    USER_SETTING_SHOW_MY_FULL_NAME_IN_WAVES: "Show My Full Name In Waves",
    USER_SETTING_ALLOW_USERS_TO_SEE_MESSAGE:
      "Allow users to see my full name in Waves",
    USER_SETTING_ALLOW_OTHER_USERS_TO_MESSAGE_ME:
      "Allow Other Users To Message Me",
    USER_SETTING_COMING_SOON: "Coming soon",
    USER_SETTING_SUBSCRIBE_TO_KWIK_NEWSLETTER: "Subscribe to Kwik Newsletter",
    USER_SETTING_ALL_WE_DO_IS_LET_MESSAGE:
      "All we do is let you know when we make your life better!",
    USER_SETTING_SUBSCRIBE_TO_NEWSLETTERS:
      "Subscribe To Newsletters From Vendors I Have Purchased From",
    USER_SETTING_AUTOMATICALLY_GET_MESSAGE:
      "Automatically get signed up for newsletters from the brands you bought from.",
    USER_SETTING_ALLOW_OTHER_USERS_MESSAGE:
      "Allow Other Users To See My Profile Photo In Their Waves",
    USER_SETTING_IF_ON_OTHERS_CAN_MESSAGE:
      "If on, others can see your profile photo in their waves.",
    USER_SETTING_DOWNLOAD_MY_DATA: "Download My Data",
    USER_SETTING_YOU_CAN_DOWNLOAD_MESSAGE:
      "You can download a copy of your data at any time",
    USER_SETTING_REQUEST_TO_DOWNLOAD_MU_DATA: "Request to Download My Data",
    USER_SETTING_DELETE_MY_DATA: "Delete My Data",
    USER_SETTING_YOU_CAN_DELETE_MESSAGE: "Delete the data stored in my account",
    USER_SETTING_NOTIFICATION_SETTINGS: "Notification Settings",
    USER_SETTING_NOTIFY_ME_ON: "Notify Me On",
    USER_SETTING_FINANCE: "Finance",
    USER_SETTING_CASHOUT_ALERTS: "Cashout Alerts",
    USER_SETTING_NOTIFY_ME_ON_EVERY_CASHOUT: "Notify me on every cash out",
    USER_SETTING_NEW_BANK_ACCOUNT_ADDED: "New Bank Account Added",
    USER_SETTING_NOTIFY_ME_WHEN_A_NEW_BANK_ACCOUNT_IS_ADDED:
      "Notify me when a new bank account is added",
    USER_SETTING_KWIKCASH_CLEARS: "1Cash Clears",
    USER_SETTING_WAVES: "Waves",
    USER_SETTING_WHEN_SOMEONE_JOINS_MY_WAVES: "When Someone Joins my Waves",
    USER_SETTING_NOTIFY_ME_EVERY_TIME_SOMEONE_JOINS_MY_WAVES:
      "Notify me every time someone joins my waves",
    USER_SETTING_MARKETING: "Marketing",
    USER_SETTING_SIGN_ME_UP_FOR_KWIK_NEWSLETTER:
      "Sign me up for Kwik Newsletter",
    USER_SETTING_GET_UPDATES_ON_THE_RELEASES_MESSAGE:
      "Get updates on the releases, and get important updates that might impact your account",
    USER_SETTING_ALLOW_BRANDS_MESSAGE:
      "Allow Brands to Send Me Their Newsletter",
    USER_SETTING_ALLOW_THE_BRANDS_OF_THE_MESSAGE:
      "Allow the brands of the campaigns I am in to send me newsletters by default",
    USER_SETTING_SHOPPING: "Shopping",
    USER_SETTING_NEW_BRANDS_ON_KWIK: "New Brands on Kwik",
    USER_SETTING_TRENDING_DEALS: "Trending Deals",
    USER_SETTING_SETTINGS: "Settings",
    USER_SETTING_ANY_SETTINGS_CHANGES_ARE_MADE: "Any settings changes are made",
    USER_SETTING_NOTIFY_ME_WHEN_ANY_SETTINGS_ARE_CHANGED:
      "Notify me when any settings are changed",
    USER_SETTING_LANGUAGE_CHANGED: "Language Changed",
    USER_SETTING_NOTIFY_ME_WHEN_THE_LANGUAGE_CHANGES:
      "Notify me when the language changes",
    USER_REGISTER_LEGAL_NAME: "Legal Name",
    USER_REGISTER_PLEASE_INPUT_YOUR_ADDRESS_LEGAL_NAME:
      "Please input your Address Legal Name",
    BRAND: "Brand",
  },
};
